import { jsx as y, jsxs as U, Fragment as ms } from "react/jsx-runtime";
import * as x from "react";
import L, { createContext as Ur, useContext as Mr, useCallback as bs, useState as Ce, useRef as Br, useEffect as Ke, useMemo as Hr, createElement as vs, forwardRef as fn } from "react";
import "react-dom";
import { l as jn, c as ys, n as Wr, s as ws } from "./stay-request-DjxIZ5y-.js";
import { f as vm, i as ym, h as wm, a as km, g as $m, b as xm, e as zm, d as Sm, j as Nm, k as Em, m as Cm, p as Om, u as Rm } from "./stay-request-DjxIZ5y-.js";
var dt = (e) => e.type === "checkbox", De = (e) => e instanceof Date, ce = (e) => e == null;
const Kr = (e) => typeof e == "object";
var te = (e) => !ce(e) && !Array.isArray(e) && Kr(e) && !De(e), qr = (e) => te(e) && e.target ? dt(e.target) ? e.target.checked : e.target.value : e, ks = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Gr = (e, t) => e.has(ks(t)), $s = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return te(t) && t.hasOwnProperty("isPrototypeOf");
}, pn = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function ae(e) {
  let t;
  const n = Array.isArray(e), r = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(pn && (e instanceof Blob || r)) && (n || te(e)))
    if (t = n ? [] : {}, !n && !$s(e))
      t = e;
    else
      for (const o in e)
        e.hasOwnProperty(o) && (t[o] = ae(e[o]));
  else
    return e;
  return t;
}
var It = (e) => /^\w*$/.test(e), ee = (e) => e === void 0, _n = (e) => Array.isArray(e) ? e.filter(Boolean) : [], hn = (e) => _n(e.replace(/["|']|\]/g, "").split(/\.|\[/)), S = (e, t, n) => {
  if (!t || !te(e))
    return n;
  const r = (It(t) ? [t] : hn(t)).reduce((o, s) => ce(o) ? o : o[s], e);
  return ee(r) || r === e ? ee(e[t]) ? n : e[t] : r;
}, pe = (e) => typeof e == "boolean", Z = (e, t, n) => {
  let r = -1;
  const o = It(t) ? [t] : hn(t), s = o.length, a = s - 1;
  for (; ++r < s; ) {
    const i = o[r];
    let l = n;
    if (r !== a) {
      const c = e[i];
      l = te(c) || Array.isArray(c) ? c : isNaN(+o[r + 1]) ? {} : [];
    }
    if (i === "__proto__" || i === "constructor" || i === "prototype")
      return;
    e[i] = l, e = e[i];
  }
};
const zt = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, ve = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ze = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Yr = L.createContext(null);
Yr.displayName = "HookFormContext";
const gn = () => L.useContext(Yr);
var Jr = (e, t, n, r = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const s in e)
    Object.defineProperty(o, s, {
      get: () => {
        const a = s;
        return t._proxyFormState[a] !== ve.all && (t._proxyFormState[a] = !r || ve.all), n && (n[a] = !0), e[a];
      }
    });
  return o;
};
const mn = typeof window < "u" ? x.useLayoutEffect : x.useEffect;
function xs(e) {
  const t = gn(), { control: n = t.control, disabled: r, name: o, exact: s } = e || {}, [a, i] = L.useState(n._formState), l = L.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return mn(() => n._subscribe({
    name: o,
    formState: l.current,
    exact: s,
    callback: (c) => {
      !r && i({
        ...n._formState,
        ...c
      });
    }
  }), [o, r, s]), L.useEffect(() => {
    l.current.isValid && n._setValid(!0);
  }, [n]), L.useMemo(() => Jr(a, n, l.current, !1), [a, n]);
}
var we = (e) => typeof e == "string", Qr = (e, t, n, r, o) => we(e) ? (r && t.watch.add(e), S(n, e, o)) : Array.isArray(e) ? e.map((s) => (r && t.watch.add(s), S(n, s))) : (r && (t.watchAll = !0), n);
function zs(e) {
  const t = gn(), { control: n = t.control, name: r, defaultValue: o, disabled: s, exact: a } = e || {}, i = L.useRef(o), [l, c] = L.useState(n._getWatch(r, i.current));
  return mn(() => n._subscribe({
    name: r,
    formState: {
      values: !0
    },
    exact: a,
    callback: (f) => !s && c(Qr(r, n._names, f.values || n._formValues, !1, i.current))
  }), [r, n, s, a]), L.useEffect(() => n._removeUnmounted()), l;
}
function Ss(e) {
  const t = gn(), { name: n, disabled: r, control: o = t.control, shouldUnregister: s } = e, a = Gr(o._names.array, n), i = zs({
    control: o,
    name: n,
    defaultValue: S(o._formValues, n, S(o._defaultValues, n, e.defaultValue)),
    exact: !0
  }), l = xs({
    control: o,
    name: n,
    exact: !0
  }), c = L.useRef(e), f = L.useRef(o.register(n, {
    ...e.rules,
    value: i,
    ...pe(e.disabled) ? { disabled: e.disabled } : {}
  })), u = L.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!S(l.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!S(l.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!S(l.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!S(l.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => S(l.errors, n)
    }
  }), [l, n]), p = L.useCallback((k) => f.current.onChange({
    target: {
      value: qr(k),
      name: n
    },
    type: zt.CHANGE
  }), [n]), h = L.useCallback(() => f.current.onBlur({
    target: {
      value: S(o._formValues, n),
      name: n
    },
    type: zt.BLUR
  }), [n, o._formValues]), m = L.useCallback((k) => {
    const O = S(o._fields, n);
    O && k && (O._f.ref = {
      focus: () => k.focus && k.focus(),
      select: () => k.select && k.select(),
      setCustomValidity: (v) => k.setCustomValidity(v),
      reportValidity: () => k.reportValidity()
    });
  }, [o._fields, n]), w = L.useMemo(() => ({
    name: n,
    value: i,
    ...pe(r) || l.disabled ? { disabled: l.disabled || r } : {},
    onChange: p,
    onBlur: h,
    ref: m
  }), [n, r, l.disabled, p, h, m, i]);
  return L.useEffect(() => {
    const k = o._options.shouldUnregister || s;
    o.register(n, {
      ...c.current.rules,
      ...pe(c.current.disabled) ? { disabled: c.current.disabled } : {}
    });
    const O = (v, C) => {
      const N = S(o._fields, v);
      N && N._f && (N._f.mount = C);
    };
    if (O(n, !0), k) {
      const v = ae(S(o._options.defaultValues, n));
      Z(o._defaultValues, n, v), ee(S(o._formValues, n)) && Z(o._formValues, n, v);
    }
    return !a && o.register(n), () => {
      (a ? k && !o._state.action : k) ? o.unregister(n) : O(n, !1);
    };
  }, [n, o, a, s]), L.useEffect(() => {
    o._setDisabledField({
      disabled: r,
      name: n
    });
  }, [r, n, o]), L.useMemo(() => ({
    field: w,
    formState: l,
    fieldState: u
  }), [w, l, u]);
}
const Vn = (e) => e.render(Ss(e));
var bn = (e, t, n, r, o) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: o || !0
  }
} : {}, tt = (e) => Array.isArray(e) ? e : [e], Zn = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (o) => {
      for (const s of e)
        s.next && s.next(o);
    },
    subscribe: (o) => (e.push(o), {
      unsubscribe: () => {
        e = e.filter((s) => s !== o);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Qt = (e) => ce(e) || !Kr(e);
function Pe(e, t) {
  if (Qt(e) || Qt(t))
    return e === t;
  if (De(e) && De(t))
    return e.getTime() === t.getTime();
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (const o of n) {
    const s = e[o];
    if (!r.includes(o))
      return !1;
    if (o !== "ref") {
      const a = t[o];
      if (De(s) && De(a) || te(s) && te(a) || Array.isArray(s) && Array.isArray(a) ? !Pe(s, a) : s !== a)
        return !1;
    }
  }
  return !0;
}
var de = (e) => te(e) && !Object.keys(e).length, vn = (e) => e.type === "file", ye = (e) => typeof e == "function", St = (e) => {
  if (!pn)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, Xr = (e) => e.type === "select-multiple", yn = (e) => e.type === "radio", Ns = (e) => yn(e) || dt(e), qt = (e) => St(e) && e.isConnected;
function Es(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    e = ee(e) ? r++ : e[t[r++]];
  return e;
}
function Cs(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !ee(e[t]))
      return !1;
  return !0;
}
function oe(e, t) {
  const n = Array.isArray(t) ? t : It(t) ? [t] : hn(t), r = n.length === 1 ? e : Es(e, n), o = n.length - 1, s = n[o];
  return r && delete r[s], o !== 0 && (te(r) && de(r) || Array.isArray(r) && Cs(r)) && oe(e, n.slice(0, -1)), e;
}
var eo = (e) => {
  for (const t in e)
    if (ye(e[t]))
      return !0;
  return !1;
};
function Nt(e, t = {}) {
  const n = Array.isArray(e);
  if (te(e) || n)
    for (const r in e)
      Array.isArray(e[r]) || te(e[r]) && !eo(e[r]) ? (t[r] = Array.isArray(e[r]) ? [] : {}, Nt(e[r], t[r])) : ce(e[r]) || (t[r] = !0);
  return t;
}
function to(e, t, n) {
  const r = Array.isArray(e);
  if (te(e) || r)
    for (const o in e)
      Array.isArray(e[o]) || te(e[o]) && !eo(e[o]) ? ee(t) || Qt(n[o]) ? n[o] = Array.isArray(e[o]) ? Nt(e[o], []) : { ...Nt(e[o]) } : to(e[o], ce(t) ? {} : t[o], n[o]) : n[o] = !Pe(e[o], t[o]);
  return n;
}
var Je = (e, t) => to(e, t, Nt(t));
const Un = {
  value: !1,
  isValid: !1
}, Mn = { value: !0, isValid: !0 };
var no = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ee(e[0].attributes.value) ? ee(e[0].value) || e[0].value === "" ? Mn : { value: e[0].value, isValid: !0 } : Mn
    ) : Un;
  }
  return Un;
}, ro = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => ee(e) ? e : t ? e === "" ? NaN : e && +e : n && we(e) ? new Date(e) : r ? r(e) : e;
const Bn = {
  isValid: !1,
  value: null
};
var oo = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, Bn) : Bn;
function Hn(e) {
  const t = e.ref;
  return vn(t) ? t.files : yn(t) ? oo(e.refs).value : Xr(t) ? [...t.selectedOptions].map(({ value: n }) => n) : dt(t) ? no(e.refs).value : ro(ee(t.value) ? e.ref.value : t.value, e);
}
var Os = (e, t, n, r) => {
  const o = {};
  for (const s of e) {
    const a = S(t, s);
    a && Z(o, s, a._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: o,
    shouldUseNativeValidation: r
  };
}, Et = (e) => e instanceof RegExp, Qe = (e) => ee(e) ? e : Et(e) ? e.source : te(e) ? Et(e.value) ? e.value.source : e.value : e, Wn = (e) => ({
  isOnSubmit: !e || e === ve.onSubmit,
  isOnBlur: e === ve.onBlur,
  isOnChange: e === ve.onChange,
  isOnAll: e === ve.all,
  isOnTouch: e === ve.onTouched
});
const Kn = "AsyncFunction";
var Rs = (e) => !!e && !!e.validate && !!(ye(e.validate) && e.validate.constructor.name === Kn || te(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === Kn)), As = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), qn = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const nt = (e, t, n, r) => {
  for (const o of n || Object.keys(e)) {
    const s = S(e, o);
    if (s) {
      const { _f: a, ...i } = s;
      if (a) {
        if (a.refs && a.refs[0] && t(a.refs[0], o) && !r)
          return !0;
        if (a.ref && t(a.ref, a.name) && !r)
          return !0;
        if (nt(i, t))
          break;
      } else if (te(i) && nt(i, t))
        break;
    }
  }
};
function Gn(e, t, n) {
  const r = S(e, n);
  if (r || It(n))
    return {
      error: r,
      name: n
    };
  const o = n.split(".");
  for (; o.length; ) {
    const s = o.join("."), a = S(t, s), i = S(e, s);
    if (a && !Array.isArray(a) && n !== s)
      return { name: n };
    if (i && i.type)
      return {
        name: s,
        error: i
      };
    if (i && i.root && i.root.type)
      return {
        name: `${s}.root`,
        error: i.root
      };
    o.pop();
  }
  return {
    name: n
  };
}
var Ps = (e, t, n, r) => {
  n(e);
  const { name: o, ...s } = e;
  return de(s) || Object.keys(s).length >= Object.keys(t).length || Object.keys(s).find((a) => t[a] === (!r || ve.all));
}, Ts = (e, t, n) => !e || !t || e === t || tt(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r))), Is = (e, t, n, r, o) => o.isOnAll ? !1 : !n && o.isOnTouch ? !(t || e) : (n ? r.isOnBlur : o.isOnBlur) ? !e : (n ? r.isOnChange : o.isOnChange) ? e : !0, Ds = (e, t) => !_n(S(e, t)).length && oe(e, t), Ls = (e, t, n) => {
  const r = tt(S(e, n));
  return Z(r, "root", t[n]), Z(e, n, r), e;
}, xt = (e) => we(e);
function Yn(e, t, n = "validate") {
  if (xt(e) || Array.isArray(e) && e.every(xt) || pe(e) && !e)
    return {
      type: n,
      message: xt(e) ? e : "",
      ref: t
    };
}
var Ue = (e) => te(e) && !Et(e) ? e : {
  value: e,
  message: ""
}, Jn = async (e, t, n, r, o, s) => {
  const { ref: a, refs: i, required: l, maxLength: c, minLength: f, min: u, max: p, pattern: h, validate: m, name: w, valueAsNumber: k, mount: O } = e._f, v = S(n, w);
  if (!O || t.has(w))
    return {};
  const C = i ? i[0] : a, N = (D) => {
    o && C.reportValidity && (C.setCustomValidity(pe(D) ? "" : D || ""), C.reportValidity());
  }, A = {}, j = yn(a), V = dt(a), G = j || V, J = (k || vn(a)) && ee(a.value) && ee(v) || St(a) && a.value === "" || v === "" || Array.isArray(v) && !v.length, X = bn.bind(null, w, r, A), ie = (D, I, F, B = ze.maxLength, W = ze.minLength) => {
    const ne = D ? I : F;
    A[w] = {
      type: D ? B : W,
      message: ne,
      ref: a,
      ...X(D ? B : W, ne)
    };
  };
  if (s ? !Array.isArray(v) || !v.length : l && (!G && (J || ce(v)) || pe(v) && !v || V && !no(i).isValid || j && !oo(i).isValid)) {
    const { value: D, message: I } = xt(l) ? { value: !!l, message: l } : Ue(l);
    if (D && (A[w] = {
      type: ze.required,
      message: I,
      ref: C,
      ...X(ze.required, I)
    }, !r))
      return N(I), A;
  }
  if (!J && (!ce(u) || !ce(p))) {
    let D, I;
    const F = Ue(p), B = Ue(u);
    if (!ce(v) && !isNaN(v)) {
      const W = a.valueAsNumber || v && +v;
      ce(F.value) || (D = W > F.value), ce(B.value) || (I = W < B.value);
    } else {
      const W = a.valueAsDate || new Date(v), ne = (Te) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Te), ge = a.type == "time", me = a.type == "week";
      we(F.value) && v && (D = ge ? ne(v) > ne(F.value) : me ? v > F.value : W > new Date(F.value)), we(B.value) && v && (I = ge ? ne(v) < ne(B.value) : me ? v < B.value : W < new Date(B.value));
    }
    if ((D || I) && (ie(!!D, F.message, B.message, ze.max, ze.min), !r))
      return N(A[w].message), A;
  }
  if ((c || f) && !J && (we(v) || s && Array.isArray(v))) {
    const D = Ue(c), I = Ue(f), F = !ce(D.value) && v.length > +D.value, B = !ce(I.value) && v.length < +I.value;
    if ((F || B) && (ie(F, D.message, I.message), !r))
      return N(A[w].message), A;
  }
  if (h && !J && we(v)) {
    const { value: D, message: I } = Ue(h);
    if (Et(D) && !v.match(D) && (A[w] = {
      type: ze.pattern,
      message: I,
      ref: a,
      ...X(ze.pattern, I)
    }, !r))
      return N(I), A;
  }
  if (m) {
    if (ye(m)) {
      const D = await m(v, n), I = Yn(D, C);
      if (I && (A[w] = {
        ...I,
        ...X(ze.validate, I.message)
      }, !r))
        return N(I.message), A;
    } else if (te(m)) {
      let D = {};
      for (const I in m) {
        if (!de(D) && !r)
          break;
        const F = Yn(await m[I](v, n), C, I);
        F && (D = {
          ...F,
          ...X(I, F.message)
        }, N(F.message), r && (A[w] = D));
      }
      if (!de(D) && (A[w] = {
        ref: C,
        ...D
      }, !r))
        return A;
    }
  }
  return N(!0), A;
};
const Fs = {
  mode: ve.onSubmit,
  reValidateMode: ve.onChange,
  shouldFocusError: !0
};
function js(e = {}) {
  let t = {
    ...Fs,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: ye(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  };
  const r = {};
  let o = te(t.defaultValues) || te(t.values) ? ae(t.defaultValues || t.values) || {} : {}, s = t.shouldUnregister ? {} : ae(o), a = {
    action: !1,
    mount: !1,
    watch: !1
  }, i = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, c = 0;
  const f = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let u = {
    ...f
  };
  const p = {
    array: Zn(),
    state: Zn()
  }, h = t.criteriaMode === ve.all, m = (d) => (_) => {
    clearTimeout(c), c = setTimeout(d, _);
  }, w = async (d) => {
    if (!t.disabled && (f.isValid || u.isValid || d)) {
      const _ = t.resolver ? de((await V()).errors) : await J(r, !0);
      _ !== n.isValid && p.state.next({
        isValid: _
      });
    }
  }, k = (d, _) => {
    !t.disabled && (f.isValidating || f.validatingFields || u.isValidating || u.validatingFields) && ((d || Array.from(i.mount)).forEach((g) => {
      g && (_ ? Z(n.validatingFields, g, _) : oe(n.validatingFields, g));
    }), p.state.next({
      validatingFields: n.validatingFields,
      isValidating: !de(n.validatingFields)
    }));
  }, O = (d, _ = [], g, E, z = !0, $ = !0) => {
    if (E && g && !t.disabled) {
      if (a.action = !0, $ && Array.isArray(S(r, d))) {
        const R = g(S(r, d), E.argA, E.argB);
        z && Z(r, d, R);
      }
      if ($ && Array.isArray(S(n.errors, d))) {
        const R = g(S(n.errors, d), E.argA, E.argB);
        z && Z(n.errors, d, R), Ds(n.errors, d);
      }
      if ((f.touchedFields || u.touchedFields) && $ && Array.isArray(S(n.touchedFields, d))) {
        const R = g(S(n.touchedFields, d), E.argA, E.argB);
        z && Z(n.touchedFields, d, R);
      }
      (f.dirtyFields || u.dirtyFields) && (n.dirtyFields = Je(o, s)), p.state.next({
        name: d,
        isDirty: ie(d, _),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      Z(s, d, _);
  }, v = (d, _) => {
    Z(n.errors, d, _), p.state.next({
      errors: n.errors
    });
  }, C = (d) => {
    n.errors = d, p.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, N = (d, _, g, E) => {
    const z = S(r, d);
    if (z) {
      const $ = S(s, d, ee(g) ? S(o, d) : g);
      ee($) || E && E.defaultChecked || _ ? Z(s, d, _ ? $ : Hn(z._f)) : F(d, $), a.mount && w();
    }
  }, A = (d, _, g, E, z) => {
    let $ = !1, R = !1;
    const M = {
      name: d
    };
    if (!t.disabled) {
      if (!g || E) {
        (f.isDirty || u.isDirty) && (R = n.isDirty, n.isDirty = M.isDirty = ie(), $ = R !== M.isDirty);
        const H = Pe(S(o, d), _);
        R = !!S(n.dirtyFields, d), H ? oe(n.dirtyFields, d) : Z(n.dirtyFields, d, !0), M.dirtyFields = n.dirtyFields, $ = $ || (f.dirtyFields || u.dirtyFields) && R !== !H;
      }
      if (g) {
        const H = S(n.touchedFields, d);
        H || (Z(n.touchedFields, d, g), M.touchedFields = n.touchedFields, $ = $ || (f.touchedFields || u.touchedFields) && H !== g);
      }
      $ && z && p.state.next(M);
    }
    return $ ? M : {};
  }, j = (d, _, g, E) => {
    const z = S(n.errors, d), $ = (f.isValid || u.isValid) && pe(_) && n.isValid !== _;
    if (t.delayError && g ? (l = m(() => v(d, g)), l(t.delayError)) : (clearTimeout(c), l = null, g ? Z(n.errors, d, g) : oe(n.errors, d)), (g ? !Pe(z, g) : z) || !de(E) || $) {
      const R = {
        ...E,
        ...$ && pe(_) ? { isValid: _ } : {},
        errors: n.errors,
        name: d
      };
      n = {
        ...n,
        ...R
      }, p.state.next(R);
    }
  }, V = async (d) => {
    k(d, !0);
    const _ = await t.resolver(s, t.context, Os(d || i.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
    return k(d), _;
  }, G = async (d) => {
    const { errors: _ } = await V(d);
    if (d)
      for (const g of d) {
        const E = S(_, g);
        E ? Z(n.errors, g, E) : oe(n.errors, g);
      }
    else
      n.errors = _;
    return _;
  }, J = async (d, _, g = {
    valid: !0
  }) => {
    for (const E in d) {
      const z = d[E];
      if (z) {
        const { _f: $, ...R } = z;
        if ($) {
          const M = i.array.has($.name), H = z._f && Rs(z._f);
          H && f.validatingFields && k([E], !0);
          const _e = await Jn(z, i.disabled, s, h, t.shouldUseNativeValidation && !_, M);
          if (H && f.validatingFields && k([E]), _e[$.name] && (g.valid = !1, _))
            break;
          !_ && (S(_e, $.name) ? M ? Ls(n.errors, _e, $.name) : Z(n.errors, $.name, _e[$.name]) : oe(n.errors, $.name));
        }
        !de(R) && await J(R, _, g);
      }
    }
    return g.valid;
  }, X = () => {
    for (const d of i.unMount) {
      const _ = S(r, d);
      _ && (_._f.refs ? _._f.refs.every((g) => !qt(g)) : !qt(_._f.ref)) && Mt(d);
    }
    i.unMount = /* @__PURE__ */ new Set();
  }, ie = (d, _) => !t.disabled && (d && _ && Z(s, d, _), !Pe(Te(), o)), D = (d, _, g) => Qr(d, i, {
    ...a.mount ? s : ee(_) ? o : we(d) ? { [d]: _ } : _
  }, g, _), I = (d) => _n(S(a.mount ? s : o, d, t.shouldUnregister ? S(o, d, []) : [])), F = (d, _, g = {}) => {
    const E = S(r, d);
    let z = _;
    if (E) {
      const $ = E._f;
      $ && (!$.disabled && Z(s, d, ro(_, $)), z = St($.ref) && ce(_) ? "" : _, Xr($.ref) ? [...$.ref.options].forEach((R) => R.selected = z.includes(R.value)) : $.refs ? dt($.ref) ? $.refs.forEach((R) => {
        (!R.defaultChecked || !R.disabled) && (Array.isArray(z) ? R.checked = !!z.find((M) => M === R.value) : R.checked = z === R.value || !!z);
      }) : $.refs.forEach((R) => R.checked = R.value === z) : vn($.ref) ? $.ref.value = "" : ($.ref.value = z, $.ref.type || p.state.next({
        name: d,
        values: ae(s)
      })));
    }
    (g.shouldDirty || g.shouldTouch) && A(d, z, g.shouldTouch, g.shouldDirty, !0), g.shouldValidate && me(d);
  }, B = (d, _, g) => {
    for (const E in _) {
      if (!_.hasOwnProperty(E))
        return;
      const z = _[E], $ = d + "." + E, R = S(r, $);
      (i.array.has(d) || te(z) || R && !R._f) && !De(z) ? B($, z, g) : F($, z, g);
    }
  }, W = (d, _, g = {}) => {
    const E = S(r, d), z = i.array.has(d), $ = ae(_);
    Z(s, d, $), z ? (p.array.next({
      name: d,
      values: ae(s)
    }), (f.isDirty || f.dirtyFields || u.isDirty || u.dirtyFields) && g.shouldDirty && p.state.next({
      name: d,
      dirtyFields: Je(o, s),
      isDirty: ie(d, $)
    })) : E && !E._f && !ce($) ? B(d, $, g) : F(d, $, g), qn(d, i) && p.state.next({ ...n }), p.state.next({
      name: a.mount ? d : void 0,
      values: ae(s)
    });
  }, ne = async (d) => {
    a.mount = !0;
    const _ = d.target;
    let g = _.name, E = !0;
    const z = S(r, g), $ = (H) => {
      E = Number.isNaN(H) || De(H) && isNaN(H.getTime()) || Pe(H, S(s, g, H));
    }, R = Wn(t.mode), M = Wn(t.reValidateMode);
    if (z) {
      let H, _e;
      const ht = _.type ? Hn(z._f) : qr(d), Ae = d.type === zt.BLUR || d.type === zt.FOCUS_OUT, _s = !As(z._f) && !t.resolver && !S(n.errors, g) && !z._f.deps || Is(Ae, S(n.touchedFields, g), n.isSubmitted, M, R), Wt = qn(g, i, Ae);
      Z(s, g, ht), Ae ? (z._f.onBlur && z._f.onBlur(d), l && l(0)) : z._f.onChange && z._f.onChange(d);
      const Kt = A(g, ht, Ae), hs = !de(Kt) || Wt;
      if (!Ae && p.state.next({
        name: g,
        type: d.type,
        values: ae(s)
      }), _s)
        return (f.isValid || u.isValid) && (t.mode === "onBlur" ? Ae && w() : Ae || w()), hs && p.state.next({ name: g, ...Wt ? {} : Kt });
      if (!Ae && Wt && p.state.next({ ...n }), t.resolver) {
        const { errors: Ln } = await V([g]);
        if ($(ht), E) {
          const gs = Gn(n.errors, r, g), Fn = Gn(Ln, r, gs.name || g);
          H = Fn.error, g = Fn.name, _e = de(Ln);
        }
      } else
        k([g], !0), H = (await Jn(z, i.disabled, s, h, t.shouldUseNativeValidation))[g], k([g]), $(ht), E && (H ? _e = !1 : (f.isValid || u.isValid) && (_e = await J(r, !0)));
      E && (z._f.deps && me(z._f.deps), j(g, _e, H, Kt));
    }
  }, ge = (d, _) => {
    if (S(n.errors, _) && d.focus)
      return d.focus(), 1;
  }, me = async (d, _ = {}) => {
    let g, E;
    const z = tt(d);
    if (t.resolver) {
      const $ = await G(ee(d) ? d : z);
      g = de($), E = d ? !z.some((R) => S($, R)) : g;
    } else d ? (E = (await Promise.all(z.map(async ($) => {
      const R = S(r, $);
      return await J(R && R._f ? { [$]: R } : R);
    }))).every(Boolean), !(!E && !n.isValid) && w()) : E = g = await J(r);
    return p.state.next({
      ...!we(d) || (f.isValid || u.isValid) && g !== n.isValid ? {} : { name: d },
      ...t.resolver || !d ? { isValid: g } : {},
      errors: n.errors
    }), _.shouldFocus && !E && nt(r, ge, d ? z : i.mount), E;
  }, Te = (d) => {
    const _ = {
      ...a.mount ? s : o
    };
    return ee(d) ? _ : we(d) ? S(_, d) : d.map((g) => S(_, g));
  }, le = (d, _) => ({
    invalid: !!S((_ || n).errors, d),
    isDirty: !!S((_ || n).dirtyFields, d),
    error: S((_ || n).errors, d),
    isValidating: !!S(n.validatingFields, d),
    isTouched: !!S((_ || n).touchedFields, d)
  }), xe = (d) => {
    d && tt(d).forEach((_) => oe(n.errors, _)), p.state.next({
      errors: d ? n.errors : {}
    });
  }, Re = (d, _, g) => {
    const E = (S(r, d, { _f: {} })._f || {}).ref, z = S(n.errors, d) || {}, { ref: $, message: R, type: M, ...H } = z;
    Z(n.errors, d, {
      ...H,
      ..._,
      ref: E
    }), p.state.next({
      name: d,
      errors: n.errors,
      isValid: !1
    }), g && g.shouldFocus && E && E.focus && E.focus();
  }, _t = (d, _) => ye(d) ? p.state.subscribe({
    next: (g) => d(D(void 0, _), g)
  }) : D(d, _, !0), Rn = (d) => p.state.subscribe({
    next: (_) => {
      Ts(d.name, _.name, d.exact) && Ps(_, d.formState || f, ps, d.reRenderRoot) && d.callback({
        values: { ...s },
        ...n,
        ..._
      });
    }
  }).unsubscribe, cs = (d) => (a.mount = !0, u = {
    ...u,
    ...d.formState
  }, Rn({
    ...d,
    formState: u
  })), Mt = (d, _ = {}) => {
    for (const g of d ? tt(d) : i.mount)
      i.mount.delete(g), i.array.delete(g), _.keepValue || (oe(r, g), oe(s, g)), !_.keepError && oe(n.errors, g), !_.keepDirty && oe(n.dirtyFields, g), !_.keepTouched && oe(n.touchedFields, g), !_.keepIsValidating && oe(n.validatingFields, g), !t.shouldUnregister && !_.keepDefaultValue && oe(o, g);
    p.state.next({
      values: ae(s)
    }), p.state.next({
      ...n,
      ..._.keepDirty ? { isDirty: ie() } : {}
    }), !_.keepIsValid && w();
  }, An = ({ disabled: d, name: _ }) => {
    (pe(d) && a.mount || d || i.disabled.has(_)) && (d ? i.disabled.add(_) : i.disabled.delete(_));
  }, Bt = (d, _ = {}) => {
    let g = S(r, d);
    const E = pe(_.disabled) || pe(t.disabled);
    return Z(r, d, {
      ...g || {},
      _f: {
        ...g && g._f ? g._f : { ref: { name: d } },
        name: d,
        mount: !0,
        ..._
      }
    }), i.mount.add(d), g ? An({
      disabled: pe(_.disabled) ? _.disabled : t.disabled,
      name: d
    }) : N(d, !0, _.value), {
      ...E ? { disabled: _.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!_.required,
        min: Qe(_.min),
        max: Qe(_.max),
        minLength: Qe(_.minLength),
        maxLength: Qe(_.maxLength),
        pattern: Qe(_.pattern)
      } : {},
      name: d,
      onChange: ne,
      onBlur: ne,
      ref: (z) => {
        if (z) {
          Bt(d, _), g = S(r, d);
          const $ = ee(z.value) && z.querySelectorAll && z.querySelectorAll("input,select,textarea")[0] || z, R = Ns($), M = g._f.refs || [];
          if (R ? M.find((H) => H === $) : $ === g._f.ref)
            return;
          Z(r, d, {
            _f: {
              ...g._f,
              ...R ? {
                refs: [
                  ...M.filter(qt),
                  $,
                  ...Array.isArray(S(o, d)) ? [{}] : []
                ],
                ref: { type: $.type, name: d }
              } : { ref: $ }
            }
          }), N(d, !1, void 0, $);
        } else
          g = S(r, d, {}), g._f && (g._f.mount = !1), (t.shouldUnregister || _.shouldUnregister) && !(Gr(i.array, d) && a.action) && i.unMount.add(d);
      }
    };
  }, Ht = () => t.shouldFocusError && nt(r, ge, i.mount), us = (d) => {
    pe(d) && (p.state.next({ disabled: d }), nt(r, (_, g) => {
      const E = S(r, g);
      E && (_.disabled = E._f.disabled || d, Array.isArray(E._f.refs) && E._f.refs.forEach((z) => {
        z.disabled = E._f.disabled || d;
      }));
    }, 0, !1));
  }, Pn = (d, _) => async (g) => {
    let E;
    g && (g.preventDefault && g.preventDefault(), g.persist && g.persist());
    let z = ae(s);
    if (p.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: $, values: R } = await V();
      n.errors = $, z = R;
    } else
      await J(r);
    if (i.disabled.size)
      for (const $ of i.disabled)
        Z(z, $, void 0);
    if (oe(n.errors, "root"), de(n.errors)) {
      p.state.next({
        errors: {}
      });
      try {
        await d(z, g);
      } catch ($) {
        E = $;
      }
    } else
      _ && await _({ ...n.errors }, g), Ht(), setTimeout(Ht);
    if (p.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: de(n.errors) && !E,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), E)
      throw E;
  }, ds = (d, _ = {}) => {
    S(r, d) && (ee(_.defaultValue) ? W(d, ae(S(o, d))) : (W(d, _.defaultValue), Z(o, d, ae(_.defaultValue))), _.keepTouched || oe(n.touchedFields, d), _.keepDirty || (oe(n.dirtyFields, d), n.isDirty = _.defaultValue ? ie(d, ae(S(o, d))) : ie()), _.keepError || (oe(n.errors, d), f.isValid && w()), p.state.next({ ...n }));
  }, Tn = (d, _ = {}) => {
    const g = d ? ae(d) : o, E = ae(g), z = de(d), $ = z ? o : E;
    if (_.keepDefaultValues || (o = g), !_.keepValues) {
      if (_.keepDirtyValues) {
        const R = /* @__PURE__ */ new Set([
          ...i.mount,
          ...Object.keys(Je(o, s))
        ]);
        for (const M of Array.from(R))
          S(n.dirtyFields, M) ? Z($, M, S(s, M)) : W(M, S($, M));
      } else {
        if (pn && ee(d))
          for (const R of i.mount) {
            const M = S(r, R);
            if (M && M._f) {
              const H = Array.isArray(M._f.refs) ? M._f.refs[0] : M._f.ref;
              if (St(H)) {
                const _e = H.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const R of i.mount)
          W(R, S($, R));
      }
      s = ae($), p.array.next({
        values: { ...$ }
      }), p.state.next({
        values: { ...$ }
      });
    }
    i = {
      mount: _.keepDirtyValues ? i.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !f.isValid || !!_.keepIsValid || !!_.keepDirtyValues, a.watch = !!t.shouldUnregister, p.state.next({
      submitCount: _.keepSubmitCount ? n.submitCount : 0,
      isDirty: z ? !1 : _.keepDirty ? n.isDirty : !!(_.keepDefaultValues && !Pe(d, o)),
      isSubmitted: _.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: z ? {} : _.keepDirtyValues ? _.keepDefaultValues && s ? Je(o, s) : n.dirtyFields : _.keepDefaultValues && d ? Je(o, d) : _.keepDirty ? n.dirtyFields : {},
      touchedFields: _.keepTouched ? n.touchedFields : {},
      errors: _.keepErrors ? n.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, In = (d, _) => Tn(ye(d) ? d(s) : d, _), fs = (d, _ = {}) => {
    const g = S(r, d), E = g && g._f;
    if (E) {
      const z = E.refs ? E.refs[0] : E.ref;
      z.focus && (z.focus(), _.shouldSelect && ye(z.select) && z.select());
    }
  }, ps = (d) => {
    n = {
      ...n,
      ...d
    };
  }, Dn = {
    control: {
      register: Bt,
      unregister: Mt,
      getFieldState: le,
      handleSubmit: Pn,
      setError: Re,
      _subscribe: Rn,
      _runSchema: V,
      _focusError: Ht,
      _getWatch: D,
      _getDirty: ie,
      _setValid: w,
      _setFieldArray: O,
      _setDisabledField: An,
      _setErrors: C,
      _getFieldArray: I,
      _reset: Tn,
      _resetDefaultValues: () => ye(t.defaultValues) && t.defaultValues().then((d) => {
        In(d, t.resetOptions), p.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: X,
      _disableForm: us,
      _subjects: p,
      _proxyFormState: f,
      get _fields() {
        return r;
      },
      get _formValues() {
        return s;
      },
      get _state() {
        return a;
      },
      set _state(d) {
        a = d;
      },
      get _defaultValues() {
        return o;
      },
      get _names() {
        return i;
      },
      set _names(d) {
        i = d;
      },
      get _formState() {
        return n;
      },
      get _options() {
        return t;
      },
      set _options(d) {
        t = {
          ...t,
          ...d
        };
      }
    },
    subscribe: cs,
    trigger: me,
    register: Bt,
    handleSubmit: Pn,
    watch: _t,
    setValue: W,
    getValues: Te,
    reset: In,
    resetField: ds,
    clearErrors: xe,
    unregister: Mt,
    setError: Re,
    setFocus: fs,
    getFieldState: le
  };
  return {
    ...Dn,
    formControl: Dn
  };
}
function Vs(e = {}) {
  const t = L.useRef(void 0), n = L.useRef(void 0), [r, o] = L.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: ye(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    isReady: !1,
    defaultValues: ye(e.defaultValues) ? void 0 : e.defaultValues
  });
  if (!t.current)
    if (e.formControl)
      t.current = {
        ...e.formControl,
        formState: r
      }, e.defaultValues && !ye(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
    else {
      const { formControl: a, ...i } = js(e);
      t.current = {
        ...i,
        formState: r
      };
    }
  const s = t.current.control;
  return s._options = e, mn(() => {
    const a = s._subscribe({
      formState: s._proxyFormState,
      callback: () => o({ ...s._formState }),
      reRenderRoot: !0
    });
    return o((i) => ({
      ...i,
      isReady: !0
    })), s._formState.isReady = !0, a;
  }, [s]), L.useEffect(() => s._disableForm(e.disabled), [s, e.disabled]), L.useEffect(() => {
    e.mode && (s._options.mode = e.mode), e.reValidateMode && (s._options.reValidateMode = e.reValidateMode);
  }, [s, e.mode, e.reValidateMode]), L.useEffect(() => {
    e.errors && (s._setErrors(e.errors), s._focusError());
  }, [s, e.errors]), L.useEffect(() => {
    e.shouldUnregister && s._subjects.state.next({
      values: s._getWatch()
    });
  }, [s, e.shouldUnregister]), L.useEffect(() => {
    if (s._proxyFormState.isDirty) {
      const a = s._getDirty();
      a !== r.isDirty && s._subjects.state.next({
        isDirty: a
      });
    }
  }, [s, r.isDirty]), L.useEffect(() => {
    e.values && !Pe(e.values, n.current) ? (s._reset(e.values, s._options.resetOptions), n.current = e.values, o((a) => ({ ...a }))) : s._resetDefaultValues();
  }, [s, e.values]), L.useEffect(() => {
    s._state.mount || (s._setValid(), s._state.mount = !0), s._state.watch && (s._state.watch = !1, s._subjects.state.next({ ...s._formState })), s._removeUnmounted();
  }), t.current.formState = Jr(r, s), t.current;
}
const Zs = (e, t, n, r) => {
  const o = [n, {
    code: t,
    ...r || {}
  }];
  if (e?.services?.logger?.forward)
    return e.services.logger.forward(o, "warn", "react-i18next::", !0);
  Le(o[0]) && (o[0] = `react-i18next:: ${o[0]}`), e?.services?.logger?.warn ? e.services.logger.warn(...o) : console?.warn && console.warn(...o);
}, Qn = {}, Xt = (e, t, n, r) => {
  Le(n) && Qn[n] || (Le(n) && (Qn[n] = /* @__PURE__ */ new Date()), Zs(e, t, n, r));
}, so = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const n = () => {
      setTimeout(() => {
        e.off("initialized", n);
      }, 0), t();
    };
    e.on("initialized", n);
  }
}, en = (e, t, n) => {
  e.loadNamespaces(t, so(e, n));
}, Xn = (e, t, n, r) => {
  if (Le(n) && (n = [n]), e.options.preload && e.options.preload.indexOf(t) > -1) return en(e, n, r);
  n.forEach((o) => {
    e.options.ns.indexOf(o) < 0 && e.options.ns.push(o);
  }), e.loadLanguages(t, so(e, r));
}, Us = (e, t, n = {}) => !t.languages || !t.languages.length ? (Xt(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: n.lng,
  precheck: (r, o) => {
    if (n.bindI18n?.indexOf("languageChanging") > -1 && r.services.backendConnector.backend && r.isLanguageChangingTo && !o(r.isLanguageChangingTo, e)) return !1;
  }
}), Le = (e) => typeof e == "string", Ms = (e) => typeof e == "object" && e !== null, Bs = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Hs = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Ws = (e) => Hs[e], Ks = (e) => e.replace(Bs, Ws);
let qs = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Ks
};
const Gs = () => qs;
let Ys;
const Js = () => Ys, ao = Ur();
class Qs {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Xs = (e, t) => {
  const n = Br();
  return Ke(() => {
    n.current = e;
  }, [e, t]), n.current;
}, io = (e, t, n, r) => e.getFixedT(t, n, r), ea = (e, t, n, r) => bs(io(e, t, n, r), [e, t, n, r]), wn = (e, t = {}) => {
  const {
    i18n: n
  } = t, {
    i18n: r,
    defaultNS: o
  } = Mr(ao) || {}, s = n || r || Js();
  if (s && !s.reportNamespaces && (s.reportNamespaces = new Qs()), !s) {
    Xt(s, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const N = (j, V) => Le(V) ? V : Ms(V) && Le(V.defaultValue) ? V.defaultValue : Array.isArray(j) ? j[j.length - 1] : j, A = [N, {}, !1];
    return A.t = N, A.i18n = {}, A.ready = !1, A;
  }
  s.options.react?.wait && Xt(s, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const a = {
    ...Gs(),
    ...s.options.react,
    ...t
  }, {
    useSuspense: i,
    keyPrefix: l
  } = a;
  let c = e || o || s.options?.defaultNS;
  c = Le(c) ? [c] : c || ["translation"], s.reportNamespaces.addUsedNamespaces?.(c);
  const f = (s.isInitialized || s.initializedStoreOnce) && c.every((N) => Us(N, s, a)), u = ea(s, t.lng || null, a.nsMode === "fallback" ? c : c[0], l), p = () => u, h = () => io(s, t.lng || null, a.nsMode === "fallback" ? c : c[0], l), [m, w] = Ce(p);
  let k = c.join();
  t.lng && (k = `${t.lng}${k}`);
  const O = Xs(k), v = Br(!0);
  Ke(() => {
    const {
      bindI18n: N,
      bindI18nStore: A
    } = a;
    v.current = !0, !f && !i && (t.lng ? Xn(s, t.lng, c, () => {
      v.current && w(h);
    }) : en(s, c, () => {
      v.current && w(h);
    })), f && O && O !== k && v.current && w(h);
    const j = () => {
      v.current && w(h);
    };
    return N && s?.on(N, j), A && s?.store.on(A, j), () => {
      v.current = !1, s && N?.split(" ").forEach((V) => s.off(V, j)), A && s && A.split(" ").forEach((V) => s.store.off(V, j));
    };
  }, [s, k]), Ke(() => {
    v.current && f && w(p);
  }, [s, l, f]);
  const C = [m, s, f];
  if (C.t = m, C.i18n = s, C.ready = f, f || !f && !i) return C;
  throw new Promise((N) => {
    t.lng ? Xn(s, t.lng, c, () => N()) : en(s, c, () => N());
  });
};
function ta({
  i18n: e,
  defaultNS: t,
  children: n
}) {
  const r = Hr(() => ({
    i18n: e,
    defaultNS: t
  }), [e, t]);
  return vs(ao.Provider, {
    value: r
  }, n);
}
function lo(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = lo(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Q() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = lo(e)) && (r && (r += " "), r += t);
  return r;
}
const na = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], ra = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, oa = na.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: ra[e]
})), sa = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, aa = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl"
};
function ia(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ y("span", { className: n }, n));
}
const qe = fn(
  ({ name: e, size: t = "medium", color: n = "base", className: r = "", ...o }, s) => {
    const a = oa.find((l) => l.name === e), i = Q("icon", `ds-${a?.class}`, aa[t], sa[n], r);
    return /* @__PURE__ */ y("i", { className: i, ...o, ref: s, children: ia(a?.paths) });
  }
);
qe.displayName = "Icon";
const la = "_loader_1ksyv_29", ca = "_circle_1ksyv_41", Me = {
  loader: la,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: ca,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, ua = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, da = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function fa({ onDark: e, size: t = "medium", color: n = "primary", className: r }) {
  return /* @__PURE__ */ U(
    "svg",
    {
      className: Q(
        Me.loader,
        Me[ua[t]],
        Me[da[n]],
        e && Me["on-dark"],
        r
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ y("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ y("circle", { className: Me.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ U(
          "circle",
          {
            className: Me["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ y("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ y(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const pa = "_button_z1os6_29", _a = "_disabled_z1os6_43", ha = "_loader_z1os6_263", Se = {
  button: pa,
  disabled: _a,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: ha,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, Ge = fn(
  ({
    text: e,
    color: t = "primary",
    size: n = "medium",
    isFullWidth: r = !1,
    icon: o,
    iconPosition: s = "left",
    isLoading: a = !1,
    iconSize: i = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: f,
    children: u,
    ...p
  }, h) => {
    const m = Q(
      Se.button,
      Se[ga[t]],
      Se[ma[n]],
      r && Se["is-full-width"],
      c && Se.disabled,
      s === "right" && Se["has-icon-right"],
      l && Se["is-contrasted"],
      a && Se["is-loading"],
      f
    ), w = /* @__PURE__ */ U(ms, { children: [
      a && /* @__PURE__ */ y(fa, { className: Se.loader, onDark: !0, size: "small" }),
      o && s === "left" && /* @__PURE__ */ y(qe, { color: "inherit", size: i, name: o }),
      u ?? e,
      o && s === "right" && /* @__PURE__ */ y(qe, { color: "inherit", size: i, name: o })
    ] });
    if (ba(p))
      return /* @__PURE__ */ y(
        "a",
        {
          ...p,
          href: c ? void 0 : p.href,
          className: m,
          target: p.target,
          ref: h,
          children: w
        }
      );
    if (va(p))
      return /* @__PURE__ */ y(
        "button",
        {
          disabled: a || c,
          ...p,
          className: m,
          ref: h,
          children: w
        }
      );
  }
);
Ge.displayName = "Button";
const ga = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, ma = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function ba(e) {
  return "href" in e && typeof e.href == "string";
}
function va(e) {
  return !("href" in e);
}
const ya = "_buttons_1obz3_29", er = {
  buttons: ya,
  "flex-grow-buttons": "_flex-grow-buttons_1obz3_44"
}, co = ({ children: e, flexGrowButtons: t }) => /* @__PURE__ */ y("div", { className: Q(er.buttons, t && er["flex-grow-buttons"]), children: e }), tr = {
  MOBILE: 640,
  TABLET: 768
}, wa = "_text_8wmox_29", Ie = {
  text: wa,
  "is-small": "_is-small_8wmox_34",
  "is-ellipsis": "_is-ellipsis_8wmox_38",
  "is-center": "_is-center_8wmox_43",
  "color-primary": "_color-primary_8wmox_46",
  "color-secondary": "_color-secondary_8wmox_49",
  "color-tertiary": "_color-tertiary_8wmox_52",
  "color-eco-green": "_color-eco-green_8wmox_55",
  "color-success": "_color-success_8wmox_58",
  "color-error": "_color-error_8wmox_61",
  "color-inverted": "_color-inverted_8wmox_64",
  "color-warning": "_color-warning_8wmox_67",
  "is-bold": "_is-bold_8wmox_70",
  "size-xs": "_size-xs_8wmox_73",
  "size-sm": "_size-sm_8wmox_76",
  "size-base": "_size-base_8wmox_79",
  "size-lg": "_size-lg_8wmox_82",
  "size-xl": "_size-xl_8wmox_85",
  "dialog-overlay-show": "_dialog-overlay-show_8wmox_1",
  "dialog-content-show": "_dialog-content-show_8wmox_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_8wmox_1"
};
function st({
  children: e,
  dangerouslySetInnerHTML: t,
  isSmall: n,
  ellipsis: r,
  isSpan: o,
  className: s = "",
  color: a = "primary",
  isBold: i,
  size: l,
  title: c,
  center: f,
  ...u
}) {
  const p = Q(
    Ie.text,
    n && Ie["is-small"],
    r && Ie["is-ellipsis"],
    a && Ie[`color-${a}`],
    i && Ie["is-bold"],
    l && Ie[`size-${l}`],
    f && Ie["is-center"],
    s
  ), h = o ? "span" : "div";
  return t ? /* @__PURE__ */ y(h, { className: p, dangerouslySetInnerHTML: t, ...u, title: c }) : /* @__PURE__ */ y(h, { className: p, ...u, children: e });
}
const ka = "_title_1w5da_29", $a = "_subtitle_1w5da_94", Be = {
  "title-container": "_title-container_1w5da_29",
  "color-inverted": "_color-inverted_1w5da_32",
  "is-primary": "_is-primary_1w5da_35",
  "is-secondary": "_is-secondary_1w5da_38",
  "is-tertiary": "_is-tertiary_1w5da_41",
  "is-success": "_is-success_1w5da_44",
  "is-error": "_is-error_1w5da_47",
  "is-eco-green": "_is-eco-green_1w5da_50",
  title: ka,
  "is-1": "_is-1_1w5da_61",
  "is-impact": "_is-impact_1w5da_70",
  "is-2": "_is-2_1w5da_74",
  "is-3": "_is-3_1w5da_84",
  subtitle: $a,
  "dialog-overlay-show": "_dialog-overlay-show_1w5da_1",
  "dialog-content-show": "_dialog-content-show_1w5da_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1w5da_1"
}, xa = {
  default: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "color-inverted"
};
function uo({
  color: e = "default",
  children: t,
  level: n = 3,
  hasHeaderTag: r = !1,
  isImpact: o,
  subtitle: s,
  className: a = "",
  title: i,
  ...l
}) {
  const c = `h${n}`, f = `${r ? c : "p"}`, u = Q(Be.title, Be[`is-${n}`], o && Be["is-impact"], a);
  return /* @__PURE__ */ U("div", { className: Q(Be["title-container"], Be[xa[e]]), children: [
    /* @__PURE__ */ y(f, { className: u, ...l, title: i, children: t }),
    s && /* @__PURE__ */ y("p", { className: Q(Be.subtitle), children: s })
  ] });
}
function Oe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e?.(r), n === !1 || !r.defaultPrevented)
      return t?.(r);
  };
}
var at = globalThis?.document ? x.useLayoutEffect : () => {
}, za = x[" useInsertionEffect ".trim().toString()] || at;
function fo({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, s, a] = Sa({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, l = i ? e : o;
  {
    const f = x.useRef(e !== void 0);
    x.useEffect(() => {
      const u = f.current;
      u !== i && console.warn(
        `${r} is changing from ${u ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = i;
    }, [i, r]);
  }
  const c = x.useCallback(
    (f) => {
      if (i) {
        const u = Na(f) ? f(e) : f;
        u !== e && a.current?.(u);
      } else
        s(f);
    },
    [i, e, s, a]
  );
  return [l, c];
}
function Sa({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = x.useState(e), o = x.useRef(n), s = x.useRef(t);
  return za(() => {
    s.current = t;
  }, [t]), x.useEffect(() => {
    o.current !== n && (s.current?.(n), o.current = n);
  }, [n, o]), [n, r, s];
}
function Na(e) {
  return typeof e == "function";
}
function nr(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function po(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const s = nr(o, t);
      return !n && typeof s == "function" && (n = !0), s;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const s = r[o];
          typeof s == "function" ? s() : nr(e[o], null);
        }
      };
  };
}
function Fe(...e) {
  return x.useCallback(po(...e), e);
}
function Dt(e, t = []) {
  let n = [];
  function r(s, a) {
    const i = x.createContext(a), l = n.length;
    n = [...n, a];
    const c = (u) => {
      const { scope: p, children: h, ...m } = u, w = p?.[e]?.[l] || i, k = x.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ y(w.Provider, { value: k, children: h });
    };
    c.displayName = s + "Provider";
    function f(u, p) {
      const h = p?.[e]?.[l] || i, m = x.useContext(h);
      if (m) return m;
      if (a !== void 0) return a;
      throw new Error(`\`${u}\` must be used within \`${s}\``);
    }
    return [c, f];
  }
  const o = () => {
    const s = n.map((a) => x.createContext(a));
    return function(a) {
      const i = a?.[e] || s;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: i } }),
        [a, i]
      );
    };
  };
  return o.scopeName = e, [r, Ea(o, ...t)];
}
function Ea(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(o) {
      const s = r.reduce((a, { useScope: i, scopeName: l }) => {
        const c = i(o)[`__scope${l}`];
        return { ...a, ...c };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
// @__NO_SIDE_EFFECTS__
function tn(e) {
  const t = /* @__PURE__ */ Ca(e), n = x.forwardRef((r, o) => {
    const { children: s, ...a } = r, i = x.Children.toArray(s), l = i.find(Ra);
    if (l) {
      const c = l.props.children, f = i.map((u) => u === l ? x.Children.count(c) > 1 ? x.Children.only(null) : x.isValidElement(c) ? c.props.children : null : u);
      return /* @__PURE__ */ y(t, { ...a, ref: o, children: x.isValidElement(c) ? x.cloneElement(c, void 0, f) : null });
    }
    return /* @__PURE__ */ y(t, { ...a, ref: o, children: s });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Ca(e) {
  const t = x.forwardRef((n, r) => {
    const { children: o, ...s } = n;
    if (x.isValidElement(o)) {
      const a = Pa(o), i = Aa(s, o.props);
      return o.type !== x.Fragment && (i.ref = r ? po(r, a) : a), x.cloneElement(o, i);
    }
    return x.Children.count(o) > 1 ? x.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Oa = Symbol("radix.slottable");
function Ra(e) {
  return x.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Oa;
}
function Aa(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const i = s(...a);
      return o(...a), i;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Pa(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Ta = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ye = Ta.reduce((e, t) => {
  const n = /* @__PURE__ */ tn(`Primitive.${t}`), r = x.forwardRef((o, s) => {
    const { asChild: a, ...i } = o, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ y(l, { ...i, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), Ia = x.createContext(void 0);
function _o(e) {
  const t = x.useContext(Ia);
  return e || t || "ltr";
}
function Da(e) {
  const t = e + "CollectionProvider", [n, r] = Dt(t), [o, s] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (w) => {
    const { scope: k, children: O } = w, v = L.useRef(null), C = L.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ y(o, { scope: k, itemMap: C, collectionRef: v, children: O });
  };
  a.displayName = t;
  const i = e + "CollectionSlot", l = /* @__PURE__ */ tn(i), c = L.forwardRef(
    (w, k) => {
      const { scope: O, children: v } = w, C = s(i, O), N = Fe(k, C.collectionRef);
      return /* @__PURE__ */ y(l, { ref: N, children: v });
    }
  );
  c.displayName = i;
  const f = e + "CollectionItemSlot", u = "data-radix-collection-item", p = /* @__PURE__ */ tn(f), h = L.forwardRef(
    (w, k) => {
      const { scope: O, children: v, ...C } = w, N = L.useRef(null), A = Fe(k, N), j = s(f, O);
      return L.useEffect(() => (j.itemMap.set(N, { ref: N, ...C }), () => void j.itemMap.delete(N))), /* @__PURE__ */ y(p, { [u]: "", ref: A, children: v });
    }
  );
  h.displayName = f;
  function m(w) {
    const k = s(e + "CollectionConsumer", w);
    return L.useCallback(() => {
      const O = k.collectionRef.current;
      if (!O) return [];
      const v = Array.from(O.querySelectorAll(`[${u}]`));
      return Array.from(k.itemMap.values()).sort(
        (C, N) => v.indexOf(C.ref.current) - v.indexOf(N.ref.current)
      );
    }, [k.collectionRef, k.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: h },
    m,
    r
  ];
}
var La = x[" useId ".trim().toString()] || (() => {
}), Fa = 0;
function ja(e) {
  const [t, n] = x.useState(La());
  return at(() => {
    n((r) => r ?? String(Fa++));
  }, [e]), t ? `radix-${t}` : "";
}
function Va(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var ho = (e) => {
  const { present: t, children: n } = e, r = Za(t), o = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), s = Fe(r.ref, Ua(o));
  return typeof n == "function" || r.isPresent ? x.cloneElement(o, { ref: s }) : null;
};
ho.displayName = "Presence";
function Za(e) {
  const [t, n] = x.useState(), r = x.useRef(null), o = x.useRef(e), s = x.useRef("none"), a = e ? "mounted" : "unmounted", [i, l] = Va(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const c = gt(r.current);
    s.current = i === "mounted" ? c : "none";
  }, [i]), at(() => {
    const c = r.current, f = o.current;
    if (f !== e) {
      const u = s.current, p = gt(c);
      e ? l("MOUNT") : p === "none" || c?.display === "none" ? l("UNMOUNT") : l(f && u !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), at(() => {
    if (t) {
      let c;
      const f = t.ownerDocument.defaultView ?? window, u = (h) => {
        const m = gt(r.current).includes(h.animationName);
        if (h.target === t && m && (l("ANIMATION_END"), !o.current)) {
          const w = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = w);
          });
        }
      }, p = (h) => {
        h.target === t && (s.current = gt(r.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        f.clearTimeout(c), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: x.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function gt(e) {
  return e?.animationName || "none";
}
function Ua(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Ma(e) {
  const t = x.useRef(e);
  return x.useEffect(() => {
    t.current = e;
  }), x.useMemo(() => (...n) => t.current?.(...n), []);
}
var Gt = "rovingFocusGroup.onEntryFocus", Ba = { bubbles: !1, cancelable: !0 }, ft = "RovingFocusGroup", [nn, go, Ha] = Da(ft), [Wa, mo] = Dt(
  ft,
  [Ha]
), [Ka, qa] = Wa(ft), bo = x.forwardRef(
  (e, t) => /* @__PURE__ */ y(nn.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ y(nn.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ y(Ga, { ...e, ref: t }) }) })
);
bo.displayName = ft;
var Ga = x.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: s,
    currentTabStopId: a,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: f = !1,
    ...u
  } = e, p = x.useRef(null), h = Fe(t, p), m = _o(s), [w, k] = fo({
    prop: a,
    defaultProp: i ?? null,
    onChange: l,
    caller: ft
  }), [O, v] = x.useState(!1), C = Ma(c), N = go(n), A = x.useRef(!1), [j, V] = x.useState(0);
  return x.useEffect(() => {
    const G = p.current;
    if (G)
      return G.addEventListener(Gt, C), () => G.removeEventListener(Gt, C);
  }, [C]), /* @__PURE__ */ y(
    Ka,
    {
      scope: n,
      orientation: r,
      dir: m,
      loop: o,
      currentTabStopId: w,
      onItemFocus: x.useCallback(
        (G) => k(G),
        [k]
      ),
      onItemShiftTab: x.useCallback(() => v(!0), []),
      onFocusableItemAdd: x.useCallback(
        () => V((G) => G + 1),
        []
      ),
      onFocusableItemRemove: x.useCallback(
        () => V((G) => G - 1),
        []
      ),
      children: /* @__PURE__ */ y(
        Ye.div,
        {
          tabIndex: O || j === 0 ? -1 : 0,
          "data-orientation": r,
          ...u,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: Oe(e.onMouseDown, () => {
            A.current = !0;
          }),
          onFocus: Oe(e.onFocus, (G) => {
            const J = !A.current;
            if (G.target === G.currentTarget && J && !O) {
              const X = new CustomEvent(Gt, Ba);
              if (G.currentTarget.dispatchEvent(X), !X.defaultPrevented) {
                const ie = N().filter((B) => B.focusable), D = ie.find((B) => B.active), I = ie.find((B) => B.id === w), F = [D, I, ...ie].filter(
                  Boolean
                ).map((B) => B.ref.current);
                wo(F, f);
              }
            }
            A.current = !1;
          }),
          onBlur: Oe(e.onBlur, () => v(!1))
        }
      )
    }
  );
}), vo = "RovingFocusGroupItem", yo = x.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: s,
      children: a,
      ...i
    } = e, l = ja(), c = s || l, f = qa(vo, n), u = f.currentTabStopId === c, p = go(n), { onFocusableItemAdd: h, onFocusableItemRemove: m, currentTabStopId: w } = f;
    return x.useEffect(() => {
      if (r)
        return h(), () => m();
    }, [r, h, m]), /* @__PURE__ */ y(
      nn.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ y(
          Ye.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": f.orientation,
            ...i,
            ref: t,
            onMouseDown: Oe(e.onMouseDown, (k) => {
              r ? f.onItemFocus(c) : k.preventDefault();
            }),
            onFocus: Oe(e.onFocus, () => f.onItemFocus(c)),
            onKeyDown: Oe(e.onKeyDown, (k) => {
              if (k.key === "Tab" && k.shiftKey) {
                f.onItemShiftTab();
                return;
              }
              if (k.target !== k.currentTarget) return;
              const O = Qa(k, f.orientation, f.dir);
              if (O !== void 0) {
                if (k.metaKey || k.ctrlKey || k.altKey || k.shiftKey) return;
                k.preventDefault();
                let v = p().filter((C) => C.focusable).map((C) => C.ref.current);
                if (O === "last") v.reverse();
                else if (O === "prev" || O === "next") {
                  O === "prev" && v.reverse();
                  const C = v.indexOf(k.currentTarget);
                  v = f.loop ? Xa(v, C + 1) : v.slice(C + 1);
                }
                setTimeout(() => wo(v));
              }
            }),
            children: typeof a == "function" ? a({ isCurrentTabStop: u, hasTabStop: w != null }) : a
          }
        )
      }
    );
  }
);
yo.displayName = vo;
var Ya = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Ja(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Qa(e, t, n) {
  const r = Ja(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Ya[r];
}
function wo(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function Xa(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var ei = bo, ti = yo;
function ni(e) {
  const [t, n] = x.useState(void 0);
  return at(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const s = o[0];
        let a, i;
        if ("borderBoxSize" in s) {
          const l = s.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, i = c.blockSize;
        } else
          a = e.offsetWidth, i = e.offsetHeight;
        n({ width: a, height: i });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function ri(e) {
  const t = x.useRef({ value: e, previous: e });
  return x.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var kn = "Radio", [oi, ko] = Dt(kn), [si, ai] = oi(kn), $o = x.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: s,
      disabled: a,
      value: i = "on",
      onCheck: l,
      form: c,
      ...f
    } = e, [u, p] = x.useState(null), h = Fe(t, (k) => p(k)), m = x.useRef(!1), w = u ? c || !!u.closest("form") : !0;
    return /* @__PURE__ */ U(si, { scope: n, checked: o, disabled: a, children: [
      /* @__PURE__ */ y(
        Ye.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": No(o),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: i,
          ...f,
          ref: h,
          onClick: Oe(e.onClick, (k) => {
            o || l?.(), w && (m.current = k.isPropagationStopped(), m.current || k.stopPropagation());
          })
        }
      ),
      w && /* @__PURE__ */ y(
        So,
        {
          control: u,
          bubbles: !m.current,
          name: r,
          value: i,
          checked: o,
          required: s,
          disabled: a,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
$o.displayName = kn;
var xo = "RadioIndicator", zo = x.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...o } = e, s = ai(xo, n);
    return /* @__PURE__ */ y(ho, { present: r || s.checked, children: /* @__PURE__ */ y(
      Ye.span,
      {
        "data-state": No(s.checked),
        "data-disabled": s.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
zo.displayName = xo;
var ii = "RadioBubbleInput", So = x.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...o
  }, s) => {
    const a = x.useRef(null), i = Fe(a, s), l = ri(n), c = ni(t);
    return x.useEffect(() => {
      const f = a.current;
      if (!f) return;
      const u = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(
        u,
        "checked"
      ).set;
      if (l !== n && p) {
        const h = new Event("click", { bubbles: r });
        p.call(f, n), f.dispatchEvent(h);
      }
    }, [l, n, r]), /* @__PURE__ */ y(
      Ye.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: i,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
So.displayName = ii;
function No(e) {
  return e ? "checked" : "unchecked";
}
var li = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Lt = "RadioGroup", [ci, rm] = Dt(Lt, [
  mo,
  ko
]), Eo = mo(), Co = ko(), [ui, di] = ci(Lt), Oo = x.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: s,
      required: a = !1,
      disabled: i = !1,
      orientation: l,
      dir: c,
      loop: f = !0,
      onValueChange: u,
      ...p
    } = e, h = Eo(n), m = _o(c), [w, k] = fo({
      prop: s,
      defaultProp: o ?? null,
      onChange: u,
      caller: Lt
    });
    return /* @__PURE__ */ y(
      ui,
      {
        scope: n,
        name: r,
        required: a,
        disabled: i,
        value: w,
        onValueChange: k,
        children: /* @__PURE__ */ y(
          ei,
          {
            asChild: !0,
            ...h,
            orientation: l,
            dir: m,
            loop: f,
            children: /* @__PURE__ */ y(
              Ye.div,
              {
                role: "radiogroup",
                "aria-required": a,
                "aria-orientation": l,
                "data-disabled": i ? "" : void 0,
                dir: m,
                ...p,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
Oo.displayName = Lt;
var Ro = "RadioGroupItem", Ao = x.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = e, s = di(Ro, n), a = s.disabled || r, i = Eo(n), l = Co(n), c = x.useRef(null), f = Fe(t, c), u = s.value === o.value, p = x.useRef(!1);
    return x.useEffect(() => {
      const h = (w) => {
        li.includes(w.key) && (p.current = !0);
      }, m = () => p.current = !1;
      return document.addEventListener("keydown", h), document.addEventListener("keyup", m), () => {
        document.removeEventListener("keydown", h), document.removeEventListener("keyup", m);
      };
    }, []), /* @__PURE__ */ y(
      ti,
      {
        asChild: !0,
        ...i,
        focusable: !a,
        active: u,
        children: /* @__PURE__ */ y(
          $o,
          {
            disabled: a,
            required: s.required,
            checked: u,
            ...l,
            ...o,
            name: s.name,
            ref: f,
            onCheck: () => s.onValueChange(o.value),
            onKeyDown: Oe((h) => {
              h.key === "Enter" && h.preventDefault();
            }),
            onFocus: Oe(o.onFocus, () => {
              p.current && c.current?.click();
            })
          }
        )
      }
    );
  }
);
Ao.displayName = Ro;
var fi = "RadioGroupIndicator", Po = x.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, o = Co(n);
    return /* @__PURE__ */ y(zo, { ...o, ...r, ref: t });
  }
);
Po.displayName = fi;
var pi = Oo, _i = Ao, hi = Po;
const gi = "_indicator_o29me_51", mi = "_label_o29me_66", mt = {
  "radio-item": "_radio-item_o29me_29",
  "radio-button": "_radio-button_o29me_33",
  indicator: gi,
  label: mi
};
function bi({ value: e, id: t, label: n, description: r }) {
  return /* @__PURE__ */ U("div", { className: mt["radio-item"], children: [
    /* @__PURE__ */ y(_i, { value: e, id: t, className: mt["radio-button"], "aria-label": n, children: /* @__PURE__ */ y(hi, { className: mt.indicator }) }),
    /* @__PURE__ */ U("label", { htmlFor: t, className: mt.label, children: [
      n,
      r && /* @__PURE__ */ y("p", { children: r })
    ] })
  ] });
}
function vi() {
  const [e, t] = Ce({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Ke(() => {
    function n() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}
function To() {
  const { width: e } = vi();
  let t = "desktop";
  return e && e <= tr.MOBILE ? t = "mobile" : e && e <= tr.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop"
  };
}
const yi = "_title_ej2xw_37", wi = "_text_ej2xw_41", He = {
  "radio-group": "_radio-group_ej2xw_29",
  "group-label": "_group-label_ej2xw_34",
  title: yi,
  text: wi,
  "has-error": "_has-error_ej2xw_48",
  "error-message": "_error-message_ej2xw_51"
};
function rn({
  children: e,
  defaultValue: t,
  label: n,
  helperContent: r,
  errorMessage: o,
  disabled: s,
  onChange: a,
  onBlur: i,
  value: l,
  name: c
}) {
  const f = !!o, u = !!(n ?? r);
  return /* @__PURE__ */ U(
    pi,
    {
      name: c,
      onValueChange: a,
      defaultValue: t,
      className: Q(He["radio-group"], o && He["has-error"]),
      disabled: s,
      onBlur: i,
      value: l,
      children: [
        u && /* @__PURE__ */ U("div", { className: He["group-label"], children: [
          n && /* @__PURE__ */ y("label", { className: He.title, children: n }),
          r && /* @__PURE__ */ y("p", { className: He.text, children: r })
        ] }),
        e,
        f && /* @__PURE__ */ U("p", { className: He["error-message"], children: [
          /* @__PURE__ */ y(qe, { name: "error-warning-fill", color: "error" }),
          o
        ] })
      ]
    }
  );
}
rn.Item = bi;
const ki = "_flex_k8zg6_29", $i = "_wrap_k8zg6_67", xi = "_nowrap_k8zg6_70", be = {
  flex: ki,
  "flex-row": "_flex-row_k8zg6_34",
  "flex-column": "_flex-column_k8zg6_37",
  "justify-start": "_justify-start_k8zg6_40",
  "justify-end": "_justify-end_k8zg6_43",
  "justify-center": "_justify-center_k8zg6_46",
  "justify-space-between": "_justify-space-between_k8zg6_49",
  "justify-space-around": "_justify-space-around_k8zg6_52",
  "align-start": "_align-start_k8zg6_55",
  "align-end": "_align-end_k8zg6_58",
  "align-center": "_align-center_k8zg6_61",
  "align-stretch": "_align-stretch_k8zg6_64",
  wrap: $i,
  nowrap: xi,
  "wrap-reverse": "_wrap-reverse_k8zg6_73",
  "is-full-width": "_is-full-width_k8zg6_79",
  "is-full-height": "_is-full-height_k8zg6_82",
  "flex-grow": "_flex-grow_k8zg6_85",
  "hide-on-mobile": "_hide-on-mobile_k8zg6_88",
  "gap-0": "_gap-0_k8zg6_96",
  "gap-1": "_gap-1_k8zg6_99",
  "gap-2": "_gap-2_k8zg6_102",
  "gap-3": "_gap-3_k8zg6_105",
  "gap-4": "_gap-4_k8zg6_108",
  "gap-5": "_gap-5_k8zg6_111",
  "gap-6": "_gap-6_k8zg6_114",
  "gap-7": "_gap-7_k8zg6_117",
  "gap-8": "_gap-8_k8zg6_120",
  "gap-9": "_gap-9_k8zg6_123",
  "gap-10": "_gap-10_k8zg6_126",
  "gap-11": "_gap-11_k8zg6_129",
  "gap-12": "_gap-12_k8zg6_132",
  "gap-14": "_gap-14_k8zg6_135",
  "gap-16": "_gap-16_k8zg6_138",
  "gap-18": "_gap-18_k8zg6_141",
  "gap-20": "_gap-20_k8zg6_144",
  "gap-24": "_gap-24_k8zg6_147",
  "gap-28": "_gap-28_k8zg6_150",
  "gap-32": "_gap-32_k8zg6_153",
  "gap-36": "_gap-36_k8zg6_156",
  "gap-40": "_gap-40_k8zg6_159",
  "gap-44": "_gap-44_k8zg6_162",
  "gap-48": "_gap-48_k8zg6_165",
  "gap-52": "_gap-52_k8zg6_168",
  "gap-56": "_gap-56_k8zg6_171",
  "gap-60": "_gap-60_k8zg6_174",
  "gap-64": "_gap-64_k8zg6_177",
  "gap-72": "_gap-72_k8zg6_180",
  "gap-80": "_gap-80_k8zg6_183",
  "gap-96": "_gap-96_k8zg6_186",
  "no-margin": "_no-margin_k8zg6_189",
  "dialog-overlay-show": "_dialog-overlay-show_k8zg6_1",
  "dialog-content-show": "_dialog-content-show_k8zg6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_k8zg6_1"
};
function zi({
  children: e,
  direction: t = "row",
  justifyContent: n = "start",
  alignItems: r = "start",
  flexWrap: o = "wrap",
  className: s = "",
  isFullWidth: a = !1,
  isFullHeight: i = !1,
  gap: l,
  style: c,
  noMargin: f = !1,
  flexGrow: u = !1,
  hideOnMobile: p = !1,
  ...h
}) {
  const m = Q(
    be.flex,
    be[`flex-${t}`],
    be[`justify-${n}`],
    be[`align-${r}`],
    be[o],
    a && be["is-full-width"],
    i && be["is-full-height"],
    l && be[`gap-${l}`],
    f && be["no-margin"],
    u && be["flex-grow"],
    p && be["hide-on-mobile"],
    s
  );
  return /* @__PURE__ */ y("div", { className: m, ...h, style: c, children: e });
}
const Si = 0;
function Ni(e, t, n, r, o, s) {
  const [a, i] = Ce(!1), l = a ? n : r, [c, f] = Ce(l ? l.length : Si), [u, p] = Ce(!1);
  return {
    valueCounter: c,
    isOnBlur: u,
    hasLabelOrHelperText: !!(e ?? t),
    handleBlur: () => {
      p(!0), s?.();
    },
    handleChange: (h) => {
      i(!0), f(h.target.value.length), o && o(h), p(!1);
    }
  };
}
const Ei = "_container_k248c_29", Ci = "_filled_k248c_43", Oi = "_error_k248c_46", Ri = "_success_k248c_49", Ai = "_counter_k248c_126", he = {
  container: Ei,
  "group-label": "_group-label_k248c_34",
  filled: Ci,
  error: Oi,
  success: Ri,
  "helper-text": "_helper-text_k248c_52",
  "container-counter-icon": "_container-counter-icon_k248c_105",
  "container-icon": "_container-icon_k248c_112",
  "icon-error-warning-fill": "_icon-error-warning-fill_k248c_117",
  counter: Ai,
  "dialog-overlay-show": "_dialog-overlay-show_k248c_1",
  "dialog-content-show": "_dialog-content-show_k248c_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_k248c_1"
};
function Pi({
  id: e,
  disabled: t = !1,
  status: n,
  title: r,
  helperText: o,
  placeholder: s,
  maxLength: a,
  onChange: i,
  onBlur: l,
  message: c,
  value: f,
  defaultValue: u,
  name: p
}) {
  const {
    valueCounter: h,
    isOnBlur: m,
    handleBlur: w,
    handleChange: k,
    hasLabelOrHelperText: O
  } = Ni(r, o, f, u, i, l);
  return /* @__PURE__ */ U("div", { className: he.container, children: [
    O && /* @__PURE__ */ U("div", { className: he["group-label"], children: [
      r && /* @__PURE__ */ y(
        "label",
        {
          htmlFor: e,
          className: Q(n && he[n], (h > 0 && m || t) && he.filled),
          children: r
        }
      ),
      o && /* @__PURE__ */ y("div", { className: he["helper-text"], children: o })
    ] }),
    /* @__PURE__ */ y(
      "textarea",
      {
        id: e,
        name: p,
        "aria-label": "textarea",
        placeholder: s,
        onChange: k,
        className: Q(n && he[n]),
        value: f,
        defaultValue: u,
        disabled: t,
        onBlur: w
      }
    ),
    /* @__PURE__ */ U("div", { className: he["container-counter-icon"], children: [
      c && n && /* @__PURE__ */ U("div", { className: he["container-icon"], children: [
        /* @__PURE__ */ y(
          qe,
          {
            name: `${n === "error" ? "error-warning-fill" : "checkbox-fill"}`,
            size: "medium",
            className: Q(he[n])
          }
        ),
        /* @__PURE__ */ y("span", { className: he[n], children: c })
      ] }),
      a && /* @__PURE__ */ U("div", { className: Q(he.counter, h > a && he.error), children: [
        h,
        "/",
        a
      ] })
    ] })
  ] });
}
const rr = 640, Yt = {
  "is-extra-small": "_is-extra-small_17143_29",
  "is-small": "_is-small_17143_32",
  "is-medium": "_is-medium_17143_35",
  "is-large": "_is-large_17143_38",
  "is-extra-large": "_is-extra-large_17143_41",
  "is-auto": "_is-auto_17143_44",
  "is-full-width": "_is-full-width_17143_47",
  "no-border": "_no-border_17143_50",
  "has-sm-border": "_has-sm-border_17143_53",
  "has-full-border": "_has-full-border_17143_56",
  "dialog-overlay-show": "_dialog-overlay-show_17143_1",
  "dialog-content-show": "_dialog-content-show_17143_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17143_1"
};
function Io({
  srcMobile: e,
  width: t = "auto",
  borderRadius: n = "none",
  className: r = "",
  ...o
}) {
  const s = Q(Yt.img, r, Yt[Ti[t]], Yt[Ii[n]]);
  return /* @__PURE__ */ U("picture", { children: [
    e && /* @__PURE__ */ y("source", { media: `(max-width: ${rr}px)`, srcSet: e }),
    /* @__PURE__ */ y("source", { media: `(min-width: ${rr + 1}px)` }),
    /* @__PURE__ */ y("img", { ...o, className: s, alt: o.alt, style: { width: `${o.widthInPx}px` } })
  ] });
}
const Ti = {
  xsmall: "is-extra-small",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  xlarge: "is-extra-large",
  auto: "is-auto",
  full: "is-full-width"
}, Ii = {
  none: "no-border",
  small: "has-sm-border",
  full: "has-full-border"
}, Di = "_callout_5p9zs_29", Li = "_link_5p9zs_49", bt = {
  callout: Di,
  "is-small": "_is-small_5p9zs_44",
  link: Li,
  "is-medium": "_is-medium_5p9zs_52",
  "is-info": "_is-info_5p9zs_55",
  "is-warning": "_is-warning_5p9zs_58",
  "is-success": "_is-success_5p9zs_61",
  "is-error": "_is-error_5p9zs_64",
  "is-neutral": "_is-neutral_5p9zs_67",
  "is-collection": "_is-collection_5p9zs_70",
  "content-container": "_content-container_5p9zs_76",
  "dialog-overlay-show": "_dialog-overlay-show_5p9zs_1",
  "dialog-content-show": "_dialog-content-show_5p9zs_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_5p9zs_1"
}, or = {
  info: {
    name: "information-circle",
    color: "secondary"
  },
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  },
  neutral: {
    name: "information-circle",
    color: "secondary"
  },
  collection: {
    name: "information-circle",
    color: "primary"
  }
}, Fi = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, ji = {
  small: "is-small",
  medium: "is-medium"
};
function Vi({
  status: e = "info",
  size: t = "medium",
  children: n,
  hasIcon: r = !1,
  backgroundImage: o
}) {
  const s = Q(bt.callout, bt[Fi[e]], bt[ji[t]]);
  return /* @__PURE__ */ U("div", { className: s, children: [
    r && /* @__PURE__ */ y(qe, { name: or[e].name, color: or[e].color, size: "2xl" }),
    /* @__PURE__ */ y("div", { className: bt["content-container"], children: n }),
    o && /* @__PURE__ */ y("img", { src: o, alt: "background" })
  ] });
}
const Zi = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, Ui = ({ imageSrc: e, imageSrcMobile: t, imageSrcTablet: n, alt: r, className: o }) => {
  const { isMobile: s, isTablet: a } = To();
  let i = e;
  return s && t && (i = t), a && n && (i = n), /* @__PURE__ */ y("img", { className: o, src: i, alt: r });
}, Mi = "_banner_17hqf_29", Ne = {
  "banner-container": "_banner-container_17hqf_29",
  banner: Mi,
  "banner-image": "_banner-image_17hqf_39",
  "banner-content": "_banner-content_17hqf_42",
  "banner-text": "_banner-text_17hqf_48",
  "banner-cta": "_banner-cta_17hqf_51",
  "is-info": "_is-info_17hqf_92",
  "is-warning": "_is-warning_17hqf_95",
  "is-success": "_is-success_17hqf_98",
  "is-error": "_is-error_17hqf_101",
  "is-neutral": "_is-neutral_17hqf_104",
  "dialog-overlay-show": "_dialog-overlay-show_17hqf_1",
  "dialog-content-show": "_dialog-content-show_17hqf_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17hqf_1"
};
function Bi({ color: e, image: t, className: n, cta: r, title: o, description: s }) {
  const a = Q(Ne.banner, Ne[Zi[e]], n);
  return /* @__PURE__ */ y("div", { className: Ne["banner-container"], children: /* @__PURE__ */ U("div", { className: a, children: [
    t && /* @__PURE__ */ y(Ui, { className: Ne["banner-image"], ...t }),
    /* @__PURE__ */ U("div", { className: Ne["banner-content"], children: [
      /* @__PURE__ */ U("div", { className: Ne["banner-text"], children: [
        /* @__PURE__ */ y(st, { isBold: !0, className: Ne.title, children: o }),
        /* @__PURE__ */ y(st, { className: Ne.description, children: s })
      ] }),
      r && /* @__PURE__ */ y(Ge, { className: Ne["banner-cta"], color: r.color, onClick: r.onClick, children: r.text })
    ] })
  ] }) });
}
const Hi = "_columns_16svi_29", Wi = "_column_16svi_29", Ee = {
  columns: Hi,
  "reverse-on-mobile": "_reverse-on-mobile_16svi_48",
  column: Wi,
  "center-content": "_center-content_16svi_59",
  "gap-0": "_gap-0_16svi_70",
  "gap-1": "_gap-1_16svi_73",
  "gap-2": "_gap-2_16svi_76",
  "gap-3": "_gap-3_16svi_79",
  "gap-4": "_gap-4_16svi_82",
  "gap-5": "_gap-5_16svi_85",
  "gap-6": "_gap-6_16svi_88",
  "gap-7": "_gap-7_16svi_91",
  "gap-8": "_gap-8_16svi_94",
  "gap-9": "_gap-9_16svi_97",
  "gap-10": "_gap-10_16svi_100",
  "gap-11": "_gap-11_16svi_103",
  "gap-12": "_gap-12_16svi_106",
  "gap-14": "_gap-14_16svi_109",
  "gap-16": "_gap-16_16svi_112",
  "gap-18": "_gap-18_16svi_115",
  "gap-20": "_gap-20_16svi_118",
  "gap-24": "_gap-24_16svi_121",
  "gap-28": "_gap-28_16svi_124",
  "gap-32": "_gap-32_16svi_127",
  "gap-36": "_gap-36_16svi_130",
  "gap-40": "_gap-40_16svi_133",
  "gap-44": "_gap-44_16svi_136",
  "gap-48": "_gap-48_16svi_139",
  "gap-52": "_gap-52_16svi_142",
  "gap-56": "_gap-56_16svi_145",
  "gap-60": "_gap-60_16svi_148",
  "gap-64": "_gap-64_16svi_151",
  "gap-72": "_gap-72_16svi_154",
  "gap-80": "_gap-80_16svi_157",
  "gap-96": "_gap-96_16svi_160",
  "hidden-content-on-mobile": "_hidden-content-on-mobile_16svi_163",
  "is-1": "_is-1_16svi_182",
  "is-2": "_is-2_16svi_186",
  "is-3": "_is-3_16svi_190",
  "is-4": "_is-4_16svi_194",
  "is-5": "_is-5_16svi_198",
  "is-6": "_is-6_16svi_202",
  "is-7": "_is-7_16svi_206",
  "is-8": "_is-8_16svi_210",
  "is-9": "_is-9_16svi_214",
  "is-10": "_is-10_16svi_218",
  "is-11": "_is-11_16svi_222",
  "is-12": "_is-12_16svi_226",
  "is-offset-1": "_is-offset-1_16svi_230",
  "is-offset-2": "_is-offset-2_16svi_233",
  "is-offset-3": "_is-offset-3_16svi_236",
  "is-offset-4": "_is-offset-4_16svi_239",
  "is-offset-5": "_is-offset-5_16svi_242",
  "is-offset-6": "_is-offset-6_16svi_245",
  "is-offset-7": "_is-offset-7_16svi_248",
  "is-offset-8": "_is-offset-8_16svi_251",
  "is-offset-9": "_is-offset-9_16svi_254",
  "is-offset-10": "_is-offset-10_16svi_257",
  "is-offset-11": "_is-offset-11_16svi_260",
  "is-narrow": "_is-narrow_16svi_263",
  "dialog-overlay-show": "_dialog-overlay-show_16svi_1",
  "dialog-content-show": "_dialog-content-show_16svi_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_16svi_1"
};
function Do({ children: e, className: t = "", reverseOnMobile: n = !1, ...r }) {
  const o = Q(Ee.columns, n && Ee["reverse-on-mobile"], t);
  return /* @__PURE__ */ y("div", { className: o, ...r, children: e });
}
const Ki = {
  auto: "",
  1: "is-1",
  2: "is-2",
  3: "is-3",
  4: "is-4",
  5: "is-5",
  6: "is-6",
  7: "is-7",
  8: "is-8",
  9: "is-9",
  10: "is-10",
  11: "is-11",
  12: "is-12"
}, qi = {
  auto: "",
  1: "is-offset-1",
  2: "is-offset-2",
  3: "is-offset-3",
  4: "is-offset-4",
  5: "is-offset-5",
  6: "is-offset-6",
  7: "is-offset-7",
  8: "is-offset-8",
  9: "is-offset-9",
  10: "is-offset-10",
  11: "is-offset-11",
  12: "is-offset-12"
};
function Ct({
  size: e = "auto",
  offset: t = "auto",
  isNarrow: n = !1,
  centerContent: r,
  className: o = "",
  children: s,
  gap: a,
  hiddenContentOnMobile: i = !1,
  ...l
}) {
  const c = Q(
    Ee.column,
    Ee[Ki[e]],
    Ee[qi[t]],
    n && Ee["is-narrow"],
    r && Ee["center-content"],
    a && Ee[`gap-${a}`],
    i && Ee["hidden-content-on-mobile"],
    o
  );
  return /* @__PURE__ */ y("div", { className: c, ...l, children: s });
}
const Gi = "_container_ekulv_29", sr = {
  container: Gi,
  "is-fluid": "_is-fluid_ekulv_45"
};
function Yi({ isFluid: e = !1, children: t, className: n = "", ...r }) {
  const o = Q(sr.container, e && sr["is-fluid"], n);
  return /* @__PURE__ */ y("div", { className: o, ...r, children: t });
}
const Ji = "_section_g0e0c_29", Qi = "_content_g0e0c_32", fe = {
  section: Ji,
  content: Qi,
  "is-top-bottom-padding": "_is-top-bottom-padding_g0e0c_35",
  "has-small-padding": "_has-small-padding_g0e0c_38",
  "has-medium-padding": "_has-medium-padding_g0e0c_41",
  "has-large-padding": "_has-large-padding_g0e0c_44",
  "bg-image": "_bg-image_g0e0c_48",
  "image-flex": "_image-flex_g0e0c_53",
  "image-container": "_image-container_g0e0c_63",
  "reverse-bg-color": "_reverse-bg-color_g0e0c_82",
  "image-reverse": "_image-reverse_g0e0c_88",
  "is-full-height": "_is-full-height_g0e0c_94",
  "center-content": "_center-content_g0e0c_97",
  "border-top": "_border-top_g0e0c_101",
  "border-bottom": "_border-bottom_g0e0c_104",
  "border-top-and-bottom": "_border-top-and-bottom_g0e0c_107",
  "is-primary": "_is-primary_g0e0c_111",
  "is-secondary": "_is-secondary_g0e0c_114",
  "is-tertiary": "_is-tertiary_g0e0c_117",
  "dialog-overlay-show": "_dialog-overlay-show_g0e0c_1",
  "dialog-content-show": "_dialog-content-show_g0e0c_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_g0e0c_1"
}, Xi = {
  small: "has-small-padding",
  medium: "has-medium-padding",
  large: "has-large-padding"
}, el = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary"
}, tl = {
  none: "",
  top: "border-top",
  bottom: "border-bottom",
  topAndBottom: "border-top-and-bottom"
};
function nl({
  children: e,
  className: t = "",
  color: n,
  border: r = "none",
  isFullHeight: o,
  centerContent: s,
  isTopBottomPadding: a,
  padding: i = "medium",
  imageSrc: l,
  imagePosition: c,
  imageAlt: f,
  reverseBGColor: u,
  bgImage: p,
  ...h
}) {
  const m = Q(
    fe.section,
    t,
    n && fe[el[n]],
    fe[tl[r]],
    o && fe["is-full-height"],
    s && fe["center-content"],
    l && fe["image-flex"],
    c === "right" && fe["image-reverse"],
    u && fe["reverse-bg-color"]
  ), { isMobile: w } = To();
  return /* @__PURE__ */ U("section", { ...h, className: m, children: [
    l && /* @__PURE__ */ y("div", { className: fe["image-container"], children: /* @__PURE__ */ y("img", { src: l, alt: f }) }),
    /* @__PURE__ */ y(
      "div",
      {
        className: Q(
          fe.content,
          a && fe["is-top-bottom-padding"],
          i && fe[Xi[i]],
          p && fe["bg-image"]
        ),
        style: !w && p ? { backgroundImage: `url(${p})` } : {},
        children: e
      }
    )
  ] });
}
function Lo(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = Lo(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function rl() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = Lo(e)) && (r && (r += " "), r += t);
  return r;
}
const ol = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], sl = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, al = ol.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: sl[e]
})), il = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, ll = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl"
};
function cl(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ y("span", { className: n }, n));
}
const ul = fn(
  ({ name: e, size: t = "medium", color: n = "base", className: r = "", ...o }, s) => {
    const a = al.find((l) => l.name === e), i = rl("icon", `ds-${a?.class}`, ll[t], il[n], r);
    return /* @__PURE__ */ y("i", { className: i, ...o, ref: s, children: cl(a?.paths) });
  }
);
ul.displayName = "Icon";
const dl = ["en", "fr", "it"], Fo = Ur({
  locale: "en"
});
function fl({ children: e, ...t }) {
  return /* @__PURE__ */ y(Fo.Provider, { value: t, children: e });
}
const pl = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
function _l(e) {
  return dl.includes(e) && !0;
}
function hl(e, t) {
  const n = pl.test(t);
  let r;
  return _l(e) || n ? r = `${t}` : r = `/${e}${t}`, { url: r };
}
function $n(e) {
  const { locale: t } = Mr(Fo);
  return hl(t, e);
}
function gl() {
  const [e, t] = Ce({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Ke(() => {
    function n() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}
function jo() {
  const { width: e } = gl();
  let t = "desktop";
  return e && e <= jn.MOBILE ? t = "mobile" : e && e <= jn.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop"
  };
}
const ar = (e, t, n) => {
  if (e && "reportValidity" in e) {
    const r = S(n, t);
    e.setCustomValidity(r && r.message || ""), e.reportValidity();
  }
}, on = (e, t) => {
  for (const n in t.fields) {
    const r = t.fields[n];
    r && r.ref && "reportValidity" in r.ref ? ar(r.ref, n, e) : r && r.refs && r.refs.forEach((o) => ar(o, n, e));
  }
}, ir = (e, t) => {
  t.shouldUseNativeValidation && on(e, t);
  const n = {};
  for (const r in e) {
    const o = S(t.fields, r), s = Object.assign(e[r] || {}, { ref: o && o.ref });
    if (ml(t.names || Object.keys(e), r)) {
      const a = Object.assign({}, S(n, r));
      Z(a, "root", s), Z(n, r, a);
    } else Z(n, r, s);
  }
  return n;
}, ml = (e, t) => {
  const n = lr(t);
  return e.some((r) => lr(r).match(`^${n}\\.\\d+`));
};
function lr(e) {
  return e.replace(/\]|\[/g, "");
}
function b(e, t, n) {
  function r(i, l) {
    var c;
    Object.defineProperty(i, "_zod", {
      value: i._zod ?? {},
      enumerable: !1
    }), (c = i._zod).traits ?? (c.traits = /* @__PURE__ */ new Set()), i._zod.traits.add(e), t(i, l);
    for (const f in a.prototype)
      f in i || Object.defineProperty(i, f, { value: a.prototype[f].bind(i) });
    i._zod.constr = a, i._zod.def = l;
  }
  const o = n?.Parent ?? Object;
  class s extends o {
  }
  Object.defineProperty(s, "name", { value: e });
  function a(i) {
    var l;
    const c = n?.Parent ? new s() : this;
    r(c, i), (l = c._zod).deferred ?? (l.deferred = []);
    for (const f of c._zod.deferred)
      f();
    return c;
  }
  return Object.defineProperty(a, "init", { value: r }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (i) => n?.Parent && i instanceof n.Parent ? !0 : i?._zod?.traits?.has(e)
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class it extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
const Vo = {};
function je(e) {
  return Vo;
}
function bl(e) {
  const t = Object.values(e).filter((r) => typeof r == "number");
  return Object.entries(e).filter(([r, o]) => t.indexOf(+r) === -1).map(([r, o]) => o);
}
function vl(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Zo(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function xn(e) {
  return e == null;
}
function zn(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function K(e, t, n) {
  Object.defineProperty(e, t, {
    get() {
      {
        const r = n();
        return e[t] = r, r;
      }
    },
    set(r) {
      Object.defineProperty(e, t, {
        value: r
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Sn(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Xe(e) {
  return JSON.stringify(e);
}
const Uo = Error.captureStackTrace ? Error.captureStackTrace : (...e) => {
};
function sn(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const yl = Zo(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function an(e) {
  if (sn(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(sn(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
const wl = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Ft(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Ze(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n?.parent) && (r._zod.parent = e), r;
}
function T(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function kl(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function $l(e, t) {
  const n = {}, r = e._zod.def;
  for (const o in t) {
    if (!(o in r.shape))
      throw new Error(`Unrecognized key: "${o}"`);
    t[o] && (n[o] = r.shape[o]);
  }
  return Ze(e, {
    ...e._zod.def,
    shape: n,
    checks: []
  });
}
function xl(e, t) {
  const n = { ...e._zod.def.shape }, r = e._zod.def;
  for (const o in t) {
    if (!(o in r.shape))
      throw new Error(`Unrecognized key: "${o}"`);
    t[o] && delete n[o];
  }
  return Ze(e, {
    ...e._zod.def,
    shape: n,
    checks: []
  });
}
function zl(e, t) {
  if (!an(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = {
    ...e._zod.def,
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Sn(this, "shape", r), r;
    },
    checks: []
    // delete existing checks
  };
  return Ze(e, n);
}
function Sl(e, t) {
  return Ze(e, {
    ...e._zod.def,
    get shape() {
      const n = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Sn(this, "shape", n), n;
    },
    catchall: t._zod.def.catchall,
    checks: []
    // delete existing checks
  });
}
function Nl(e, t, n) {
  const r = t._zod.def.shape, o = { ...r };
  if (n)
    for (const s in n) {
      if (!(s in r))
        throw new Error(`Unrecognized key: "${s}"`);
      n[s] && (o[s] = e ? new e({
        type: "optional",
        innerType: r[s]
      }) : r[s]);
    }
  else
    for (const s in r)
      o[s] = e ? new e({
        type: "optional",
        innerType: r[s]
      }) : r[s];
  return Ze(t, {
    ...t._zod.def,
    shape: o,
    checks: []
  });
}
function El(e, t, n) {
  const r = t._zod.def.shape, o = { ...r };
  if (n)
    for (const s in n) {
      if (!(s in o))
        throw new Error(`Unrecognized key: "${s}"`);
      n[s] && (o[s] = new e({
        type: "nonoptional",
        innerType: r[s]
      }));
    }
  else
    for (const s in r)
      o[s] = new e({
        type: "nonoptional",
        innerType: r[s]
      });
  return Ze(t, {
    ...t._zod.def,
    shape: o,
    // optional: [],
    checks: []
  });
}
function rt(e, t = 0) {
  for (let n = t; n < e.issues.length; n++)
    if (e.issues[n]?.continue !== !0)
      return !0;
  return !1;
}
function Nn(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function vt(e) {
  return typeof e == "string" ? e : e?.message;
}
function Ve(e, t, n) {
  const r = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const o = vt(e.inst?._zod.def?.error?.(e)) ?? vt(t?.error?.(e)) ?? vt(n.customError?.(e)) ?? vt(n.localeError?.(e)) ?? "Invalid input";
    r.message = o;
  }
  return delete r.inst, delete r.continue, t?.reportInput || delete r.input, r;
}
function En(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function lt(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const Mo = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), Object.defineProperty(e, "message", {
    get() {
      return JSON.stringify(t, vl, 2);
    },
    enumerable: !0
    // configurable: false,
  }), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, Cn = b("$ZodError", Mo), jt = b("$ZodError", Mo, { Parent: Error });
function Cl(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const o of e.issues)
    o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(t(o))) : r.push(t(o));
  return { formErrors: r, fieldErrors: n };
}
function Ol(e, t) {
  const n = t || function(s) {
    return s.message;
  }, r = { _errors: [] }, o = (s) => {
    for (const a of s.issues)
      if (a.code === "invalid_union" && a.errors.length)
        a.errors.map((i) => o({ issues: i }));
      else if (a.code === "invalid_key")
        o({ issues: a.issues });
      else if (a.code === "invalid_element")
        o({ issues: a.issues });
      else if (a.path.length === 0)
        r._errors.push(n(a));
      else {
        let i = r, l = 0;
        for (; l < a.path.length; ) {
          const c = a.path[l];
          l === a.path.length - 1 ? (i[c] = i[c] || { _errors: [] }, i[c]._errors.push(n(a))) : i[c] = i[c] || { _errors: [] }, i = i[c], l++;
        }
      }
  };
  return o(e), r;
}
const Bo = (e) => (t, n, r, o) => {
  const s = r ? Object.assign(r, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, s);
  if (a instanceof Promise)
    throw new it();
  if (a.issues.length) {
    const i = new (o?.Err ?? e)(a.issues.map((l) => Ve(l, s, je())));
    throw Uo(i, o?.callee), i;
  }
  return a.value;
}, Rl = /* @__PURE__ */ Bo(jt), Ho = (e) => async (t, n, r, o) => {
  const s = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, s);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const i = new (o?.Err ?? e)(a.issues.map((l) => Ve(l, s, je())));
    throw Uo(i, o?.callee), i;
  }
  return a.value;
}, Al = /* @__PURE__ */ Ho(jt), Wo = (e) => (t, n, r) => {
  const o = r ? { ...r, async: !1 } : { async: !1 }, s = t._zod.run({ value: n, issues: [] }, o);
  if (s instanceof Promise)
    throw new it();
  return s.issues.length ? {
    success: !1,
    error: new (e ?? Cn)(s.issues.map((a) => Ve(a, o, je())))
  } : { success: !0, data: s.value };
}, Pl = /* @__PURE__ */ Wo(jt), Ko = (e) => async (t, n, r) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let s = t._zod.run({ value: n, issues: [] }, o);
  return s instanceof Promise && (s = await s), s.issues.length ? {
    success: !1,
    error: new e(s.issues.map((a) => Ve(a, o, je())))
  } : { success: !0, data: s.value };
}, Tl = /* @__PURE__ */ Ko(jt), Il = /^[cC][^\s-]{8,}$/, Dl = /^[0-9a-z]+$/, Ll = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Fl = /^[0-9a-vA-V]{20}$/, jl = /^[A-Za-z0-9]{27}$/, Vl = /^[a-zA-Z0-9_-]{21}$/, Zl = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Ul = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, cr = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000)$/, Ml = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Bl = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Hl() {
  return new RegExp(Bl, "u");
}
const Wl = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Kl = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})$/, ql = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Gl = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Yl = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, qo = /^[A-Za-z0-9_-]*$/, Jl = /^([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+$/, Ql = /^\+(?:[0-9]){6,14}[0-9]$/, Go = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Xl = /* @__PURE__ */ new RegExp(`^${Go}$`);
function Yo(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function ec(e) {
  return new RegExp(`^${Yo(e)}$`);
}
function tc(e) {
  const t = Yo({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-]\\d{2}:\\d{2})");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${Go}T(?:${r})$`);
}
const nc = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, rc = /^[^A-Z]*$/, oc = /^[^a-z]*$/, $e = /* @__PURE__ */ b("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), sc = /* @__PURE__ */ b("$ZodCheckMaxLength", (e, t) => {
  var n;
  $e.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !xn(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < o && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const o = r.value;
    if (o.length <= t.maximum)
      return;
    const a = En(o);
    r.issues.push({
      origin: a,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), ac = /* @__PURE__ */ b("$ZodCheckMinLength", (e, t) => {
  var n;
  $e.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !xn(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > o && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const o = r.value;
    if (o.length >= t.minimum)
      return;
    const a = En(o);
    r.issues.push({
      origin: a,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), ic = /* @__PURE__ */ b("$ZodCheckLengthEquals", (e, t) => {
  var n;
  $e.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !xn(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.minimum = t.length, o.maximum = t.length, o.length = t.length;
  }), e._zod.check = (r) => {
    const o = r.value, s = o.length;
    if (s === t.length)
      return;
    const a = En(o), i = s > t.length;
    r.issues.push({
      origin: a,
      ...i ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Vt = /* @__PURE__ */ b("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  $e.init(e, t), e._zod.onattach.push((o) => {
    const s = o._zod.bag;
    s.format = t.format, t.pattern && (s.patterns ?? (s.patterns = /* @__PURE__ */ new Set()), s.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (o) => {
    t.pattern.lastIndex = 0, !t.pattern.test(o.value) && o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: o.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), lc = /* @__PURE__ */ b("$ZodCheckRegex", (e, t) => {
  Vt.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), cc = /* @__PURE__ */ b("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = rc), Vt.init(e, t);
}), uc = /* @__PURE__ */ b("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = oc), Vt.init(e, t);
}), dc = /* @__PURE__ */ b("$ZodCheckIncludes", (e, t) => {
  $e.init(e, t);
  const n = Ft(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((o) => {
    const s = o._zod.bag;
    s.patterns ?? (s.patterns = /* @__PURE__ */ new Set()), s.patterns.add(r);
  }), e._zod.check = (o) => {
    o.value.includes(t.includes, t.position) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), fc = /* @__PURE__ */ b("$ZodCheckStartsWith", (e, t) => {
  $e.init(e, t);
  const n = new RegExp(`^${Ft(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), pc = /* @__PURE__ */ b("$ZodCheckEndsWith", (e, t) => {
  $e.init(e, t);
  const n = new RegExp(`.*${Ft(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), _c = /* @__PURE__ */ b("$ZodCheckOverwrite", (e, t) => {
  $e.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class hc {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const r = t.split(`
`).filter((a) => a), o = Math.min(...r.map((a) => a.length - a.trimStart().length)), s = r.map((a) => a.slice(o)).map((a) => " ".repeat(this.indent * 2) + a);
    for (const a of s)
      this.content.push(a);
  }
  compile() {
    const t = Function, n = this?.args, o = [...(this?.content ?? [""]).map((s) => `  ${s}`)];
    return new t(...n, o.join(`
`));
  }
}
const gc = {
  major: 4,
  minor: 0,
  patch: 5
}, re = /* @__PURE__ */ b("$ZodType", (e, t) => {
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = gc;
  const r = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && r.unshift(e);
  for (const o of r)
    for (const s of o._zod.onattach)
      s(e);
  if (r.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, a, i) => {
      let l = rt(s), c;
      for (const f of a) {
        if (f._zod.def.when) {
          if (!f._zod.def.when(s))
            continue;
        } else if (l)
          continue;
        const u = s.issues.length, p = f._zod.check(s);
        if (p instanceof Promise && i?.async === !1)
          throw new it();
        if (c || p instanceof Promise)
          c = (c ?? Promise.resolve()).then(async () => {
            await p, s.issues.length !== u && (l || (l = rt(s, u)));
          });
        else {
          if (s.issues.length === u)
            continue;
          l || (l = rt(s, u));
        }
      }
      return c ? c.then(() => s) : s;
    };
    e._zod.run = (s, a) => {
      const i = e._zod.parse(s, a);
      if (i instanceof Promise) {
        if (a.async === !1)
          throw new it();
        return i.then((l) => o(l, r, a));
      }
      return o(i, r, a);
    };
  }
  e["~standard"] = {
    validate: (o) => {
      try {
        const s = Pl(e, o);
        return s.success ? { value: s.data } : { issues: s.error?.issues };
      } catch {
        return Tl(e, o).then((a) => a.success ? { value: a.data } : { issues: a.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  };
}), On = /* @__PURE__ */ b("$ZodString", (e, t) => {
  re.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? nc(e._zod.bag), e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: e
    }), n;
  };
}), q = /* @__PURE__ */ b("$ZodStringFormat", (e, t) => {
  Vt.init(e, t), On.init(e, t);
}), mc = /* @__PURE__ */ b("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = Ul), q.init(e, t);
}), bc = /* @__PURE__ */ b("$ZodUUID", (e, t) => {
  if (t.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (r === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = cr(r));
  } else
    t.pattern ?? (t.pattern = cr());
  q.init(e, t);
}), vc = /* @__PURE__ */ b("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = Ml), q.init(e, t);
}), yc = /* @__PURE__ */ b("$ZodURL", (e, t) => {
  q.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value, o = new URL(r), s = o.href;
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(o.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: Jl.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(o.protocol.endsWith(":") ? o.protocol.slice(0, -1) : o.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), !r.endsWith("/") && s.endsWith("/") ? n.value = s.slice(0, -1) : n.value = s;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), wc = /* @__PURE__ */ b("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = Hl()), q.init(e, t);
}), kc = /* @__PURE__ */ b("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = Vl), q.init(e, t);
}), $c = /* @__PURE__ */ b("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Il), q.init(e, t);
}), xc = /* @__PURE__ */ b("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = Dl), q.init(e, t);
}), zc = /* @__PURE__ */ b("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = Ll), q.init(e, t);
}), Sc = /* @__PURE__ */ b("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = Fl), q.init(e, t);
}), Nc = /* @__PURE__ */ b("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = jl), q.init(e, t);
}), Ec = /* @__PURE__ */ b("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = tc(t)), q.init(e, t);
}), Cc = /* @__PURE__ */ b("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = Xl), q.init(e, t);
}), Oc = /* @__PURE__ */ b("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = ec(t)), q.init(e, t);
}), Rc = /* @__PURE__ */ b("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = Zl), q.init(e, t);
}), Ac = /* @__PURE__ */ b("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = Wl), q.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = "ipv4";
  });
}), Pc = /* @__PURE__ */ b("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Kl), q.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = "ipv6";
  }), e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Tc = /* @__PURE__ */ b("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = ql), q.init(e, t);
}), Ic = /* @__PURE__ */ b("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = Gl), q.init(e, t), e._zod.check = (n) => {
    const [r, o] = n.value.split("/");
    try {
      if (!o)
        throw new Error();
      const s = Number(o);
      if (`${s}` !== o)
        throw new Error();
      if (s < 0 || s > 128)
        throw new Error();
      new URL(`http://[${r}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Jo(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const Dc = /* @__PURE__ */ b("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Yl), q.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (n) => {
    Jo(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function Lc(e) {
  if (!qo.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Jo(n);
}
const Fc = /* @__PURE__ */ b("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = qo), q.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (n) => {
    Lc(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), jc = /* @__PURE__ */ b("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Ql), q.init(e, t);
});
function Vc(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const o = JSON.parse(atob(r));
    return !("typ" in o && o?.typ !== "JWT" || !o.alg || t && (!("alg" in o) || o.alg !== t));
  } catch {
    return !1;
  }
}
const Zc = /* @__PURE__ */ b("$ZodJWT", (e, t) => {
  q.init(e, t), e._zod.check = (n) => {
    Vc(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Uc = /* @__PURE__ */ b("$ZodUnknown", (e, t) => {
  re.init(e, t), e._zod.parse = (n) => n;
}), Mc = /* @__PURE__ */ b("$ZodNever", (e, t) => {
  re.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function ur(e, t, n) {
  e.issues.length && t.issues.push(...Nn(n, e.issues)), t.value[n] = e.value;
}
const Bc = /* @__PURE__ */ b("$ZodArray", (e, t) => {
  re.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value;
    if (!Array.isArray(o))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    n.value = Array(o.length);
    const s = [];
    for (let a = 0; a < o.length; a++) {
      const i = o[a], l = t.element._zod.run({
        value: i,
        issues: []
      }, r);
      l instanceof Promise ? s.push(l.then((c) => ur(c, n, a))) : ur(l, n, a);
    }
    return s.length ? Promise.all(s).then(() => n) : n;
  };
});
function yt(e, t, n) {
  e.issues.length && t.issues.push(...Nn(n, e.issues)), t.value[n] = e.value;
}
function dr(e, t, n, r) {
  e.issues.length ? r[n] === void 0 ? n in r ? t.value[n] = void 0 : t.value[n] = e.value : t.issues.push(...Nn(n, e.issues)) : e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
const Hc = /* @__PURE__ */ b("$ZodObject", (e, t) => {
  re.init(e, t);
  const n = Zo(() => {
    const u = Object.keys(t.shape);
    for (const h of u)
      if (!(t.shape[h] instanceof re))
        throw new Error(`Invalid element at key "${h}": expected a Zod schema`);
    const p = kl(t.shape);
    return {
      shape: t.shape,
      keys: u,
      keySet: new Set(u),
      numKeys: u.length,
      optionalKeys: new Set(p)
    };
  });
  K(e._zod, "propValues", () => {
    const u = t.shape, p = {};
    for (const h in u) {
      const m = u[h]._zod;
      if (m.values) {
        p[h] ?? (p[h] = /* @__PURE__ */ new Set());
        for (const w of m.values)
          p[h].add(w);
      }
    }
    return p;
  });
  const r = (u) => {
    const p = new hc(["shape", "payload", "ctx"]), h = n.value, m = (v) => {
      const C = Xe(v);
      return `shape[${C}]._zod.run({ value: input[${C}], issues: [] }, ctx)`;
    };
    p.write("const input = payload.value;");
    const w = /* @__PURE__ */ Object.create(null);
    let k = 0;
    for (const v of h.keys)
      w[v] = `key_${k++}`;
    p.write("const newResult = {}");
    for (const v of h.keys)
      if (h.optionalKeys.has(v)) {
        const C = w[v];
        p.write(`const ${C} = ${m(v)};`);
        const N = Xe(v);
        p.write(`
        if (${C}.issues.length) {
          if (input[${N}] === undefined) {
            if (${N} in input) {
              newResult[${N}] = undefined;
            }
          } else {
            payload.issues = payload.issues.concat(
              ${C}.issues.map((iss) => ({
                ...iss,
                path: iss.path ? [${N}, ...iss.path] : [${N}],
              }))
            );
          }
        } else if (${C}.value === undefined) {
          if (${N} in input) newResult[${N}] = undefined;
        } else {
          newResult[${N}] = ${C}.value;
        }
        `);
      } else {
        const C = w[v];
        p.write(`const ${C} = ${m(v)};`), p.write(`
          if (${C}.issues.length) payload.issues = payload.issues.concat(${C}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${Xe(v)}, ...iss.path] : [${Xe(v)}]
          })));`), p.write(`newResult[${Xe(v)}] = ${C}.value`);
      }
    p.write("payload.value = newResult;"), p.write("return payload;");
    const O = p.compile();
    return (v, C) => O(u, v, C);
  };
  let o;
  const s = sn, a = !Vo.jitless, l = a && yl.value, c = t.catchall;
  let f;
  e._zod.parse = (u, p) => {
    f ?? (f = n.value);
    const h = u.value;
    if (!s(h))
      return u.issues.push({
        expected: "object",
        code: "invalid_type",
        input: h,
        inst: e
      }), u;
    const m = [];
    if (a && l && p?.async === !1 && p.jitless !== !0)
      o || (o = r(t.shape)), u = o(u, p);
    else {
      u.value = {};
      const C = f.shape;
      for (const N of f.keys) {
        const A = C[N], j = A._zod.run({ value: h[N], issues: [] }, p), V = A._zod.optin === "optional" && A._zod.optout === "optional";
        j instanceof Promise ? m.push(j.then((G) => V ? dr(G, u, N, h) : yt(G, u, N))) : V ? dr(j, u, N, h) : yt(j, u, N);
      }
    }
    if (!c)
      return m.length ? Promise.all(m).then(() => u) : u;
    const w = [], k = f.keySet, O = c._zod, v = O.def.type;
    for (const C of Object.keys(h)) {
      if (k.has(C))
        continue;
      if (v === "never") {
        w.push(C);
        continue;
      }
      const N = O.run({ value: h[C], issues: [] }, p);
      N instanceof Promise ? m.push(N.then((A) => yt(A, u, C))) : yt(N, u, C);
    }
    return w.length && u.issues.push({
      code: "unrecognized_keys",
      keys: w,
      input: h,
      inst: e
    }), m.length ? Promise.all(m).then(() => u) : u;
  };
});
function fr(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  return t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((s) => Ve(s, r, je())))
  }), t;
}
const Wc = /* @__PURE__ */ b("$ZodUnion", (e, t) => {
  re.init(e, t), K(e._zod, "optin", () => t.options.some((n) => n._zod.optin === "optional") ? "optional" : void 0), K(e._zod, "optout", () => t.options.some((n) => n._zod.optout === "optional") ? "optional" : void 0), K(e._zod, "values", () => {
    if (t.options.every((n) => n._zod.values))
      return new Set(t.options.flatMap((n) => Array.from(n._zod.values)));
  }), K(e._zod, "pattern", () => {
    if (t.options.every((n) => n._zod.pattern)) {
      const n = t.options.map((r) => r._zod.pattern);
      return new RegExp(`^(${n.map((r) => zn(r.source)).join("|")})$`);
    }
  }), e._zod.parse = (n, r) => {
    let o = !1;
    const s = [];
    for (const a of t.options) {
      const i = a._zod.run({
        value: n.value,
        issues: []
      }, r);
      if (i instanceof Promise)
        s.push(i), o = !0;
      else {
        if (i.issues.length === 0)
          return i;
        s.push(i);
      }
    }
    return o ? Promise.all(s).then((a) => fr(a, n, e, r)) : fr(s, n, e, r);
  };
}), Kc = /* @__PURE__ */ b("$ZodIntersection", (e, t) => {
  re.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value, s = t.left._zod.run({ value: o, issues: [] }, r), a = t.right._zod.run({ value: o, issues: [] }, r);
    return s instanceof Promise || a instanceof Promise ? Promise.all([s, a]).then(([l, c]) => pr(n, l, c)) : pr(n, s, a);
  };
});
function ln(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (an(e) && an(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((s) => n.indexOf(s) !== -1), o = { ...e, ...t };
    for (const s of r) {
      const a = ln(e[s], t[s]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [s, ...a.mergeErrorPath]
        };
      o[s] = a.data;
    }
    return { valid: !0, data: o };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const o = e[r], s = t[r], a = ln(o, s);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function pr(e, t, n) {
  if (t.issues.length && e.issues.push(...t.issues), n.issues.length && e.issues.push(...n.issues), rt(e))
    return e;
  const r = ln(t.value, n.value);
  if (!r.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(r.mergeErrorPath)}`);
  return e.value = r.data, e;
}
const qc = /* @__PURE__ */ b("$ZodEnum", (e, t) => {
  re.init(e, t);
  const n = bl(t.entries);
  e._zod.values = new Set(n), e._zod.pattern = new RegExp(`^(${n.filter((r) => wl.has(typeof r)).map((r) => typeof r == "string" ? Ft(r) : r.toString()).join("|")})$`), e._zod.parse = (r, o) => {
    const s = r.value;
    return e._zod.values.has(s) || r.issues.push({
      code: "invalid_value",
      values: n,
      input: s,
      inst: e
    }), r;
  };
}), Gc = /* @__PURE__ */ b("$ZodTransform", (e, t) => {
  re.init(e, t), e._zod.parse = (n, r) => {
    const o = t.transform(n.value, n);
    if (r.async)
      return (o instanceof Promise ? o : Promise.resolve(o)).then((a) => (n.value = a, n));
    if (o instanceof Promise)
      throw new it();
    return n.value = o, n;
  };
}), Yc = /* @__PURE__ */ b("$ZodOptional", (e, t) => {
  re.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", K(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), K(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${zn(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => t.innerType._zod.optin === "optional" ? t.innerType._zod.run(n, r) : n.value === void 0 ? n : t.innerType._zod.run(n, r);
}), Jc = /* @__PURE__ */ b("$ZodNullable", (e, t) => {
  re.init(e, t), K(e._zod, "optin", () => t.innerType._zod.optin), K(e._zod, "optout", () => t.innerType._zod.optout), K(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${zn(n.source)}|null)$`) : void 0;
  }), K(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), Qc = /* @__PURE__ */ b("$ZodDefault", (e, t) => {
  re.init(e, t), e._zod.optin = "optional", K(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((s) => _r(s, t)) : _r(o, t);
  };
});
function _r(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Xc = /* @__PURE__ */ b("$ZodPrefault", (e, t) => {
  re.init(e, t), e._zod.optin = "optional", K(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), eu = /* @__PURE__ */ b("$ZodNonOptional", (e, t) => {
  re.init(e, t), K(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((s) => hr(s, e)) : hr(o, e);
  };
});
function hr(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const tu = /* @__PURE__ */ b("$ZodCatch", (e, t) => {
  re.init(e, t), e._zod.optin = "optional", K(e._zod, "optout", () => t.innerType._zod.optout), K(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((s) => (n.value = s.value, s.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: s.issues.map((a) => Ve(a, r, je()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((s) => Ve(s, r, je()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), nu = /* @__PURE__ */ b("$ZodPipe", (e, t) => {
  re.init(e, t), K(e._zod, "values", () => t.in._zod.values), K(e._zod, "optin", () => t.in._zod.optin), K(e._zod, "optout", () => t.out._zod.optout), K(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    const o = t.in._zod.run(n, r);
    return o instanceof Promise ? o.then((s) => gr(s, t, r)) : gr(o, t, r);
  };
});
function gr(e, t, n) {
  return rt(e) ? e : t.out._zod.run({ value: e.value, issues: e.issues }, n);
}
const ru = /* @__PURE__ */ b("$ZodReadonly", (e, t) => {
  re.init(e, t), K(e._zod, "propValues", () => t.innerType._zod.propValues), K(e._zod, "values", () => t.innerType._zod.values), K(e._zod, "optin", () => t.innerType._zod.optin), K(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then(mr) : mr(o);
  };
});
function mr(e) {
  return e.value = Object.freeze(e.value), e;
}
const ou = /* @__PURE__ */ b("$ZodCustom", (e, t) => {
  $e.init(e, t), re.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, o = t.fn(r);
    if (o instanceof Promise)
      return o.then((s) => br(s, n, r, e));
    br(o, n, r, e);
  };
});
function br(e, t, n, r) {
  if (!e) {
    const o = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (o.params = r._zod.def.params), t.issues.push(lt(o));
  }
}
class su {
  constructor() {
    this._map = /* @__PURE__ */ new Map(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    if (this._map.set(t, r), r && typeof r == "object" && "id" in r) {
      if (this._idmap.has(r.id))
        throw new Error(`ID ${r.id} already exists in the registry`);
      this._idmap.set(r.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new Map(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      return delete r.id, { ...r, ...this._map.get(t) };
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function au() {
  return new su();
}
const wt = /* @__PURE__ */ au();
function iu(e, t) {
  return new e({
    type: "string",
    ...T(t)
  });
}
function lu(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function vr(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function cu(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function uu(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...T(t)
  });
}
function du(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...T(t)
  });
}
function fu(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...T(t)
  });
}
function pu(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function _u(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function hu(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function gu(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function mu(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function bu(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function vu(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function yu(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function wu(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function ku(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function $u(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function xu(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function zu(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function Su(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function Nu(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function Eu(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...T(t)
  });
}
function Cu(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...T(t)
  });
}
function Ou(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...T(t)
  });
}
function Ru(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...T(t)
  });
}
function Au(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...T(t)
  });
}
function Pu(e) {
  return new e({
    type: "unknown"
  });
}
function Tu(e, t) {
  return new e({
    type: "never",
    ...T(t)
  });
}
function Qo(e, t) {
  return new sc({
    check: "max_length",
    ...T(t),
    maximum: e
  });
}
function Ot(e, t) {
  return new ac({
    check: "min_length",
    ...T(t),
    minimum: e
  });
}
function Xo(e, t) {
  return new ic({
    check: "length_equals",
    ...T(t),
    length: e
  });
}
function Iu(e, t) {
  return new lc({
    check: "string_format",
    format: "regex",
    ...T(t),
    pattern: e
  });
}
function Du(e) {
  return new cc({
    check: "string_format",
    format: "lowercase",
    ...T(e)
  });
}
function Lu(e) {
  return new uc({
    check: "string_format",
    format: "uppercase",
    ...T(e)
  });
}
function Fu(e, t) {
  return new dc({
    check: "string_format",
    format: "includes",
    ...T(t),
    includes: e
  });
}
function ju(e, t) {
  return new fc({
    check: "string_format",
    format: "starts_with",
    ...T(t),
    prefix: e
  });
}
function Vu(e, t) {
  return new pc({
    check: "string_format",
    format: "ends_with",
    ...T(t),
    suffix: e
  });
}
function pt(e) {
  return new _c({
    check: "overwrite",
    tx: e
  });
}
function Zu(e) {
  return pt((t) => t.normalize(e));
}
function Uu() {
  return pt((e) => e.trim());
}
function Mu() {
  return pt((e) => e.toLowerCase());
}
function Bu() {
  return pt((e) => e.toUpperCase());
}
function Hu(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...T(n)
  });
}
function Wu(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...T(n)
  });
}
function yr(e, t) {
  try {
    var n = e();
  } catch (r) {
    return t(r);
  }
  return n && n.then ? n.then(void 0, t) : n;
}
function Ku(e, t) {
  for (var n = {}; e.length; ) {
    var r = e[0], o = r.code, s = r.message, a = r.path.join(".");
    if (!n[a]) if ("unionErrors" in r) {
      var i = r.unionErrors[0].errors[0];
      n[a] = { message: i.message, type: i.code };
    } else n[a] = { message: s, type: o };
    if ("unionErrors" in r && r.unionErrors.forEach(function(f) {
      return f.errors.forEach(function(u) {
        return e.push(u);
      });
    }), t) {
      var l = n[a].types, c = l && l[r.code];
      n[a] = bn(a, t, n, o, c ? [].concat(c, r.message) : r.message);
    }
    e.shift();
  }
  return n;
}
function qu(e, t) {
  for (var n = {}; e.length; ) {
    var r = e[0], o = r.code, s = r.message, a = r.path.join(".");
    if (!n[a]) if (r.code === "invalid_union") {
      var i = r.errors[0][0];
      n[a] = { message: i.message, type: i.code };
    } else n[a] = { message: s, type: o };
    if (r.code === "invalid_union" && r.errors.forEach(function(f) {
      return f.forEach(function(u) {
        return e.push(u);
      });
    }), t) {
      var l = n[a].types, c = l && l[r.code];
      n[a] = bn(a, t, n, o, c ? [].concat(c, r.message) : r.message);
    }
    e.shift();
  }
  return n;
}
function Gu(e, t, n) {
  if (n === void 0 && (n = {}), function(r) {
    return "_def" in r && typeof r._def == "object" && "typeName" in r._def;
  }(e)) return function(r, o, s) {
    try {
      return Promise.resolve(yr(function() {
        return Promise.resolve(e[n.mode === "sync" ? "parse" : "parseAsync"](r, t)).then(function(a) {
          return s.shouldUseNativeValidation && on({}, s), { errors: {}, values: n.raw ? Object.assign({}, r) : a };
        });
      }, function(a) {
        if (function(i) {
          return Array.isArray(i?.issues);
        }(a)) return { values: {}, errors: ir(Ku(a.errors, !s.shouldUseNativeValidation && s.criteriaMode === "all"), s) };
        throw a;
      }));
    } catch (a) {
      return Promise.reject(a);
    }
  };
  if (function(r) {
    return "_zod" in r && typeof r._zod == "object";
  }(e)) return function(r, o, s) {
    try {
      return Promise.resolve(yr(function() {
        return Promise.resolve((n.mode === "sync" ? Rl : Al)(e, r, t)).then(function(a) {
          return s.shouldUseNativeValidation && on({}, s), { errors: {}, values: n.raw ? Object.assign({}, r) : a };
        });
      }, function(a) {
        if (function(i) {
          return i instanceof Cn;
        }(a)) return { values: {}, errors: ir(qu(a.issues, !s.shouldUseNativeValidation && s.criteriaMode === "all"), s) };
        throw a;
      }));
    } catch (a) {
      return Promise.reject(a);
    }
  };
  throw new Error("Invalid input: not a Zod schema");
}
const Yu = /* @__PURE__ */ b("ZodISODateTime", (e, t) => {
  Ec.init(e, t), Y.init(e, t);
});
function Ju(e) {
  return Cu(Yu, e);
}
const Qu = /* @__PURE__ */ b("ZodISODate", (e, t) => {
  Cc.init(e, t), Y.init(e, t);
});
function Xu(e) {
  return Ou(Qu, e);
}
const ed = /* @__PURE__ */ b("ZodISOTime", (e, t) => {
  Oc.init(e, t), Y.init(e, t);
});
function td(e) {
  return Ru(ed, e);
}
const nd = /* @__PURE__ */ b("ZodISODuration", (e, t) => {
  Rc.init(e, t), Y.init(e, t);
});
function rd(e) {
  return Au(nd, e);
}
const od = (e, t) => {
  Cn.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => Ol(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => Cl(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => e.issues.push(n)
      // enumerable: false,
    },
    addIssues: {
      value: (n) => e.issues.push(...n)
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Zt = b("ZodError", od, {
  Parent: Error
}), sd = /* @__PURE__ */ Bo(Zt), ad = /* @__PURE__ */ Ho(Zt), id = /* @__PURE__ */ Wo(Zt), ld = /* @__PURE__ */ Ko(Zt), se = /* @__PURE__ */ b("ZodType", (e, t) => (re.init(e, t), e.def = t, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(
  {
    ...t,
    checks: [
      ...t.checks ?? [],
      ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
    ]
  }
  // { parent: true }
), e.clone = (n, r) => Ze(e, n, r), e.brand = () => e, e.register = (n, r) => (n.add(e, r), e), e.parse = (n, r) => sd(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => id(e, n, r), e.parseAsync = async (n, r) => ad(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => ld(e, n, r), e.spa = e.safeParseAsync, e.refine = (n, r) => e.check(ef(n, r)), e.superRefine = (n) => e.check(tf(n)), e.overwrite = (n) => e.check(pt(n)), e.optional = () => xr(e), e.nullable = () => zr(e), e.nullish = () => xr(zr(e)), e.nonoptional = (n) => Wd(e, n), e.array = () => Rd(e), e.or = (n) => Id([e, n]), e.and = (n) => Ld(e, n), e.transform = (n) => Sr(e, Vd(n)), e.default = (n) => Md(e, n), e.prefault = (n) => Hd(e, n), e.catch = (n) => qd(e, n), e.pipe = (n) => Sr(e, n), e.readonly = () => Jd(e), e.describe = (n) => {
  const r = e.clone();
  return wt.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    return wt.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return wt.get(e);
  const r = e.clone();
  return wt.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), es = /* @__PURE__ */ b("_ZodString", (e, t) => {
  On.init(e, t), se.init(e, t);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(Iu(...r)), e.includes = (...r) => e.check(Fu(...r)), e.startsWith = (...r) => e.check(ju(...r)), e.endsWith = (...r) => e.check(Vu(...r)), e.min = (...r) => e.check(Ot(...r)), e.max = (...r) => e.check(Qo(...r)), e.length = (...r) => e.check(Xo(...r)), e.nonempty = (...r) => e.check(Ot(1, ...r)), e.lowercase = (r) => e.check(Du(r)), e.uppercase = (r) => e.check(Lu(r)), e.trim = () => e.check(Uu()), e.normalize = (...r) => e.check(Zu(...r)), e.toLowerCase = () => e.check(Mu()), e.toUpperCase = () => e.check(Bu());
}), cd = /* @__PURE__ */ b("ZodString", (e, t) => {
  On.init(e, t), es.init(e, t), e.email = (n) => e.check(lu(ud, n)), e.url = (n) => e.check(pu(dd, n)), e.jwt = (n) => e.check(Eu(Sd, n)), e.emoji = (n) => e.check(_u(fd, n)), e.guid = (n) => e.check(vr(kr, n)), e.uuid = (n) => e.check(cu(kt, n)), e.uuidv4 = (n) => e.check(uu(kt, n)), e.uuidv6 = (n) => e.check(du(kt, n)), e.uuidv7 = (n) => e.check(fu(kt, n)), e.nanoid = (n) => e.check(hu(pd, n)), e.guid = (n) => e.check(vr(kr, n)), e.cuid = (n) => e.check(gu(_d, n)), e.cuid2 = (n) => e.check(mu(hd, n)), e.ulid = (n) => e.check(bu(gd, n)), e.base64 = (n) => e.check(zu($d, n)), e.base64url = (n) => e.check(Su(xd, n)), e.xid = (n) => e.check(vu(md, n)), e.ksuid = (n) => e.check(yu(bd, n)), e.ipv4 = (n) => e.check(wu(vd, n)), e.ipv6 = (n) => e.check(ku(yd, n)), e.cidrv4 = (n) => e.check($u(wd, n)), e.cidrv6 = (n) => e.check(xu(kd, n)), e.e164 = (n) => e.check(Nu(zd, n)), e.datetime = (n) => e.check(Ju(n)), e.date = (n) => e.check(Xu(n)), e.time = (n) => e.check(td(n)), e.duration = (n) => e.check(rd(n));
});
function wr(e) {
  return iu(cd, e);
}
const Y = /* @__PURE__ */ b("ZodStringFormat", (e, t) => {
  q.init(e, t), es.init(e, t);
}), ud = /* @__PURE__ */ b("ZodEmail", (e, t) => {
  vc.init(e, t), Y.init(e, t);
}), kr = /* @__PURE__ */ b("ZodGUID", (e, t) => {
  mc.init(e, t), Y.init(e, t);
}), kt = /* @__PURE__ */ b("ZodUUID", (e, t) => {
  bc.init(e, t), Y.init(e, t);
}), dd = /* @__PURE__ */ b("ZodURL", (e, t) => {
  yc.init(e, t), Y.init(e, t);
}), fd = /* @__PURE__ */ b("ZodEmoji", (e, t) => {
  wc.init(e, t), Y.init(e, t);
}), pd = /* @__PURE__ */ b("ZodNanoID", (e, t) => {
  kc.init(e, t), Y.init(e, t);
}), _d = /* @__PURE__ */ b("ZodCUID", (e, t) => {
  $c.init(e, t), Y.init(e, t);
}), hd = /* @__PURE__ */ b("ZodCUID2", (e, t) => {
  xc.init(e, t), Y.init(e, t);
}), gd = /* @__PURE__ */ b("ZodULID", (e, t) => {
  zc.init(e, t), Y.init(e, t);
}), md = /* @__PURE__ */ b("ZodXID", (e, t) => {
  Sc.init(e, t), Y.init(e, t);
}), bd = /* @__PURE__ */ b("ZodKSUID", (e, t) => {
  Nc.init(e, t), Y.init(e, t);
}), vd = /* @__PURE__ */ b("ZodIPv4", (e, t) => {
  Ac.init(e, t), Y.init(e, t);
}), yd = /* @__PURE__ */ b("ZodIPv6", (e, t) => {
  Pc.init(e, t), Y.init(e, t);
}), wd = /* @__PURE__ */ b("ZodCIDRv4", (e, t) => {
  Tc.init(e, t), Y.init(e, t);
}), kd = /* @__PURE__ */ b("ZodCIDRv6", (e, t) => {
  Ic.init(e, t), Y.init(e, t);
}), $d = /* @__PURE__ */ b("ZodBase64", (e, t) => {
  Dc.init(e, t), Y.init(e, t);
}), xd = /* @__PURE__ */ b("ZodBase64URL", (e, t) => {
  Fc.init(e, t), Y.init(e, t);
}), zd = /* @__PURE__ */ b("ZodE164", (e, t) => {
  jc.init(e, t), Y.init(e, t);
}), Sd = /* @__PURE__ */ b("ZodJWT", (e, t) => {
  Zc.init(e, t), Y.init(e, t);
}), Nd = /* @__PURE__ */ b("ZodUnknown", (e, t) => {
  Uc.init(e, t), se.init(e, t);
});
function $r() {
  return Pu(Nd);
}
const Ed = /* @__PURE__ */ b("ZodNever", (e, t) => {
  Mc.init(e, t), se.init(e, t);
});
function Cd(e) {
  return Tu(Ed, e);
}
const Od = /* @__PURE__ */ b("ZodArray", (e, t) => {
  Bc.init(e, t), se.init(e, t), e.element = t.element, e.min = (n, r) => e.check(Ot(n, r)), e.nonempty = (n) => e.check(Ot(1, n)), e.max = (n, r) => e.check(Qo(n, r)), e.length = (n, r) => e.check(Xo(n, r)), e.unwrap = () => e.element;
});
function Rd(e, t) {
  return Hu(Od, e, t);
}
const Ad = /* @__PURE__ */ b("ZodObject", (e, t) => {
  Hc.init(e, t), se.init(e, t), K(e, "shape", () => t.shape), e.keyof = () => Fd(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: $r() }), e.loose = () => e.clone({ ...e._zod.def, catchall: $r() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Cd() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => zl(e, n), e.merge = (n) => Sl(e, n), e.pick = (n) => $l(e, n), e.omit = (n) => xl(e, n), e.partial = (...n) => Nl(ts, e, n[0]), e.required = (...n) => El(ns, e, n[0]);
});
function Pd(e, t) {
  const n = {
    type: "object",
    get shape() {
      return Sn(this, "shape", { ...e }), this.shape;
    },
    ...T(t)
  };
  return new Ad(n);
}
const Td = /* @__PURE__ */ b("ZodUnion", (e, t) => {
  Wc.init(e, t), se.init(e, t), e.options = t.options;
});
function Id(e, t) {
  return new Td({
    type: "union",
    options: e,
    ...T(t)
  });
}
const Dd = /* @__PURE__ */ b("ZodIntersection", (e, t) => {
  Kc.init(e, t), se.init(e, t);
});
function Ld(e, t) {
  return new Dd({
    type: "intersection",
    left: e,
    right: t
  });
}
const cn = /* @__PURE__ */ b("ZodEnum", (e, t) => {
  qc.init(e, t), se.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, o) => {
    const s = {};
    for (const a of r)
      if (n.has(a))
        s[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new cn({
      ...t,
      checks: [],
      ...T(o),
      entries: s
    });
  }, e.exclude = (r, o) => {
    const s = { ...t.entries };
    for (const a of r)
      if (n.has(a))
        delete s[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new cn({
      ...t,
      checks: [],
      ...T(o),
      entries: s
    });
  };
});
function Fd(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new cn({
    type: "enum",
    entries: n,
    ...T(t)
  });
}
const jd = /* @__PURE__ */ b("ZodTransform", (e, t) => {
  Gc.init(e, t), se.init(e, t), e._zod.parse = (n, r) => {
    n.addIssue = (s) => {
      if (typeof s == "string")
        n.issues.push(lt(s, n.value, t));
      else {
        const a = s;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = e), a.continue ?? (a.continue = !0), n.issues.push(lt(a));
      }
    };
    const o = t.transform(n.value, n);
    return o instanceof Promise ? o.then((s) => (n.value = s, n)) : (n.value = o, n);
  };
});
function Vd(e) {
  return new jd({
    type: "transform",
    transform: e
  });
}
const ts = /* @__PURE__ */ b("ZodOptional", (e, t) => {
  Yc.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function xr(e) {
  return new ts({
    type: "optional",
    innerType: e
  });
}
const Zd = /* @__PURE__ */ b("ZodNullable", (e, t) => {
  Jc.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function zr(e) {
  return new Zd({
    type: "nullable",
    innerType: e
  });
}
const Ud = /* @__PURE__ */ b("ZodDefault", (e, t) => {
  Qc.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Md(e, t) {
  return new Ud({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t;
    }
  });
}
const Bd = /* @__PURE__ */ b("ZodPrefault", (e, t) => {
  Xc.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Hd(e, t) {
  return new Bd({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t;
    }
  });
}
const ns = /* @__PURE__ */ b("ZodNonOptional", (e, t) => {
  eu.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Wd(e, t) {
  return new ns({
    type: "nonoptional",
    innerType: e,
    ...T(t)
  });
}
const Kd = /* @__PURE__ */ b("ZodCatch", (e, t) => {
  tu.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function qd(e, t) {
  return new Kd({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Gd = /* @__PURE__ */ b("ZodPipe", (e, t) => {
  nu.init(e, t), se.init(e, t), e.in = t.in, e.out = t.out;
});
function Sr(e, t) {
  return new Gd({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Yd = /* @__PURE__ */ b("ZodReadonly", (e, t) => {
  ru.init(e, t), se.init(e, t);
});
function Jd(e) {
  return new Yd({
    type: "readonly",
    innerType: e
  });
}
const Qd = /* @__PURE__ */ b("ZodCustom", (e, t) => {
  ou.init(e, t), se.init(e, t);
});
function Xd(e) {
  const t = new $e({
    check: "custom"
    // ...util.normalizeParams(params),
  });
  return t._zod.check = e, t;
}
function ef(e, t = {}) {
  return Wu(Qd, e, t);
}
function tf(e) {
  const t = Xd((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(lt(r, n.value, t._zod.def));
    else {
      const o = r;
      o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), o.input ?? (o.input = n.value), o.inst ?? (o.inst = t), o.continue ?? (o.continue = !t._zod.def.abort), n.issues.push(lt(o));
    }
  }, e(n.value, n)));
  return t;
}
const Rt = "9", nf = Pd({
  reasonId: wr({ error: "reasons_for_cancellation_needed" }),
  comment: wr().optional()
}).refine((e) => !(e.reasonId === Rt && !e.comment), {
  message: "reasons_other_comment_needed",
  path: ["comment"]
}).refine((e) => !(e.reasonId === Rt && e.comment && e.comment.length > 255), {
  message: "common:error.characters_max_limit",
  path: ["comment"]
});
function rf({ onClickContinue: e, cancellationReasons: t, conversation: n, user: r }) {
  const { t: o } = wn(["conversations", "common"]), [s, a] = Ce(!1), [i, l] = Ce(!1), c = async (m) => {
    try {
      a(!0), await ys(n.id, m.reasonId, m.comment);
      const w = t.find((k) => k.id.toString() === m.reasonId);
      Gg(
        {
          exchange_status: "cancelled",
          cancellation_reason: w?.name,
          exchange_type: n.exchanges.length === 1 ? "guest_point_exchange" : "reciprocal_exchange",
          collection: r.is_he_collection
        },
        { eventCallback: () => e(), eventTimeout: 2e3 }
      );
    } catch (w) {
      throw l(!0), w;
    } finally {
      a(!1);
    }
  }, f = Vs({
    resolver: Gu(nf)
  }), { watch: u } = f, p = Hr(
    () => t.map((m) => ({
      id: m.id.toString(),
      name: o(`reasons_for_cancellation_${m.name}`)
    })),
    [t, o]
  ), h = u("reasonId") === Rt;
  return {
    isLoading: s,
    requestHasError: i,
    onSubmitCancellationForm: c,
    cancellationReasonsRadioItems: p,
    displayCommentTextarea: h,
    cancellationForm: f
  };
}
function of({ onClickContinue: e, cancellationReasons: t, conversation: n, user: r }) {
  const { url: o } = $n(`/conversations/${n.id}`), { t: s } = wn(["conversations", "common"]), { isDesktop: a } = jo(), {
    isLoading: i,
    requestHasError: l,
    onSubmitCancellationForm: c,
    cancellationReasonsRadioItems: f,
    displayCommentTextarea: u,
    cancellationForm: {
      control: p,
      handleSubmit: h,
      setValue: m,
      formState: { errors: w }
    }
  } = rf({ onClickContinue: e, cancellationReasons: t, conversation: n, user: r });
  return /* @__PURE__ */ U(Do, { children: [
    /* @__PURE__ */ U(Ct, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ y(uo, { level: 2, children: s("cancellation-page.reason_step.title") }),
      /* @__PURE__ */ y("form", { onSubmit: h(c), children: /* @__PURE__ */ U(zi, { isFullWidth: !0, flexGrow: !0, alignItems: "stretch", direction: "column", children: [
        /* @__PURE__ */ y(
          Vn,
          {
            name: "reasonId",
            control: p,
            render: ({ field: k }) => /* @__PURE__ */ y(
              rn,
              {
                ...k,
                errorMessage: w.reasonId?.message ? s(w.reasonId.message) : void 0,
                onChange: (O) => {
                  O !== Rt && u && m("comment", ""), k.onChange(O);
                },
                label: s("cancellation-page.reason_step.checboxes_label"),
                children: f.map((O) => /* @__PURE__ */ y(rn.Item, { value: O.id, id: O.id, label: O.name }, O.id))
              }
            )
          }
        ),
        u && /* @__PURE__ */ y(
          Vn,
          {
            name: "comment",
            control: p,
            render: ({ field: k }) => /* @__PURE__ */ y(
              Pi,
              {
                placeholder: s("cancellation-page.reason_step.comment_placeholder"),
                id: "reason-comment",
                status: w.comment?.message ? "error" : void 0,
                message: w.comment?.message ? s(w.comment?.message, { limit: 255 }) : void 0,
                maxLength: 255,
                ...k
              }
            )
          }
        ),
        l && !i && /* @__PURE__ */ U(Vi, { status: "error", hasIcon: !0, children: [
          /* @__PURE__ */ y("span", { style: { fontWeight: "bold" }, children: s("common:errors.unable_to_submit.title") }),
          /* @__PURE__ */ y(st, { children: s("common:errors.unable_to_submit.subtitle") })
        ] }),
        /* @__PURE__ */ U(co, { flexGrowButtons: !0, children: [
          /* @__PURE__ */ y(Ge, { isLoading: i, disabled: i, color: "destructive", type: "submit", children: s("cancellation-page.cancel-exchange") }),
          /* @__PURE__ */ y(Ge, { disabled: i, color: "tertiary", href: o, children: s("cancellation-page.keep-exchange") })
        ] })
      ] }) })
    ] }),
    a && /* @__PURE__ */ y(Ct, { size: 6, centerContent: !0, children: /* @__PURE__ */ y(
      Io,
      {
        width: "full",
        src: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/cancellation/cancellation-regular-desktop.svg",
        alt: "cancellation-warning"
      }
    ) })
  ] });
}
function sf({ onClickContinue: e, conversation: t }) {
  const { t: n } = wn("conversations"), { isTablet: r, isMobile: o, isDesktop: s } = jo(), { url: a } = $n(`/conversations/${t.id}`), i = /* @__PURE__ */ U(co, { flexGrowButtons: !0, children: [
    /* @__PURE__ */ y(Ge, { onClick: e, children: n("cancellation-page.continue-cancellation") }),
    /* @__PURE__ */ y(Ge, { color: "tertiary", href: a, children: n("cancellation-page.keep-exchange") })
  ] });
  return /* @__PURE__ */ U(Do, { children: [
    /* @__PURE__ */ U(Ct, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ y(uo, { level: 2, children: n("cancellation-page.cancel-exchange") }),
      /* @__PURE__ */ y(st, { children: n("cancellation-page.warning-step.first-warning") }),
      /* @__PURE__ */ y(st, { isBold: !0, children: n("cancellation-page.warning-step.second-warning") }),
      s && i
    ] }),
    /* @__PURE__ */ U(Ct, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ y(
        Io,
        {
          width: "full",
          src: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/cancellation/cancellation-regular-desktop.svg",
          alt: "cancellation-warning"
        }
      ),
      (r || o) && i
    ] })
  ] });
}
const rs = "https://www.homeexchange.com/blog/calculate-the-carbon-footprint-of-your-trip/", af = {
  fr: "https://www.homeexchange.fr/blog/calculez-lempreinte-carbone-de-votre-voyage/",
  es: "https://es.homeexchange.com/es/blog/calcula-la-huella-de-carbono-de-tus-viajes/",
  en: rs
};
function om({
  className: e,
  title: t,
  description: n,
  locale: r,
  ctaText: o,
  onClickCTA: s
}) {
  return /* @__PURE__ */ y(
    Bi,
    {
      className: e,
      color: "info",
      title: t,
      description: n,
      image: {
        alt: "transportation-banner-logo",
        imageSrc: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/transportation/transportation-banner-logo.svg",
        imageSrcMobile: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/transportation/transportation-banner-logo-small.svg"
      },
      cta: {
        color: "eco-green",
        text: o,
        onClick: async () => {
          await s(), window.open(af[r] || rs, "_blank");
        }
      }
    }
  );
}
const lf = (e, t, n, r) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null, page_data: null, user_data: null });
  const { eventCallback: o, ...s } = {}, a = (i) => {
    o && typeof o == "function" && i.startsWith("GTM-") && o(i);
  };
  window.dataLayer.push({
    event: "data_layer_init",
    event_data: {
      collection: n,
      method: null,
      text: null
    },
    page_data: {
      location: window.location.href,
      referrer: document.referrer,
      title: document.title,
      language: navigator.language
    },
    user_data: {
      login_status: "logged",
      uid: e,
      profile: t
    },
    eventCallback: a,
    ...s
  });
}, os = (e, t, n) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null });
  const { eventCallback: r, ...o } = n || {}, s = (a) => {
    r && typeof r == "function" && a.startsWith("GTM-") && r(a);
  };
  window.dataLayer.push({
    event: e,
    event_data: t,
    ...o,
    eventCallback: s
  }), !window.google_tag_manager && n?.eventCallback && typeof n.eventCallback == "function" && n.eventCallback();
}, cf = (e, t, n) => {
  os("funnel_progress", {
    funnel_name: e,
    funnel_step: t,
    ...n
  });
}, uf = (e) => e.subscriptionEndOn ? e.isHeCollection ? "member_collection" : new Date(e.subscriptionEndOn) < /* @__PURE__ */ new Date() ? "expired" : "member_regular" : "lead", P = (e) => typeof e == "string", et = () => {
  let e, t;
  const n = new Promise((r, o) => {
    e = r, t = o;
  });
  return n.resolve = e, n.reject = t, n;
}, Nr = (e) => e == null ? "" : "" + e, df = (e, t, n) => {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}, ff = /###/g, Er = (e) => e && e.indexOf("###") > -1 ? e.replace(ff, ".") : e, Cr = (e) => !e || P(e), ot = (e, t, n) => {
  const r = P(t) ? t.split(".") : t;
  let o = 0;
  for (; o < r.length - 1; ) {
    if (Cr(e)) return {};
    const s = Er(r[o]);
    !e[s] && n && (e[s] = new n()), Object.prototype.hasOwnProperty.call(e, s) ? e = e[s] : e = {}, ++o;
  }
  return Cr(e) ? {} : {
    obj: e,
    k: Er(r[o])
  };
}, Or = (e, t, n) => {
  const {
    obj: r,
    k: o
  } = ot(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[o] = n;
    return;
  }
  let s = t[t.length - 1], a = t.slice(0, t.length - 1), i = ot(e, a, Object);
  for (; i.obj === void 0 && a.length; )
    s = `${a[a.length - 1]}.${s}`, a = a.slice(0, a.length - 1), i = ot(e, a, Object), i?.obj && typeof i.obj[`${i.k}.${s}`] < "u" && (i.obj = void 0);
  i.obj[`${i.k}.${s}`] = n;
}, pf = (e, t, n, r) => {
  const {
    obj: o,
    k: s
  } = ot(e, t, Object);
  o[s] = o[s] || [], o[s].push(n);
}, At = (e, t) => {
  const {
    obj: n,
    k: r
  } = ot(e, t);
  if (n && Object.prototype.hasOwnProperty.call(n, r))
    return n[r];
}, _f = (e, t, n) => {
  const r = At(e, n);
  return r !== void 0 ? r : At(t, n);
}, ss = (e, t, n) => {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? P(e[r]) || e[r] instanceof String || P(t[r]) || t[r] instanceof String ? n && (e[r] = t[r]) : ss(e[r], t[r], n) : e[r] = t[r]);
  return e;
}, We = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var hf = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const gf = (e) => P(e) ? e.replace(/[&<>"'\/]/g, (t) => hf[t]) : e;
class mf {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const bf = [" ", ",", "?", "!", ";"], vf = new mf(20), yf = (e, t, n) => {
  t = t || "", n = n || "";
  const r = bf.filter((a) => t.indexOf(a) < 0 && n.indexOf(a) < 0);
  if (r.length === 0) return !0;
  const o = vf.getRegExp(`(${r.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let s = !o.test(e);
  if (!s) {
    const a = e.indexOf(n);
    a > 0 && !o.test(e.substring(0, a)) && (s = !0);
  }
  return s;
}, un = (e, t, n = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const r = t.split(n);
  let o = e;
  for (let s = 0; s < r.length; ) {
    if (!o || typeof o != "object")
      return;
    let a, i = "";
    for (let l = s; l < r.length; ++l)
      if (l !== s && (i += n), i += r[l], a = o[i], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && l < r.length - 1)
          continue;
        s += l - s + 1;
        break;
      }
    o = a;
  }
  return o;
}, ct = (e) => e?.replace("_", "-"), wf = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class Pt {
  constructor(t, n = {}) {
    this.init(t, n);
  }
  init(t, n = {}) {
    this.prefix = n.prefix || "i18next:", this.logger = t || wf, this.options = n, this.debug = n.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, o) {
    return o && !this.debug ? null : (P(t[0]) && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new Pt(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Pt(this.logger, t);
  }
}
var ke = new Pt();
class Ut {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const o = this.observers[r].get(n) || 0;
      this.observers[r].set(n, o + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t, ...n) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([o, s]) => {
      for (let a = 0; a < s; a++)
        o(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([o, s]) => {
      for (let a = 0; a < s; a++)
        o.apply(o, [t, ...n]);
    });
  }
}
class Rr extends Ut {
  constructor(t, n = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r, o = {}) {
    const s = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, a = o.ignoreJSONStructure !== void 0 ? o.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let i;
    t.indexOf(".") > -1 ? i = t.split(".") : (i = [t, n], r && (Array.isArray(r) ? i.push(...r) : P(r) && s ? i.push(...r.split(s)) : i.push(r)));
    const l = At(this.data, i);
    return !l && !n && !r && t.indexOf(".") > -1 && (t = i[0], n = i[1], r = i.slice(2).join(".")), l || !a || !P(r) ? l : un(this.data?.[t]?.[n], r, s);
  }
  addResource(t, n, r, o, s = {
    silent: !1
  }) {
    const a = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator;
    let i = [t, n];
    r && (i = i.concat(a ? r.split(a) : r)), t.indexOf(".") > -1 && (i = t.split("."), o = n, n = i[1]), this.addNamespaces(n), Or(this.data, i, o), s.silent || this.emit("added", t, n, r, o);
  }
  addResources(t, n, r, o = {
    silent: !1
  }) {
    for (const s in r)
      (P(r[s]) || Array.isArray(r[s])) && this.addResource(t, n, s, r[s], {
        silent: !0
      });
    o.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, o, s, a = {
    silent: !1,
    skipCopy: !1
  }) {
    let i = [t, n];
    t.indexOf(".") > -1 && (i = t.split("."), o = r, r = n, n = i[1]), this.addNamespaces(n);
    let l = At(this.data, i) || {};
    a.skipCopy || (r = JSON.parse(JSON.stringify(r))), o ? ss(l, r, s) : l = {
      ...l,
      ...r
    }, Or(this.data, i, l), a.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((o) => n[o] && Object.keys(n[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var as = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, o) {
    return e.forEach((s) => {
      t = this.processors[s]?.process(t, n, r, o) ?? t;
    }), t;
  }
};
const Ar = {}, Pr = (e) => !P(e) && typeof e != "boolean" && typeof e != "number";
class Tt extends Ut {
  constructor(t, n = {}) {
    super(), df(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = ke.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, n = {
    interpolation: {}
  }) {
    const r = {
      ...n
    };
    return t == null ? !1 : this.resolve(t, r)?.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let s = n.ns || this.options.defaultNS || [];
    const a = r && t.indexOf(r) > -1, i = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !yf(t, r, o);
    if (a && !i) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: P(s) ? [s] : s
        };
      const c = t.split(r);
      (r !== o || r === o && this.options.ns.indexOf(c[0]) > -1) && (s = c.shift()), t = c.join(o);
    }
    return {
      key: t,
      namespaces: P(s) ? [s] : s
    };
  }
  translate(t, n, r) {
    let o = typeof n == "object" ? {
      ...n
    } : n;
    if (typeof o != "object" && this.options.overloadTranslationOptionHandler && (o = this.options.overloadTranslationOptionHandler(arguments)), typeof options == "object" && (o = {
      ...o
    }), o || (o = {}), t == null) return "";
    Array.isArray(t) || (t = [String(t)]);
    const s = o.returnDetails !== void 0 ? o.returnDetails : this.options.returnDetails, a = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, {
      key: i,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], o), c = l[l.length - 1];
    let f = o.nsSeparator !== void 0 ? o.nsSeparator : this.options.nsSeparator;
    f === void 0 && (f = ":");
    const u = o.lng || this.language, p = o.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (u?.toLowerCase() === "cimode")
      return p ? s ? {
        res: `${c}${f}${i}`,
        usedKey: i,
        exactUsedKey: i,
        usedLng: u,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(o)
      } : `${c}${f}${i}` : s ? {
        res: i,
        usedKey: i,
        exactUsedKey: i,
        usedLng: u,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(o)
      } : i;
    const h = this.resolve(t, o);
    let m = h?.res;
    const w = h?.usedKey || i, k = h?.exactUsedKey || i, O = ["[object Number]", "[object Function]", "[object RegExp]"], v = o.joinArrays !== void 0 ? o.joinArrays : this.options.joinArrays, C = !this.i18nFormat || this.i18nFormat.handleAsObject, N = o.count !== void 0 && !P(o.count), A = Tt.hasDefaultValue(o), j = N ? this.pluralResolver.getSuffix(u, o.count, o) : "", V = o.ordinal && N ? this.pluralResolver.getSuffix(u, o.count, {
      ordinal: !1
    }) : "", G = N && !o.ordinal && o.count === 0, J = G && o[`defaultValue${this.options.pluralSeparator}zero`] || o[`defaultValue${j}`] || o[`defaultValue${V}`] || o.defaultValue;
    let X = m;
    C && !m && A && (X = J);
    const ie = Pr(X), D = Object.prototype.toString.apply(X);
    if (C && X && ie && O.indexOf(D) < 0 && !(P(v) && Array.isArray(X))) {
      if (!o.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const I = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(w, X, {
          ...o,
          ns: l
        }) : `key '${i} (${this.language})' returned an object instead of string.`;
        return s ? (h.res = I, h.usedParams = this.getUsedParamsDetails(o), h) : I;
      }
      if (a) {
        const I = Array.isArray(X), F = I ? [] : {}, B = I ? k : w;
        for (const W in X)
          if (Object.prototype.hasOwnProperty.call(X, W)) {
            const ne = `${B}${a}${W}`;
            A && !m ? F[W] = this.translate(ne, {
              ...o,
              defaultValue: Pr(J) ? J[W] : void 0,
              joinArrays: !1,
              ns: l
            }) : F[W] = this.translate(ne, {
              ...o,
              joinArrays: !1,
              ns: l
            }), F[W] === ne && (F[W] = X[W]);
          }
        m = F;
      }
    } else if (C && P(v) && Array.isArray(m))
      m = m.join(v), m && (m = this.extendTranslation(m, t, o, r));
    else {
      let I = !1, F = !1;
      !this.isValidLookup(m) && A && (I = !0, m = J), this.isValidLookup(m) || (F = !0, m = i);
      const W = (o.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && F ? void 0 : m, ne = A && J !== m && this.options.updateMissing;
      if (F || I || ne) {
        if (this.logger.log(ne ? "updateKey" : "missingKey", u, c, i, ne ? J : m), a) {
          const le = this.resolve(i, {
            ...o,
            keySeparator: !1
          });
          le && le.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let ge = [];
        const me = this.languageUtils.getFallbackCodes(this.options.fallbackLng, o.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && me && me[0])
          for (let le = 0; le < me.length; le++)
            ge.push(me[le]);
        else this.options.saveMissingTo === "all" ? ge = this.languageUtils.toResolveHierarchy(o.lng || this.language) : ge.push(o.lng || this.language);
        const Te = (le, xe, Re) => {
          const _t = A && Re !== m ? Re : W;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(le, c, xe, _t, ne, o) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(le, c, xe, _t, ne, o), this.emit("missingKey", le, c, xe, m);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && N ? ge.forEach((le) => {
          const xe = this.pluralResolver.getSuffixes(le, o);
          G && o[`defaultValue${this.options.pluralSeparator}zero`] && xe.indexOf(`${this.options.pluralSeparator}zero`) < 0 && xe.push(`${this.options.pluralSeparator}zero`), xe.forEach((Re) => {
            Te([le], i + Re, o[`defaultValue${Re}`] || J);
          });
        }) : Te(ge, i, J));
      }
      m = this.extendTranslation(m, t, o, h, r), F && m === i && this.options.appendNamespaceToMissingKey && (m = `${c}${f}${i}`), (F || I) && this.options.parseMissingKeyHandler && (m = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${f}${i}` : i, I ? m : void 0, o));
    }
    return s ? (h.res = m, h.usedParams = this.getUsedParamsDetails(o), h) : m;
  }
  extendTranslation(t, n, r, o, s) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || o.usedLng, o.usedNS, o.usedKey, {
        resolved: o
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const l = P(t) && (r?.interpolation?.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const u = t.match(this.interpolator.nestingRegexp);
        c = u && u.length;
      }
      let f = r.replace && !P(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (f = {
        ...this.options.interpolation.defaultVariables,
        ...f
      }), t = this.interpolator.interpolate(t, f, r.lng || this.language || o.usedLng, r), l) {
        const u = t.match(this.interpolator.nestingRegexp), p = u && u.length;
        c < p && (r.nest = !1);
      }
      !r.lng && o && o.res && (r.lng = this.language || o.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, (...u) => s?.[0] === u[0] && !r.context ? (this.logger.warn(`It seems you are nesting recursively key: ${u[0]} in key: ${n[0]}`), null) : this.translate(...u, n), r)), r.interpolation && this.interpolator.reset();
    }
    const a = r.postProcess || this.options.postProcess, i = P(a) ? [a] : a;
    return t != null && i?.length && r.applyPostProcessor !== !1 && (t = as.handle(i, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...o,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), t;
  }
  resolve(t, n = {}) {
    let r, o, s, a, i;
    return P(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(r)) return;
      const c = this.extractFromKey(l, n), f = c.key;
      o = f;
      let u = c.namespaces;
      this.options.fallbackNS && (u = u.concat(this.options.fallbackNS));
      const p = n.count !== void 0 && !P(n.count), h = p && !n.ordinal && n.count === 0, m = n.context !== void 0 && (P(n.context) || typeof n.context == "number") && n.context !== "", w = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      u.forEach((k) => {
        this.isValidLookup(r) || (i = k, !Ar[`${w[0]}-${k}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(i) && (Ar[`${w[0]}-${k}`] = !0, this.logger.warn(`key "${o}" for languages "${w.join(", ")}" won't get resolved as namespace "${i}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), w.forEach((O) => {
          if (this.isValidLookup(r)) return;
          a = O;
          const v = [f];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, f, O, k, n);
          else {
            let N;
            p && (N = this.pluralResolver.getSuffix(O, n.count, n));
            const A = `${this.options.pluralSeparator}zero`, j = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (v.push(f + N), n.ordinal && N.indexOf(j) === 0 && v.push(f + N.replace(j, this.options.pluralSeparator)), h && v.push(f + A)), m) {
              const V = `${f}${this.options.contextSeparator}${n.context}`;
              v.push(V), p && (v.push(V + N), n.ordinal && N.indexOf(j) === 0 && v.push(V + N.replace(j, this.options.pluralSeparator)), h && v.push(V + A));
            }
          }
          let C;
          for (; C = v.pop(); )
            this.isValidLookup(r) || (s = C, r = this.getResource(O, k, C, n));
        }));
      });
    }), {
      res: r,
      usedKey: o,
      exactUsedKey: s,
      usedLng: a,
      usedNS: i
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r, o = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, n, r, o) : this.resourceStore.getResource(t, n, r, o);
  }
  getUsedParamsDetails(t = {}) {
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && !P(t.replace);
    let o = r ? t.replace : t;
    if (r && typeof t.count < "u" && (o.count = t.count), this.options.interpolation.defaultVariables && (o = {
      ...this.options.interpolation.defaultVariables,
      ...o
    }), !r) {
      o = {
        ...o
      };
      for (const s of n)
        delete o[s];
    }
    return o;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
class Tr {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = ke.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = ct(t), !t || t.indexOf("-") < 0) return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = ct(t), !t || t.indexOf("-") < 0) return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (P(t) && t.indexOf("-") > -1) {
      let n;
      try {
        n = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return n && this.options.lowerCaseLng && (n = n.toLowerCase()), n || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let n;
    return t.forEach((r) => {
      if (n) return;
      const o = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(o)) && (n = o);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n) return;
      const o = this.getScriptPartFromCode(r);
      if (this.isSupportedCode(o)) return n = o;
      const s = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(s)) return n = s;
      n = this.options.supportedLngs.find((a) => {
        if (a === s) return a;
        if (!(a.indexOf("-") < 0 && s.indexOf("-") < 0) && (a.indexOf("-") > 0 && s.indexOf("-") < 0 && a.substring(0, a.indexOf("-")) === s || a.indexOf(s) === 0 && s.length > 1))
          return a;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(n)), P(t) && (t = [t]), Array.isArray(t)) return t;
    if (!n) return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes((n === !1 ? [] : n) || this.options.fallbackLng || [], t), o = [], s = (a) => {
      a && (this.isSupportedCode(a) ? o.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return P(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && s(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && s(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && s(this.getLanguagePartFromCode(t))) : P(t) && s(this.formatLanguageCode(t)), r.forEach((a) => {
      o.indexOf(a) < 0 && s(this.formatLanguageCode(a));
    }), o;
  }
}
const Ir = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Dr = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class kf {
  constructor(t, n = {}) {
    this.languageUtils = t, this.options = n, this.logger = ke.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, n = {}) {
    const r = ct(t === "dev" ? "en" : t), o = n.ordinal ? "ordinal" : "cardinal", s = JSON.stringify({
      cleanedCode: r,
      type: o
    });
    if (s in this.pluralRulesCache)
      return this.pluralRulesCache[s];
    let a;
    try {
      a = new Intl.PluralRules(r, {
        type: o
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Dr;
      if (!t.match(/-|_/)) return Dr;
      const l = this.languageUtils.getLanguagePartFromCode(t);
      a = this.getRule(l, n);
    }
    return this.pluralRulesCache[s] = a, a;
  }
  needsPlural(t, n = {}) {
    let r = this.getRule(t, n);
    return r || (r = this.getRule("dev", n)), r?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, n, r = {}) {
    return this.getSuffixes(t, r).map((o) => `${n}${o}`);
  }
  getSuffixes(t, n = {}) {
    let r = this.getRule(t, n);
    return r || (r = this.getRule("dev", n)), r ? r.resolvedOptions().pluralCategories.sort((o, s) => Ir[o] - Ir[s]).map((o) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${o}`) : [];
  }
  getSuffix(t, n, r = {}) {
    const o = this.getRule(t, r);
    return o ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${o.select(n)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", n, r));
  }
}
const Lr = (e, t, n, r = ".", o = !0) => {
  let s = _f(e, t, n);
  return !s && o && P(n) && (s = un(e, n, r), s === void 0 && (s = un(t, n, r))), s;
}, Jt = (e) => e.replace(/\$/g, "$$$$");
class $f {
  constructor(t = {}) {
    this.logger = ke.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((n) => n), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: o,
      prefix: s,
      prefixEscaped: a,
      suffix: i,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: f,
      unescapePrefix: u,
      nestingPrefix: p,
      nestingPrefixEscaped: h,
      nestingSuffix: m,
      nestingSuffixEscaped: w,
      nestingOptionsSeparator: k,
      maxReplaces: O,
      alwaysFormat: v
    } = t.interpolation;
    this.escape = n !== void 0 ? n : gf, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = o !== void 0 ? o : !1, this.prefix = s ? We(s) : a || "{{", this.suffix = i ? We(i) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = f ? "" : u || "-", this.unescapeSuffix = this.unescapePrefix ? "" : f || "", this.nestingPrefix = p ? We(p) : h || We("$t("), this.nestingSuffix = m ? We(m) : w || We(")"), this.nestingOptionsSeparator = k || ",", this.maxReplaces = O || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n?.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, o) {
    let s, a, i;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const O = Lr(n, l, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(O, void 0, r, {
          ...o,
          ...n,
          interpolationkey: h
        }) : O;
      }
      const m = h.split(this.formatSeparator), w = m.shift().trim(), k = m.join(this.formatSeparator).trim();
      return this.format(Lr(n, l, w, this.options.keySeparator, this.options.ignoreJSONStructure), k, r, {
        ...o,
        ...n,
        interpolationkey: w
      });
    };
    this.resetRegExp();
    const f = o?.missingInterpolationHandler || this.options.missingInterpolationHandler, u = o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => Jt(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? Jt(this.escape(h)) : Jt(h)
    }].forEach((h) => {
      for (i = 0; s = h.regex.exec(t); ) {
        const m = s[1].trim();
        if (a = c(m), a === void 0)
          if (typeof f == "function") {
            const k = f(t, s, o);
            a = P(k) ? k : "";
          } else if (o && Object.prototype.hasOwnProperty.call(o, m))
            a = "";
          else if (u) {
            a = s[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${t}`), a = "";
        else !P(a) && !this.useRawValueToEscape && (a = Nr(a));
        const w = h.safeValue(a);
        if (t = t.replace(s[0], w), u ? (h.regex.lastIndex += a.length, h.regex.lastIndex -= s[0].length) : h.regex.lastIndex = 0, i++, i >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n, r = {}) {
    let o, s, a;
    const i = (l, c) => {
      const f = this.nestingOptionsSeparator;
      if (l.indexOf(f) < 0) return l;
      const u = l.split(new RegExp(`${f}[ ]*{`));
      let p = `{${u[1]}`;
      l = u[0], p = this.interpolate(p, a);
      const h = p.match(/'/g), m = p.match(/"/g);
      ((h?.length ?? 0) % 2 === 0 && !m || m.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        a = JSON.parse(p), c && (a = {
          ...c,
          ...a
        });
      } catch (w) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, w), `${l}${f}${p}`;
      }
      return a.defaultValue && a.defaultValue.indexOf(this.prefix) > -1 && delete a.defaultValue, l;
    };
    for (; o = this.nestingRegexp.exec(t); ) {
      let l = [];
      a = {
        ...r
      }, a = a.replace && !P(a.replace) ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let c = !1;
      if (o[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(o[1])) {
        const f = o[1].split(this.formatSeparator).map((u) => u.trim());
        o[1] = f.shift(), l = f, c = !0;
      }
      if (s = n(i.call(this, o[1].trim(), a), a), s && o[0] === t && !P(s)) return s;
      P(s) || (s = Nr(s)), s || (this.logger.warn(`missed to resolve ${o[1]} for nesting ${t}`), s = ""), c && (s = l.reduce((f, u) => this.format(f, u, r.lng, {
        ...r,
        interpolationkey: o[1].trim()
      }), s.trim())), t = t.replace(o[0], s), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const xf = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const o = r[1].substring(0, r[1].length - 1);
    t === "currency" && o.indexOf(":") < 0 ? n.currency || (n.currency = o.trim()) : t === "relativetime" && o.indexOf(":") < 0 ? n.range || (n.range = o.trim()) : o.split(";").forEach((a) => {
      if (a) {
        const [i, ...l] = a.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), f = i.trim();
        n[f] || (n[f] = c), c === "false" && (n[f] = !1), c === "true" && (n[f] = !0), isNaN(c) || (n[f] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, Fr = (e) => {
  const t = {};
  return (n, r, o) => {
    let s = o;
    o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey] && (s = {
      ...s,
      [o.interpolationkey]: void 0
    });
    const a = r + JSON.stringify(s);
    let i = t[a];
    return i || (i = e(ct(r), o), t[a] = i), i(n);
  };
}, zf = (e) => (t, n, r) => e(ct(n), r)(t);
class Sf {
  constructor(t = {}) {
    this.logger = ke.create("formatter"), this.options = t, this.init(t);
  }
  init(t, n = {
    interpolation: {}
  }) {
    this.formatSeparator = n.interpolation.formatSeparator || ",";
    const r = n.cacheInBuiltFormats ? Fr : zf;
    this.formats = {
      number: r((o, s) => {
        const a = new Intl.NumberFormat(o, {
          ...s
        });
        return (i) => a.format(i);
      }),
      currency: r((o, s) => {
        const a = new Intl.NumberFormat(o, {
          ...s,
          style: "currency"
        });
        return (i) => a.format(i);
      }),
      datetime: r((o, s) => {
        const a = new Intl.DateTimeFormat(o, {
          ...s
        });
        return (i) => a.format(i);
      }),
      relativetime: r((o, s) => {
        const a = new Intl.RelativeTimeFormat(o, {
          ...s
        });
        return (i) => a.format(i, s.range || "day");
      }),
      list: r((o, s) => {
        const a = new Intl.ListFormat(o, {
          ...s
        });
        return (i) => a.format(i);
      })
    };
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = Fr(n);
  }
  format(t, n, r, o = {}) {
    const s = n.split(this.formatSeparator);
    if (s.length > 1 && s[0].indexOf("(") > 1 && s[0].indexOf(")") < 0 && s.find((i) => i.indexOf(")") > -1)) {
      const i = s.findIndex((l) => l.indexOf(")") > -1);
      s[0] = [s[0], ...s.splice(1, i)].join(this.formatSeparator);
    }
    return s.reduce((i, l) => {
      const {
        formatName: c,
        formatOptions: f
      } = xf(l);
      if (this.formats[c]) {
        let u = i;
        try {
          const p = o?.formatParams?.[o.interpolationkey] || {}, h = p.locale || p.lng || o.locale || o.lng || r;
          u = this.formats[c](i, h, {
            ...f,
            ...o,
            ...p
          });
        } catch (p) {
          this.logger.warn(p);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return i;
    }, t);
  }
}
const Nf = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class Ef extends Ut {
  constructor(t, n, r, o = {}) {
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = o, this.logger = ke.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = o.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5, this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(r, o.backend, o);
  }
  queueLoad(t, n, r, o) {
    const s = {}, a = {}, i = {}, l = {};
    return t.forEach((c) => {
      let f = !0;
      n.forEach((u) => {
        const p = `${c}|${u}`;
        !r.reload && this.store.hasResourceBundle(c, u) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? a[p] === void 0 && (a[p] = !0) : (this.state[p] = 1, f = !1, a[p] === void 0 && (a[p] = !0), s[p] === void 0 && (s[p] = !0), l[u] === void 0 && (l[u] = !0)));
      }), f || (i[c] = !0);
    }), (Object.keys(s).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: o
    }), {
      toLoad: Object.keys(s),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(i),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, r) {
    const o = t.split("|"), s = o[0], a = o[1];
    n && this.emit("failedLoading", s, a, n), !n && r && this.store.addResourceBundle(s, a, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && r && (this.state[t] = 0);
    const i = {};
    this.queue.forEach((l) => {
      pf(l.loaded, [s], a), Nf(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        i[c] || (i[c] = {});
        const f = l.loaded[c];
        f.length && f.forEach((u) => {
          i[c][u] === void 0 && (i[c][u] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", i), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, r, o = 0, s = this.retryTimeout, a) {
    if (!t.length) return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: o,
        wait: s,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const i = (c, f) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const u = this.waitingReads.shift();
        this.read(u.lng, u.ns, u.fcName, u.tried, u.wait, u.callback);
      }
      if (c && f && o < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, o + 1, s * 2, a);
        }, s);
        return;
      }
      a(c, f);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, n);
        c && typeof c.then == "function" ? c.then((f) => i(null, f)).catch(i) : i(null, c);
      } catch (c) {
        i(c);
      }
      return;
    }
    return l(t, n, i);
  }
  prepareLoading(t, n, r = {}, o) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
    P(t) && (t = this.languageUtils.toResolveHierarchy(t)), P(n) && (n = [n]);
    const s = this.queueLoad(t, n, r, o);
    if (!s.toLoad.length)
      return s.pending.length || o(), null;
    s.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t, n = "") {
    const r = t.split("|"), o = r[0], s = r[1];
    this.read(o, s, "read", void 0, void 0, (a, i) => {
      a && this.logger.warn(`${n}loading namespace ${s} for language ${o} failed`, a), !a && i && this.logger.log(`${n}loaded namespace ${s} for language ${o}`, i), this.loaded(t, a, i);
    });
  }
  saveMissing(t, n, r, o, s, a = {}, i = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend?.create) {
        const l = {
          ...a,
          isUpdate: s
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let f;
            c.length === 5 ? f = c(t, n, r, o, l) : f = c(t, n, r, o), f && typeof f.then == "function" ? f.then((u) => i(null, u)).catch(i) : i(null, f);
          } catch (f) {
            i(f);
          }
        else
          c(t, n, r, o, i, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, o);
    }
  }
}
const jr = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), P(e[1]) && (t.defaultValue = e[1]), P(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((r) => {
        t[r] = n[r];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), Vr = (e) => (P(e.ns) && (e.ns = [e.ns]), P(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), P(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), $t = () => {
}, Cf = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
};
class ut extends Ut {
  constructor(t = {}, n) {
    if (super(), this.options = Vr(t), this.services = {}, this.logger = ke, this.modules = {
      external: []
    }, Cf(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init(t = {}, n) {
    this.isInitializing = !0, typeof t == "function" && (n = t, t = {}), t.defaultNS == null && t.ns && (P(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const r = jr();
    this.options = {
      ...r,
      ...this.options,
      ...Vr(t)
    }, this.options.interpolation = {
      ...r.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const o = (c) => c ? typeof c == "function" ? new c() : c : null;
    if (!this.options.isClone) {
      this.modules.logger ? ke.init(o(this.modules.logger), this.options) : ke.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : c = Sf;
      const f = new Tr(this.options);
      this.store = new Rr(this.options.resources, this.options);
      const u = this.services;
      u.logger = ke, u.resourceStore = this.store, u.languageUtils = f, u.pluralResolver = new kf(f, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), c && (!this.options.interpolation.format || this.options.interpolation.format === r.interpolation.format) && (u.formatter = o(c), u.formatter.init(u, this.options), this.options.interpolation.format = u.formatter.format.bind(u.formatter)), u.interpolator = new $f(this.options), u.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, u.backendConnector = new Ef(o(this.modules.backend), u.resourceStore, u, this.options), u.backendConnector.on("*", (p, ...h) => {
        this.emit(p, ...h);
      }), this.modules.languageDetector && (u.languageDetector = o(this.modules.languageDetector), u.languageDetector.init && u.languageDetector.init(u, this.options.detection, this.options)), this.modules.i18nFormat && (u.i18nFormat = o(this.modules.i18nFormat), u.i18nFormat.init && u.i18nFormat.init(this)), this.translator = new Tt(this.services, this.options), this.translator.on("*", (p, ...h) => {
        this.emit(p, ...h);
      }), this.modules.external.forEach((p) => {
        p.init && p.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = $t), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = (...f) => this.store[c](...f);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = (...f) => (this.store[c](...f), this);
    });
    const i = et(), l = () => {
      const c = (f, u) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), i.resolve(u), n(f, u);
      };
      if (this.languages && !this.isInitialized) return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initAsync ? l() : setTimeout(l, 0), i;
  }
  loadResources(t, n = $t) {
    let r = n;
    const o = P(t) ? t : this.language;
    if (typeof t == "function" && (r = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (o?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
      const s = [], a = (i) => {
        if (!i || i === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(i).forEach((c) => {
          c !== "cimode" && s.indexOf(c) < 0 && s.push(c);
        });
      };
      o ? a(o) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => a(l)), this.options.preload?.forEach?.((i) => a(i)), this.services.backendConnector.load(s, this.options.ns, (i) => {
        !i && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(i);
      });
    } else
      r(null);
  }
  reloadResources(t, n, r) {
    const o = et();
    return typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), r || (r = $t), this.services.backendConnector.reload(t, n, (s) => {
      o.resolve(), r(s);
    }), o;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && as.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, n) {
    this.isLanguageChangingTo = t;
    const r = et();
    this.emit("languageChanging", t);
    const o = (i) => {
      this.language = i, this.languages = this.services.languageUtils.toResolveHierarchy(i), this.resolvedLanguage = void 0, this.setResolvedLanguage(i);
    }, s = (i, l) => {
      l ? this.isLanguageChangingTo === t && (o(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, r.resolve((...c) => this.t(...c)), n && n(i, (...c) => this.t(...c));
    }, a = (i) => {
      !t && !i && this.services.languageDetector && (i = []);
      const l = P(i) ? i : i && i[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(P(i) ? [i] : i);
      c && (this.language || o(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (f) => {
        s(f, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? a(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(a) : this.services.languageDetector.detect(a) : a(t), r;
  }
  getFixedT(t, n, r) {
    const o = (s, a, ...i) => {
      let l;
      typeof a != "object" ? l = this.options.overloadTranslationOptionHandler([s, a].concat(i)) : l = {
        ...a
      }, l.lng = l.lng || o.lng, l.lngs = l.lngs || o.lngs, l.ns = l.ns || o.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || o.keyPrefix);
      const c = this.options.keySeparator || ".";
      let f;
      return l.keyPrefix && Array.isArray(s) ? f = s.map((u) => `${l.keyPrefix}${c}${u}`) : f = l.keyPrefix ? `${l.keyPrefix}${c}${s}` : s, this.t(f, l);
    };
    return P(t) ? o.lng = t : o.lngs = t, o.ns = n, o.keyPrefix = r, o;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, n = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], o = this.options ? this.options.fallbackLng : !1, s = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const a = (i, l) => {
      const c = this.services.backendConnector.state[`${i}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const i = n.precheck(this, a);
      if (i !== void 0) return i;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(r, t) && (!o || a(s, t)));
  }
  loadNamespaces(t, n) {
    const r = et();
    return this.options.ns ? (P(t) && (t = [t]), t.forEach((o) => {
      this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
    }), this.loadResources((o) => {
      r.resolve(), n && n(o);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = et();
    P(t) && (t = [t]);
    const o = this.options.preload || [], s = t.filter((a) => o.indexOf(a) < 0 && this.services.languageUtils.isSupportedCode(a));
    return s.length ? (this.options.preload = o.concat(s), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services?.languageUtils || new Tr(jr());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, n) {
    return new ut(t, n);
  }
  cloneInstance(t = {}, n = $t) {
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const o = {
      ...this.options,
      ...t,
      isClone: !0
    }, s = new ut(o);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (s.logger = s.logger.clone(t)), ["store", "services", "language"].forEach((i) => {
      s[i] = this[i];
    }), s.services = {
      ...this.services
    }, s.services.utils = {
      hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
    }, r) {
      const i = Object.keys(this.store.data).reduce((l, c) => (l[c] = {
        ...this.store.data[c]
      }, l[c] = Object.keys(l[c]).reduce((f, u) => (f[u] = {
        ...l[c][u]
      }, f), l[c]), l), {});
      s.store = new Rr(i, o), s.services.resourceStore = s.store;
    }
    return s.translator = new Tt(s.services, o), s.translator.on("*", (i, ...l) => {
      s.emit(i, ...l);
    }), s.init(o, n), s.translator.options = o, s.translator.backendConnector.services.utils = {
      hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
    }, s;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const ue = ut.createInstance();
ue.createInstance = ut.createInstance;
const Of = ue.createInstance;
ue.dir;
ue.init;
ue.loadResources;
ue.reloadResources;
ue.use;
ue.changeLanguage;
ue.getFixedT;
ue.t;
ue.exists;
ue.setDefaultNamespace;
ue.hasLoadedNamespace;
ue.loadNamespaces;
ue.loadLanguages;
const Rf = "Studio", Af = "{{count}} soveværelse", Pf = "{{count}} soveværelser", Tf = "", If = "{{count}} seng", Df = "{{count}} senge", Lf = "", Ff = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: Rf,
  bedroomsNumbers_one: Af,
  bedroomsNumbers_other: Pf,
  beds_zero: Tf,
  beds_one: If,
  beds_other: Df,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: Lf
}, jf = "Når du har forhåndsgodkendt  dette boligbytte, skal din byttepartner bekræfte det. Byttepartneren har {nbDays} dage til at bekræfte boligbyttet (indtil {date}). Ellers vil din forhåndsgodkendelse udløbe, og du bliver nødt til at forhåndsgodkende boligbyttet igen.", Vf = "Dobbelt booking (via en anden platform)", Zf = "Familieproblemer", Uf = "Helbredsproblemer", Mf = "Skader i hjemmet", Bf = "Flytning", Hf = "Du skal angive årsagerne til, at du vil annullere boligbyttet.", Wf = "Andre", Kf = "Transportproblemer", qf = "Tillidsproblem", Gf = "Arbejdsrelateret", Yf = "Du er nødt til at indtaste en årsag", Jf = {
  "cancellation-page.cancel-exchange": "Annuller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsæt annulleringen",
  "cancellation-page.keep-exchange": "Behold mit boligbytte",
  "cancellation-page.reason_step.checboxes_label": "Vælg hovedårsagen til din annullering:",
  "cancellation-page.reason_step.comment_placeholder": "Skriv årsagen til din annullering her.",
  "cancellation-page.reason_step.error": "Du er nødt til at indtaste en årsag",
  "cancellation-page.reason_step.title": "Hvorfor er du nødt til at annullere?",
  "cancellation-page.warning-step.first-warning": "Husk, at annullering af dit boligbytte kan have en negativ indvirkning på din byttepartner, som måske allerede har lavet rejseplaner!",
  "cancellation-page.warning-step.second-warning": "Vigtigt: I tilfælde af for mange uberettigede aflysninger som vært, kan din konto blive taget offline. Og som gæst får du muligvis ikke alle dine GuestPoints tilbage.",
  pre_approval_modal_expiration_description: jf,
  reasons_for_cancellation_double_booking_rental: Vf,
  reasons_for_cancellation_family_issues: Zf,
  reasons_for_cancellation_health_issues: Uf,
  reasons_for_cancellation_home_damage: Mf,
  reasons_for_cancellation_moving: Bf,
  reasons_for_cancellation_needed: Hf,
  reasons_for_cancellation_other: Wf,
  reasons_for_cancellation_transportation_issues: Kf,
  reasons_for_cancellation_trust_issues: qf,
  reasons_for_cancellation_work_related: Gf,
  reasons_other_comment_needed: Yf
}, Qf = "Studio", Xf = "{{count}} schlafzimmer", ep = "{{count}} schlafzimmer", tp = "", np = "{{count}} Bett", rp = "{{count}} Betten", op = "", sp = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: Qf,
  bedroomsNumbers_one: Xf,
  bedroomsNumbers_other: ep,
  beds_zero: tp,
  beds_one: np,
  beds_other: rp,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: op
}, ap = "Nachdem Sie diesen Haustausch vorläufig bestätigt haben, muss Ihr Tauschpartner ihn finalisieren. Dazu hat Ihr Partner {nbDays} Tage Zeit (bis {date}). Nach Ablauf dieser Frist erlischt Ihre Vorabbestätigung und Sie müssen den Haustausch erneut vorläufig bestätigen.", ip = "Doppelbuchung (über eine andere Plattform)", lp = "Familiäre Gründe", cp = "Gesundheitliche Probleme", up = "Schäden an der Unterkunft", dp = "Umzug", fp = "Sie müssten bitte die Gründe für Ihre Annullierung angeben.", pp = "Andere", _p = "Probleme bei der An-/Abreise", hp = "Vertrauensprobleme", gp = "Arbeitsbedingte Gründe", mp = "Sie müssen einen Grund angeben", bp = {
  "cancellation-page.cancel-exchange": "Den Tausch stornieren",
  "cancellation-page.continue-cancellation": "Stornierung fortsetzen",
  "cancellation-page.keep-exchange": "Meinen Haustausch beibehalten",
  "cancellation-page.reason_step.checboxes_label": "Wählen Sie den Hauptgrund für Ihre Stornierung aus:",
  "cancellation-page.reason_step.comment_placeholder": "Bitte geben Sie hier den Grund für Ihre Stornierung an",
  "cancellation-page.reason_step.error": "Sie müssen einen Grund angeben",
  "cancellation-page.reason_step.title": "Warum müssen Sie stornieren?",
  "cancellation-page.warning-step.first-warning": "Beachten Sie, dass die Stornierung Ihres Haustauschs negative Auswirkungen auf Ihre Tauschpartner haben könnte, die möglicherweise bereits Reisepläne gemacht haben!",
  "cancellation-page.warning-step.second-warning": "Wichtig: Zu viele ungerechtfertigte Stornierungen können dazu führen, dass Ihr Konto als Gastgeber*in offline gestellt wird. Als Gast*in können Ihnen möglicherweise nicht alle Ihre GuestPoints zurückerstattet werden.",
  pre_approval_modal_expiration_description: ap,
  reasons_for_cancellation_double_booking_rental: ip,
  reasons_for_cancellation_family_issues: lp,
  reasons_for_cancellation_health_issues: cp,
  reasons_for_cancellation_home_damage: up,
  reasons_for_cancellation_moving: dp,
  reasons_for_cancellation_needed: fp,
  reasons_for_cancellation_other: pp,
  reasons_for_cancellation_transportation_issues: _p,
  reasons_for_cancellation_trust_issues: hp,
  reasons_for_cancellation_work_related: gp,
  reasons_other_comment_needed: mp
}, vp = "Studio", yp = "{{count}} bedroom", wp = "{{count}} bedrooms", kp = "", $p = "{{count}} bed", xp = "{{count}} beds", zp = "No result", Sp = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: vp,
  bedroomsNumbers_one: yp,
  bedroomsNumbers_other: wp,
  beds_zero: kp,
  beds_one: $p,
  beds_other: xp,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: zp
}, Np = "After you pre-approve this exchange, your exchange partner will need to finalize it. They have {nbDays} days to finalize the exchange (until {date}). Otherwise, your pre-approval will expire and you will have to preapprove the exchange again.", Ep = "Double booking (via another platform)", Cp = "Family issue", Op = "Health issue", Rp = "Home damage", Ap = "Moving home", Pp = "You need to indicate the reasons for your cancellation.", Tp = "Other", Ip = "Transport issue", Dp = "Trust issue", Lp = "Work related", Fp = "You need to enter a reason", jp = {
  "cancellation-page.cancel-exchange": "Cancel the exchange",
  "cancellation-page.continue-cancellation": "Continue cancellation",
  "cancellation-page.keep-exchange": "Keep my exchange",
  "cancellation-page.reason_step.checboxes_label": "Select the main reason for your cancellation:",
  "cancellation-page.reason_step.comment_placeholder": "Write the reason for your cancellation here",
  "cancellation-page.reason_step.error": "You need to enter a reason",
  "cancellation-page.reason_step.title": "Why do you need to cancel?",
  "cancellation-page.warning-step.first-warning": "Remember that cancelling your exchange could impact negatively on your exchange partner, who might already have made plans!",
  "cancellation-page.warning-step.second-warning": "Important: In case of excessive unjustified cancellations as a host, your account may be taken offline. And as a guest, you may not have all your GuestPoints returned to you.",
  pre_approval_modal_expiration_description: Np,
  reasons_for_cancellation_double_booking_rental: Ep,
  reasons_for_cancellation_family_issues: Cp,
  reasons_for_cancellation_health_issues: Op,
  reasons_for_cancellation_home_damage: Rp,
  reasons_for_cancellation_moving: Ap,
  reasons_for_cancellation_needed: Pp,
  reasons_for_cancellation_other: Tp,
  reasons_for_cancellation_transportation_issues: Ip,
  reasons_for_cancellation_trust_issues: Dp,
  reasons_for_cancellation_work_related: Lp,
  reasons_other_comment_needed: Fp
}, Vp = "Estudio", Zp = "{{count}} dormitorio", Up = "{{count}} dormitorios", Mp = "", Bp = "{{count}} cama", Hp = "{{count}} camas", Wp = "", Kp = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: Vp,
  bedroomsNumbers_one: Zp,
  bedroomsNumbers_other: Up,
  beds_zero: Mp,
  beds_one: Bp,
  beds_other: Hp,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: Wp
}, qp = "Después de preaprobar este intercambio, tus compañeros de intercambio tendrán que registrarlo. Tienes {nbDays} días para registrar el intercambio (hasta el {date}). De lo contrario, la preaprobación caducará y tendrás que volver a preaprobar el intercambio.", Gp = "Reserva doble (otra plataforma)", Yp = "Asuntos familiares", Jp = "Temas de salud", Qp = "Daños en la casa", Xp = "Mudanza", e_ = "Por favor, indica las razones de la cancelación", t_ = "Otro", n_ = "Problemas con el transporte", r_ = "Temas de confianza", o_ = "Asuntos laborales", s_ = "Debes introducir un motivo", a_ = {
  "cancellation-page.cancel-exchange": "Cancelar el intercambio",
  "cancellation-page.continue-cancellation": "Continuar con la cancelación",
  "cancellation-page.keep-exchange": "Mantener el intercambio",
  "cancellation-page.reason_step.checboxes_label": "Selecciona el motivo principal de la cancelación:",
  "cancellation-page.reason_step.comment_placeholder": "",
  "cancellation-page.reason_step.error": "Debes introducir un motivo",
  "cancellation-page.reason_step.title": "¿Por qué quieres cancelar el intercambio?",
  "cancellation-page.warning-step.first-warning": "No olvides que cancelar el intercambio puede afectar a tus compañeros de intercambio, que seguramente han hecho planes.",
  "cancellation-page.warning-step.second-warning": "Importante: un exceso de cancelaciones injustificadas por parte de los anfitriones puede resultar en la desactivación de su cuenta y, por parte de los invitados, puede implicar que no se recuperen todos los GuestPoints.",
  pre_approval_modal_expiration_description: qp,
  reasons_for_cancellation_double_booking_rental: Gp,
  reasons_for_cancellation_family_issues: Yp,
  reasons_for_cancellation_health_issues: Jp,
  reasons_for_cancellation_home_damage: Qp,
  reasons_for_cancellation_moving: Xp,
  reasons_for_cancellation_needed: e_,
  reasons_for_cancellation_other: t_,
  reasons_for_cancellation_transportation_issues: n_,
  reasons_for_cancellation_trust_issues: r_,
  reasons_for_cancellation_work_related: o_,
  reasons_other_comment_needed: s_
}, i_ = "Studio", l_ = "{{count}} chambre", c_ = "{{count}} chambres", u_ = "", d_ = "{{count}} lit", f_ = "{{count}} lits", p_ = "", __ = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: i_,
  bedroomsNumbers_one: l_,
  bedroomsNumbers_other: c_,
  beds_zero: u_,
  beds_one: d_,
  beds_other: f_,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: p_
}, h_ = "Après cette pré-approbation, votre partenaire d'échange disposera de {nbDays} jour(s) pour finaliser (jusqu'au {date}). Sinon, votre pré-approbation expirera et vous devrez pré-approuver l'échange de nouveau.", g_ = "Double réservation (via une autre plateforme)", m_ = "Imprévu familial", b_ = "Problème de santé", v_ = "Dégâts à mon domicile", y_ = "Déménagement", w_ = "Vous devez indiquer les raisons de votre annulation.", k_ = "Autre", $_ = "Problème de transport", x_ = "Problème de confiance", z_ = "Imprévu professionnel", S_ = "Vous devez saisir un motif", N_ = {
  "cancellation-page.cancel-exchange": "Annuler l'échange",
  "cancellation-page.continue-cancellation": "Poursuivre l'annulation",
  "cancellation-page.keep-exchange": "Conserver mon échange",
  "cancellation-page.reason_step.checboxes_label": "Sélectionnez la raison principale de votre annulation :",
  "cancellation-page.reason_step.comment_placeholder": "Indiquez la raison de votre annulation juste ici",
  "cancellation-page.reason_step.error": "Vous devez saisir un motif",
  "cancellation-page.reason_step.title": "Pourquoi devez-vous annuler ?",
  "cancellation-page.warning-step.first-warning": "N'oubliez pas que l'annulation de votre échange peut avoir un impact négatif sur votre partenaire d'échange, qui a peut-être déjà planifié son voyage !",
  "cancellation-page.warning-step.second-warning": "Important : Face à un nombre excessif d'annulations injustifiées en tant qu'hôte, votre compte pourrait être mis hors ligne et, en tant qu'invité-e, vous pourriez ne pas récupérer l'intégralité de vos GuestPoints.",
  pre_approval_modal_expiration_description: h_,
  reasons_for_cancellation_double_booking_rental: g_,
  reasons_for_cancellation_family_issues: m_,
  reasons_for_cancellation_health_issues: b_,
  reasons_for_cancellation_home_damage: v_,
  reasons_for_cancellation_moving: y_,
  reasons_for_cancellation_needed: w_,
  reasons_for_cancellation_other: k_,
  reasons_for_cancellation_transportation_issues: $_,
  reasons_for_cancellation_trust_issues: x_,
  reasons_for_cancellation_work_related: z_,
  reasons_other_comment_needed: S_
}, E_ = "Studio", C_ = "{{count}} soba", O_ = "{{count}} sobe", R_ = "{{count}} sobe", A_ = "", P_ = "{{count}} krevet", T_ = "{{count}} kreveti", I_ = "{{count}} kreveti", D_ = "", L_ = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: E_,
  bedroomsNumbers_one: C_,
  bedroomsNumbers_few: O_,
  bedroomsNumbers_other: R_,
  beds_zero: A_,
  beds_one: P_,
  beds_few: T_,
  beds_other: I_,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: D_
}, F_ = "Nakon što unaprijed odobrite ovu zamjenu, Vaš partner za zamjenu ju mora finalizirati. Za to ima {nbDays} dana (do {date}). Ako ne, Vaše će prethodno odobrenje isteći i trebat ćete ponovno prethodno odobriti zamjenu.", j_ = "Dvostruka rezervacija (druga platforma)", V_ = "Obiteljski problemi", Z_ = "Zdravstveni problemi", U_ = "Oštećenje doma", M_ = "Preseljenje", B_ = "Morate navesti razloge otkazivanja", H_ = "Ostalo", W_ = "Problemi s prijevozom", K_ = "Nepovjerenje", q_ = "Poslovni problemi", G_ = "Trebate unijeti razlog", Y_ = {
  "cancellation-page.cancel-exchange": "Otkažite zamjenu",
  "cancellation-page.continue-cancellation": "Nastavite s otkazivanjem",
  "cancellation-page.keep-exchange": "Zadržite svoju zamjenu",
  "cancellation-page.reason_step.checboxes_label": "Odaberite glavni razlog zašto otkazujete:",
  "cancellation-page.reason_step.comment_placeholder": "Ovdje unesite razlog otkazivanja zamjene",
  "cancellation-page.reason_step.error": "Trebate unijeti razlog",
  "cancellation-page.reason_step.title": "Zašto trebate otkazati?",
  "cancellation-page.warning-step.first-warning": "Vodite računa o tome da otkazivanje zamjene može negativno utjecati na Vašeg partnera za zamjenu koji je već možda napravio planove za putovanje!",
  "cancellation-page.warning-step.second-warning": "Važno: U slučaju pretjeranih neopradanih otkazivanja u svojstvu domaćina, Vaš dom može biti uklonjen s interneta. A kao gost, možda nećete dobiti natrag svoje GuestPoints.",
  pre_approval_modal_expiration_description: F_,
  reasons_for_cancellation_double_booking_rental: j_,
  reasons_for_cancellation_family_issues: V_,
  reasons_for_cancellation_health_issues: Z_,
  reasons_for_cancellation_home_damage: U_,
  reasons_for_cancellation_moving: M_,
  reasons_for_cancellation_needed: B_,
  reasons_for_cancellation_other: H_,
  reasons_for_cancellation_transportation_issues: W_,
  reasons_for_cancellation_trust_issues: K_,
  reasons_for_cancellation_work_related: q_,
  reasons_other_comment_needed: G_
}, J_ = "Monolocale", Q_ = "{{count}} camera da letto", X_ = "{{count}} camere da letto", eh = "", th = "{{count}} letto", nh = "{{count}} letti", rh = "", oh = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: J_,
  bedroomsNumbers_one: Q_,
  bedroomsNumbers_other: X_,
  beds_zero: eh,
  beds_one: th,
  beds_other: nh,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: rh
}, sh = "Dopo aver pre-approvato questo scambio, il tuo partner di scambio dovrà finalizzarlo. Avrà tempo {nbDays} giorni per finalizzare lo scambio (fino al giorno {date}). In caso contrario, la tua pre-approvazione scadrà e dovrai pre-approvare lo scambio nuovamente.", ah = "Doppia prenotazione (con un'altra piattaforma)", ih = "Ragioni familiari", lh = "Motivi di salute", ch = "Danni alla proprietà", uh = "Trasferimento", dh = "È necessario indicare i motivi per la cancellazione.", fh = "Altro", ph = "Problemi di trasporto", _h = "Problemi di fiducia", hh = "Motivi legati al lavoro", gh = "È necessario inserire un motivo", mh = {
  "cancellation-page.cancel-exchange": "Annulla lo scambio",
  "cancellation-page.continue-cancellation": "Continua con la cancellazione",
  "cancellation-page.keep-exchange": "Mantieni il mio scambio",
  "cancellation-page.reason_step.checboxes_label": "Seleziona il motivo principale della tua cancellazione:",
  "cancellation-page.reason_step.comment_placeholder": "Inserisci qui la ragione della cancellazione",
  "cancellation-page.reason_step.error": "È necessario inserire un motivo",
  "cancellation-page.reason_step.title": "Perché devi annullare?",
  "cancellation-page.warning-step.first-warning": "Ricorda che annullare il tuo scambio può avere un impatto negativo sul tuo partner di scambio, che potrebbe già aver pianificato il viaggio!",
  "cancellation-page.warning-step.second-warning": "Importante: In caso di eccessive cancellazioni ingiustificate in qualità di host, il tuo account potrebbe essere disattivato. E come ospite, potresti non recuperare tutti i tuoi GuestPoints.",
  pre_approval_modal_expiration_description: sh,
  reasons_for_cancellation_double_booking_rental: ah,
  reasons_for_cancellation_family_issues: ih,
  reasons_for_cancellation_health_issues: lh,
  reasons_for_cancellation_home_damage: ch,
  reasons_for_cancellation_moving: uh,
  reasons_for_cancellation_needed: dh,
  reasons_for_cancellation_other: fh,
  reasons_for_cancellation_transportation_issues: ph,
  reasons_for_cancellation_trust_issues: _h,
  reasons_for_cancellation_work_related: hh,
  reasons_other_comment_needed: gh
}, bh = "Studio", vh = "{{count}} soverom", yh = "{{count}} soverom", wh = "", kh = "{{count}} seng", $h = "{{count}} senger", xh = "", zh = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: bh,
  bedroomsNumbers_one: vh,
  bedroomsNumbers_other: yh,
  beds_zero: wh,
  beds_one: kh,
  beds_other: $h,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: xh
}, Sh = "Etter at du har forhåndsgodkjent dette boligbyttet må din boligbyttepartner ferdigstille det. De har {nbDays} dager på seg til å ferdigstille boligbyttet (frem til {date}). Om ikke vil forhåndsgodkjenningen din utløpe, og du må forhåndsgodkjenne boligbyttet på nytt.", Nh = "Dobbelbooking (via en annen plattform)", Eh = "Famileproblemer", Ch = "Helseproblemer", Oh = "Skade på boligen", Rh = "Flytting", Ah = "Du må angi årsakene til avbestillingen.", Ph = "Annet", Th = "Transportproblemer", Ih = "Tillitsbrudd", Dh = "Arbeidsrelatert", Lh = "Du må oppgi en grunn", Fh = {
  "cancellation-page.cancel-exchange": "Kanseller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsett kansellering",
  "cancellation-page.keep-exchange": "Behold boligbyttet",
  "cancellation-page.reason_step.checboxes_label": "Velg hovedårsaken for din kansellering:",
  "cancellation-page.reason_step.comment_placeholder": "Oppgi årsaken for din kansellering her",
  "cancellation-page.reason_step.error": "Du må oppgi en grunn",
  "cancellation-page.reason_step.title": "Hvorfor ønsker du å kansellere?",
  "cancellation-page.warning-step.first-warning": "Husk at det å kansellere boligbyttet kan ha en negativ innvirkning på din boligbyttepartner, som kanskje allerede har lagt reiseplaner!",
  "cancellation-page.warning-step.second-warning": "Viktig: Dersom du kansellerer et boligbytte som vert uten gyldig grunn kan din konto bli sperret. Som gjest kan konsekvensen være at du ikke får refundert alle dine GuestPoints.",
  pre_approval_modal_expiration_description: Sh,
  reasons_for_cancellation_double_booking_rental: Nh,
  reasons_for_cancellation_family_issues: Eh,
  reasons_for_cancellation_health_issues: Ch,
  reasons_for_cancellation_home_damage: Oh,
  reasons_for_cancellation_moving: Rh,
  reasons_for_cancellation_needed: Ah,
  reasons_for_cancellation_other: Ph,
  reasons_for_cancellation_transportation_issues: Th,
  reasons_for_cancellation_trust_issues: Ih,
  reasons_for_cancellation_work_related: Dh,
  reasons_other_comment_needed: Lh
}, jh = "Studio", Vh = "{{count}} slaapkamer", Zh = "{{count}} slaapkamers", Uh = "", Mh = "{{count}} bed", Bh = "{{count}} bedden", Hh = "Geen resultaat", Wh = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: jh,
  bedroomsNumbers_one: Vh,
  bedroomsNumbers_other: Zh,
  beds_zero: Uh,
  beds_one: Mh,
  beds_other: Bh,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: Hh
}, Kh = "Nadat je de uitwisseling hebt goedgekeurd, moet je uitwisselingspartner deze bevestigen. Hij of zij heeft {nbDays} dagen de tijd om dit te doen (tot {date}). Anders vervalt je voorlopige goedkeuring en moet je de uitwisseling opnieuw goedkeuren.", qh = "Dubbele boeking (via een ander platform)", Gh = "Familiale redenen", Yh = "Gezondheidsproblemen", Jh = "Schade aan het huis", Qh = "Verhuis", Xh = "U dient aan te geven in de redenen voor uw annulering.", eg = "Andere", tg = "Problemen met het transport", ng = "Vertrouwenskwestie", rg = "Werkgerelateerde redenen", og = "Je moet een reden opgeven", sg = {
  "cancellation-page.cancel-exchange": "Annuleer de uitwisseling",
  "cancellation-page.continue-cancellation": "Doorgaan met annuleren",
  "cancellation-page.keep-exchange": "Mijn uitwisseling behouden",
  "cancellation-page.reason_step.checboxes_label": "Selecteer de hoofdreden voor je annulering:",
  "cancellation-page.reason_step.comment_placeholder": "Schrijf hier de reden van de annulering.",
  "cancellation-page.reason_step.error": "Je moet een reden opgeven",
  "cancellation-page.reason_step.title": "Waarom moet je annuleren?",
  "cancellation-page.warning-step.first-warning": "Vergeet niet dat het annuleren van je uitwisseling negatieve gevolgen kan hebben voor je uitwisselingspartner, die misschien al reisplannen heeft gemaakt!",
  "cancellation-page.warning-step.second-warning": "Belangrijk: Als je als gastheer/-vrouw te vaak onterecht annuleert, kan je account offline worden gehaald. En als gast kan het zijn dat je niet al je GuestPoints terugkrijgt.",
  pre_approval_modal_expiration_description: Kh,
  reasons_for_cancellation_double_booking_rental: qh,
  reasons_for_cancellation_family_issues: Gh,
  reasons_for_cancellation_health_issues: Yh,
  reasons_for_cancellation_home_damage: Jh,
  reasons_for_cancellation_moving: Qh,
  reasons_for_cancellation_needed: Xh,
  reasons_for_cancellation_other: eg,
  reasons_for_cancellation_transportation_issues: tg,
  reasons_for_cancellation_trust_issues: ng,
  reasons_for_cancellation_work_related: rg,
  reasons_other_comment_needed: og
}, ag = "Studio", ig = "{{count}} quarto", lg = "{{count}} quartos", cg = "", ug = "{{count}} cama", dg = "{{count}} camas", fg = "", pg = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: ag,
  bedroomsNumbers_one: ig,
  bedroomsNumbers_other: lg,
  beds_zero: cg,
  beds_one: ug,
  beds_other: dg,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: fg
}, _g = "Após pré-aprovar esta troca, o seu parceiro de troca terá de a finalizar e terá {nbDays} dias para o fazer (até {date}). Caso contrário, a sua pré-aprovação irá expirar e terá de voltar a pré-aprovar a troca.", hg = "Reserva dupla (outra plataforma)", gg = "Motivos familiares", mg = "Motivos de saúde", bg = "Danos na propriedade", vg = "Mudanças", yg = "Você precisa indicar os motivos do cancelamento.", wg = "Outro", kg = "Problemas de transporte", $g = "Problemas de confiança", xg = "Motivos laborais", zg = "É obrigatório introduzir um motivo", Sg = {
  "cancellation-page.cancel-exchange": "Cancelar a troca",
  "cancellation-page.continue-cancellation": "Continuar com o cancelamento",
  "cancellation-page.keep-exchange": "Manter a minha troca",
  "cancellation-page.reason_step.checboxes_label": "Selecione o motivo principal para o cancelamento:",
  "cancellation-page.reason_step.comment_placeholder": "Escreva aqui o motivo do cancelamento",
  "cancellation-page.reason_step.error": "É obrigatório introduzir um motivo",
  "cancellation-page.reason_step.title": "Por que motivo precisa de cancelar?",
  "cancellation-page.warning-step.first-warning": "Lembre-se que cancelar a sua troca pode ter um impacto negativo para o seu parceiro de troca, que pode já ter feito planos de viagem!",
  "cancellation-page.warning-step.second-warning": "Importante: Caso tenha demasiados cancelamentos injustificados como anfitrião, a sua conta poderá ser colocada offline. Caso isto aconteça enquanto convidado, poderá não receber todos os seus GuestPoints de volta.",
  pre_approval_modal_expiration_description: _g,
  reasons_for_cancellation_double_booking_rental: hg,
  reasons_for_cancellation_family_issues: gg,
  reasons_for_cancellation_health_issues: mg,
  reasons_for_cancellation_home_damage: bg,
  reasons_for_cancellation_moving: vg,
  reasons_for_cancellation_needed: yg,
  reasons_for_cancellation_other: wg,
  reasons_for_cancellation_transportation_issues: kg,
  reasons_for_cancellation_trust_issues: $g,
  reasons_for_cancellation_work_related: xg,
  reasons_other_comment_needed: zg
}, Ng = "Studio", Eg = "{{count}} sovrum", Cg = "{{count}} sovrum", Og = "", Rg = "{{count}} säng", Ag = "{{count}} sängar", Pg = "", Tg = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: Ng,
  bedroomsNumbers_one: Eg,
  bedroomsNumbers_other: Cg,
  beds_zero: Og,
  beds_one: Rg,
  beds_other: Ag,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: Pg
}, Ig = "Efter att du har förgodkänt det här hembytet behöver din hembytespartner bekräfta det. Hen har {nbDays} dagar på sig att bekräfta det (till {date}). Annars kommer ditt förgodkännande att löpa ut och du behöver förgodkänna hembytet igen.", Dg = "Dubbelbokning (annan plattform)", Lg = "Familjeproblem", Fg = "Hälsoproblem", jg = "Skada i hemmet", Vg = "Flytt", Zg = "Du måste ange orsaken till din avbokning.", Ug = "Övrigt", Mg = "Transportproblem", Bg = "Bristande förtroende", Hg = "Arbetsrelaterat", Wg = "Du behöver ange en anledning", Kg = {
  "cancellation-page.cancel-exchange": "Avboka hembytet",
  "cancellation-page.continue-cancellation": "Fortsätt avbokning",
  "cancellation-page.keep-exchange": "Behåll mitt hembyte",
  "cancellation-page.reason_step.checboxes_label": "Välj huvudanledningen till din avbokning:",
  "cancellation-page.reason_step.comment_placeholder": "Ange anledningen till din avbokning här.",
  "cancellation-page.reason_step.error": "Du behöver ange en anledning",
  "cancellation-page.reason_step.title": "Varför behöver du avboka?",
  "cancellation-page.warning-step.first-warning": "Kom ihåg att ifall du avbokar ditt hembyte kan det ha en negativ inverkan på din hembytespartner, som kanske redan har planerat sin resa!",
  "cancellation-page.warning-step.second-warning": "Viktigt: Vid överdrivna och omotiverade avbokningar som värd kan ditt konto tas offline. Och som gäst kanske inte alla dina GuestPoints återgäldas till dig.",
  pre_approval_modal_expiration_description: Ig,
  reasons_for_cancellation_double_booking_rental: Dg,
  reasons_for_cancellation_family_issues: Lg,
  reasons_for_cancellation_health_issues: Fg,
  reasons_for_cancellation_home_damage: jg,
  reasons_for_cancellation_moving: Vg,
  reasons_for_cancellation_needed: Zg,
  reasons_for_cancellation_other: Ug,
  reasons_for_cancellation_transportation_issues: Mg,
  reasons_for_cancellation_trust_issues: Bg,
  reasons_for_cancellation_work_related: Hg,
  reasons_other_comment_needed: Wg
}, qg = "en", is = Of({
  fallbackLng: qg,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  resources: {
    da: {
      common: Ff,
      conversations: Jf
    },
    de: {
      common: sp,
      conversations: bp
    },
    en: {
      conversations: jp,
      common: Sp
    },
    es: {
      conversations: a_,
      common: Kp
    },
    fr: {
      conversations: N_,
      common: __
    },
    hr: {
      conversations: Y_,
      common: L_
    },
    it: {
      conversations: mh,
      common: oh
    },
    nb: {
      conversations: Fh,
      common: zh
    },
    nl: {
      conversations: sg,
      common: Wh
    },
    pt: {
      conversations: Sg,
      common: pg
    },
    sv: {
      conversations: Kg,
      common: Tg
    }
  }
});
is.init();
const Zr = is, Gg = (e, t) => {
  os("exchange_status", e, t);
}, sm = (e, t) => {
  const n = {
    weekday: "long",
    month: "long",
    day: "numeric"
  };
  return Wr(new Date(e), t).toLocaleDateString(document.body.dataset.locale, n);
}, am = (e, t, n) => {
  const r = Wr(new Date(t), n);
  return new Date(e) > r;
}, dn = "warning_step", ls = "reason_step", Yg = {
  [dn]: sf,
  [ls]: of
};
function Jg({
  cancellationReasons: e,
  conversation: t,
  user: n
}) {
  const [r, o] = Ce(dn), s = Yg[r], { url: a } = $n(`/conversations/${t.id}`);
  return Ke(() => {
    const i = uf({
      isHeCollection: n.is_he_collection,
      subscriptionEndOn: n?.subscription?.end_on
    });
    lf(n.id, i, n.is_he_collection);
  }, [n]), /* @__PURE__ */ y(nl, { color: "primary", isFullHeight: !0, centerContent: !0, children: /* @__PURE__ */ y(Yi, { children: /* @__PURE__ */ y(
    s,
    {
      cancellationReasons: e,
      conversation: t,
      user: n,
      onClickContinue: () => {
        r === dn ? (cf("exchange_cancellation", "exchange_cancellation_reason_selection", {
          collection: n.is_he_collection
        }), window.scrollTo(0, 0), o(ls)) : window.location.assign(a);
      }
    }
  ) }) });
}
function im({ cancellationReasons: e, conversation: t, locale: n, user: r, apiUrl: o }) {
  return Zr.changeLanguage(n), ws(o), /* @__PURE__ */ y(fl, { locale: n, children: /* @__PURE__ */ y(ta, { i18n: Zr, children: /* @__PURE__ */ y(Jg, { cancellationReasons: e, conversation: t, user: r }) }) });
}
const lm = "WITH-GP", cm = "RECIPROCAL", um = "RECIPROCAL-WITH-GP", dm = "NEW", fm = "ACCEPTED", pm = "EXPIRED", _m = "MANUALLY_DECLINED", hm = "AUTOMATICALLY_DECLINED", gm = "PAST_DATES_DECLINE";
export {
  im as CancellationPage,
  of as ReasonStep,
  fm as STAY_REQUEST_STATUS_ACCEPTED,
  hm as STAY_REQUEST_STATUS_AUTOMATICALLY_DECLINED,
  pm as STAY_REQUEST_STATUS_EXPIRED,
  _m as STAY_REQUEST_STATUS_MANUALLY_DECLINED,
  dm as STAY_REQUEST_STATUS_NEW,
  gm as STAY_REQUEST_STATUS_PAST_DATES_DECLINE,
  cm as STAY_TYPE_RECIPROCAL,
  um as STAY_TYPE_RECIPROCAL_WITH_GP,
  lm as STAY_TYPE_WITH_GP,
  om as TransportationBanner,
  sf as WarningStep,
  ys as cancel,
  vm as cancelPreApprobation,
  ym as changeStayRequestToNonReciprocal,
  wm as changeStayRequestToReciprocal,
  km as createStayRequest,
  $m as getCancellationInformations,
  xm as getExchangeConfig,
  sm as getExpirationDate,
  zm as getStayRequest,
  Sm as getV1StayRequest,
  Nm as heFetch,
  Zr as i18nConfig,
  Em as isCancellationPossible,
  am as isStartDateAfterExpirationDate,
  Cm as manualDecline,
  Om as preapproveExchange,
  ws as setConversationsFetchConfig,
  Gg as trackExchangeStatus,
  Rm as updateStayRequestDates
};
